import 'jquery-validation';
import 'country-select-js';
import 'jquery.scrollbar';
import 'bootstrap-slider';

// Viewport height for scroll-visibility checks. Use this instead of
// $(window).height(), which jQuery resolves to document.documentElement
// .clientHeight: the Qualified chat tag (js.qualified.com/docking.js, injected by
// GTM) sets `contain: layout` on <html> for its docked panel, and Firefox then
// reports that as 8px. Every gate of the form
// `elemTop <= scrollTop + $(window).height() - N` becomes unsatisfiable at every
// scroll position, so the feature silently never initialises — Chrome is
// unaffected, which is what makes it look like a Firefox-only bug.
// window.innerHeight is not affected by the containment.
function mriViewportHeight() {
  return Math.max(document.documentElement.clientHeight, window.innerHeight);
}

export default {
  init() {
    // JavaScript to be fired on all pages
    /* ========================================================================
   * DOM-based Routing
   * Based on http://goo.gl/EUTi53 by Paul Irish
   *
   * Only fires on body classes that match. If a body class contains a dash,
   * replace the dash with an underscore when adding it to the object below.
   *
   * .noConflict()
   * The routing is enclosed within an anonymous function so that you can
   * always reference jQuery with $, even when in .noConflict() mode.
   * ======================================================================== */


    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
      // All pages
      'common': {
        init: function() {
          // Must run first: it can write referrer-derived or session-stored lcf_utm_*
          // params onto the current URL (history.replaceState), and misc() / lets_connect_form()
          // read window.location.search to populate the Pardot iframes and forms.
          // Guarded so a hostile or malformed URL can't stop the modules below.
          try {
            this.ga4_utm();
          } catch(err) {
            console.warn(err);
          }
          this.flippingNumbers();
          this.matchHeights();
          this.owlCarousels();
          this.select2();
          this.misc();
          this.geolocation();
          this.mobileNav();
          this.multimediaTabs();
          this.lazyLoad();
          this.stickyKit();
          this.browserCompatibility();
          this.shop();
          this.clients_logos_grid();
          this.roi_calculator();
          this.roi_calculator_2023();
          this.roi_calculator_2023_energy();
          this.roi_calculator_2024_ram();
          this.roi_calculator_2024_mci();
          this.roi_calculator_2024_energy4();
          this.roi_calculator_2025_energy();
          this.lease_pricing_calculator();
          this.rollover_section();
          this.faq_accordion();
          this.lets_connect_form();
          this.insta_slider();
          this.contact_support_filter();
          this.epc_generator_form();
          this.shs_ajax_module();
          this.story_progress_bar();
          this.journey_steps();
          this.engage_suite_slider();
          this.event_countdown();
          this.event_sticky_form();
          this.smart_pricing();
          this.partners_isotope();   
          this.support_numbers_isotope();
          this.animated_image();

          var $w = $(window);
          $.fn.visible = function(partial,hidden,direction,container){

            if (this.length < 1)
              return;

            // Set direction default to 'both'.
            direction = direction || 'both';

            var $t          = this.length > 1 ? this.eq(0) : this,
            isContained = typeof container !== 'undefined' && container !== null,
            $c          = isContained ? $(container) : $w,
            wPosition        = isContained ? $c.position() : 0,
            t           = $t.get(0),
            vpWidth     = $c.outerWidth(),
            vpHeight    = $c.outerHeight(),
            clientSize  = hidden === true ? t.offsetWidth * t.offsetHeight : true;

            if (typeof t.getBoundingClientRect === 'function'){

                      // Use this native browser method, if available.
              var rec = t.getBoundingClientRect(),
              tViz = isContained ?
              rec.top - wPosition.top >= 0 && rec.top < vpHeight + wPosition.top :
              rec.top >= 0 && rec.top < vpHeight,
              bViz = isContained ?
              rec.bottom - wPosition.top > 0 && rec.bottom <= vpHeight + wPosition.top :
              rec.bottom > 0 && rec.bottom <= vpHeight,
              lViz = isContained ?
              rec.left - wPosition.left >= 0 && rec.left < vpWidth + wPosition.left :
              rec.left >= 0 && rec.left <  vpWidth,
              rViz = isContained ?
              rec.right - wPosition.left > 0  && rec.right < vpWidth + wPosition.left  :
              rec.right > 0 && rec.right <= vpWidth,
              vVisible   = partial ? tViz || bViz : tViz && bViz,
              hVisible   = partial ? lViz || rViz : lViz && rViz,
              vVisible = (rec.top < 0 && rec.bottom > vpHeight) ? true : vVisible,
              hVisible = (rec.left < 0 && rec.right > vpWidth) ? true : hVisible;

              if(direction === 'both')
                return clientSize && vVisible && hVisible;
              else if(direction === 'vertical')
                return clientSize && vVisible;
              else if(direction === 'horizontal')
                return clientSize && hVisible;
            } else {

              var viewTop         = isContained ? 0 : wPosition,
              viewBottom      = viewTop + vpHeight,
              viewLeft        = $c.scrollLeft(),
              viewRight       = viewLeft + vpWidth,
              position          = $t.position(),
              _top            = position.top,
              _bottom         = _top + $t.height(),
              _left           = position.left,
              _right          = _left + $t.width(),
              compareTop      = partial === true ? _bottom : _top,
              compareBottom   = partial === true ? _top : _bottom,
              compareLeft     = partial === true ? _right : _left,
              compareRight    = partial === true ? _left : _right;

              if(direction === 'both')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
              else if(direction === 'vertical')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
              else if(direction === 'horizontal')
                return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            }
          };

          var cipher = function cipher(salt) {
            var textToChars = function textToChars(text) {
              return text.split('').map(function (c) {
                return c.charCodeAt(0);
              });
            };
            var byteHex = function byteHex(n) {
              return ("0" + Number(n).toString(16)).substr(-2);
            };
            var applySaltToChar = function applySaltToChar(code) {
              return textToChars(salt).reduce(function (a, b) {
                return a ^ b;
              }, code);
            };
            return function (text) {
              return text.split('').map(textToChars).map(applySaltToChar).map(byteHex).join('');
            };
          };

          var decipher = function decipher(salt) {
            var textToChars = function textToChars(text) {
              return text.split('').map(function (c) {
                return c.charCodeAt(0);
              });
            };
            var applySaltToChar = function applySaltToChar(code) {
              return textToChars(salt).reduce(function (a, b) {
                return a ^ b;
              }, code);
            };
            return function (encoded) {
              return encoded.match(/.{1,2}/g).map(function (hex) {
                return parseInt(hex, 16);
              }).map(applySaltToChar).map(function (charCode) {
                return String.fromCharCode(charCode);
              }).join('');
            };
          };

          $(document).find('.mri-logo-slider').each(function () {
            var swiper = $(this).find('.swiper');
            if (swiper.length > 0) {
              var logoSwiper = new Swiper(swiper[0], {
                spaceBetween: 10,
                speed: 5000,
                direction: 'horizontal',
                autoplay: {delay: 0},
                loop: true,
                slidesPerView: 3,
                freeMode: true,
                allowTouchMove: false,
                touchRatio: 0,
                breakpoints: {   
                  768: {
                    slidesPerView: 5,
                  },
                  1024: {
                    slidesPerView: 6,
                    spaceBetween: 0,
                  },
                  1400: {
                    slidesPerView: 9,
                    spaceBetween: 0,
                  },
                },
              });
            }
          });

          // .mri-text-icon-slider is a pure CSS conveyor - see
          // _text-icon-slider.scss. Swiper's autoplay-as-marquee re-armed only
          // on transitionend and stopped for good whenever that event was
          // cancelled, so there is deliberately no JS here.

          $(document).find('.mri-quote-slider').each(function () {
            var swiper = $(this).find('.swiper');
            if (swiper.length > 0) {
              var quoteSwiper = new Swiper(swiper[0], {
                spaceBetween: 30,
                direction: 'horizontal',
                loop: false,
                slidesPerView: 1,
                //watchOverflow: true,
                breakpoints: {
                  640: {
                    slidesPerView: 1,
                  },    
                  768: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                //modules: [Navigation],
              });
            }
          });

          // Hero sticky navigation - "slider" layout
          $(document).find('.mri-hero-nav-slider').each(function () {
            var $wrap     = $(this);
            var container = $wrap.find('.swiper-container');
            var $next     = $wrap.find('.hns-nav-next');

            if (container.length > 0) {
              // Counted before init: loop mode clones slides, so from here on
              // navSwiper.slides includes the duplicates and cannot be trusted
              // as the real item count.
              var slideCount = container.find('.hns-slide').length;

              var navSwiper = new Swiper(container[0], {
                direction: 'horizontal',
                // Infinite: past the last item the arrow rotates straight back
                // into the first. Swiper's own slideNext() is loop-aware and
                // steps exactly one item across the wrap - the previous
                // hand-rolled isEnd/slideTo(0) rewind read the clone indices
                // and resumed two items late, which is the "jumps several
                // items ahead after ~10 clicks" the nav used to show.
                loop: true,
                spaceBetween: 0,
                slidesPerView: 2,
                slideToClickedSlide: false,
                // Stepped so a slide never drops below ~165px and titles stay on
                // one or two lines. 768/992/1250 match the theme's own container
                // breakpoints ($screen-sm/md/lg) so the count changes with the
                // container width, not ahead of it.
                breakpoints: {
                  576: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  992: {
                    slidesPerView: 5,
                  },
                  1250: {
                    slidesPerView: 6,
                  },
                  1400: {
                    slidesPerView: 8,
                  },
                },
              });

              // watchOverflow cannot be used here: loop mode always has the
              // clones on either side, so Swiper never sees "everything fits"
              // and never locks. Decide it from the real item count instead,
              // and re-check whenever a breakpoint changes slidesPerView.
              function navFits() {
                return slideCount <= navSwiper.params.slidesPerView;
              }

              function syncNavLock() {
                $next.toggleClass('swiper-button-lock', navFits());
              }

              navSwiper.on('breakpoint', syncNavLock);
              syncNavLock();

              // Forward-only: one item per click, wrapping past the last.
              $next.on('click', function (e) {
                e.preventDefault();
                if (navFits()) { return; }
                navSwiper.slideNext();
              });
            }
          });

          // Hero slider nav - pin under the site header on scroll, titles only.
          // Opt-in per page via the "Pin on scroll" hero field; off by default,
          // in which case the nav simply scrolls away with the hero.
          $(document).find('.mri-hero-nav-slider.hns-pinnable').each(function () {
            var $wrap      = $(this);
            var $card      = $wrap.find('.hns-card');
            var $container = $wrap.find('.swiper-container');
            var $header    = $('#main-header');
            var stuck      = false;
            var queued     = false;
            var resizeQueued = false;
            var natural    = { top: 0, left: 0, width: 0, height: 0 };

            var raf = window.requestAnimationFrame || function (cb) { return window.setTimeout(cb, 16); };

            function headerHeight() {
              return $header.length ? Math.round($header.outerHeight()) : 0;
            }

            // While pinned the card is fixed at an explicit width, so Swiper sizes
            // its slides against a stale container until the card is corrected.
            function syncSwiper() {
              var instance = $container.length ? $container[0].swiper : null;
              if (instance) { instance.update(); }
            }

            function apply(isStuck) {
              stuck = isStuck;
              if (isStuck) {
                // Placeholder keeps the flow height so the page does not jump.
                $wrap.css('height', natural.height).addClass('hns-stuck');
                $card.css({ top: headerHeight(), left: natural.left, width: natural.width });
              } else {
                $wrap.removeClass('hns-stuck').css('height', '');
                $card.css({ top: '', left: '', width: '' });
              }
            }

            function onScroll() {
              var headerH = headerHeight();
              var shouldStick = ($(window).scrollTop() + headerH) > natural.top;

              if (shouldStick !== stuck) {
                apply(shouldStick);
                // The header resizes when it affixes, which can land after the
                // last scroll event - re-check once it has settled.
                window.setTimeout(onScroll, 400);
              }

              if (stuck && parseInt($card.css('top'), 10) !== headerH) {
                $card.css('top', headerH);
              }
            }

            // Measure in the natural (unpinned) state, then re-evaluate.
            function refresh() {
              if (stuck) { apply(false); }
              var rect = $wrap[0].getBoundingClientRect();
              natural = {
                top: rect.top + $(window).scrollTop(),
                left: Math.round(rect.left),
                width: Math.round(rect.width),
                height: Math.round($card.outerHeight()),
              };
              onScroll();
            }

            $(window).on('scroll', function () {
              if (queued) { return; }
              queued = true;
              raf(function () { queued = false; onScroll(); });
            });

            // Keep the pinned card on the viewport while it is being resized. The
            // placeholder stays in the flow, so its rect is already the new
            // geometry - no need to unpin to read it.
            function trackGeometry() {
              var rect = $wrap[0].getBoundingClientRect();
              natural.top   = rect.top + $(window).scrollTop();
              natural.left  = Math.round(rect.left);
              natural.width = Math.round(rect.width);

              if (!stuck) { return; }

              $card.css({ left: natural.left, width: natural.width });
              // The header changes height across breakpoints too, so re-sync the
              // offset (and unpin if the slider's own position moved past us).
              onScroll();
              syncSwiper();
            }

            var resizeTimer;
            $(window).on('resize', function () {
              if (!resizeQueued) {
                resizeQueued = true;
                raf(function () { resizeQueued = false; trackGeometry(); });
              }

              // Once resizing stops, re-measure the natural height too - a
              // breakpoint change rewraps the titles and alters the card height.
              window.clearTimeout(resizeTimer);
              resizeTimer = window.setTimeout(function () {
                refresh();
                syncSwiper();
              }, 150);
            });

            // The header animates its height on affix - follow it when it settles.
            $header.on('transitionend', function () {
              if (stuck) { onScroll(); }
            });

            $(window).on('load', refresh);
            refresh();
          });

          // Anchor links inside the hero slider nav scroll instead of jumping
          $(document).on('click', '.mri-hero-nav-slider .hns-slide', function (e) {
            var href_id = $(this).attr('href');
            try {
              if (href_id.indexOf('#') === 0 && $(href_id).length > 0) {
                e.preventDefault();
                // Clear the header, plus the nav itself only when it pins and so
                // stays over the target. Unpinned it scrolls away with the hero.
                var $nav = $(this).closest('.mri-hero-nav-slider');
                var offset_nav = $('#main-header').outerHeight()
                  + ($nav.hasClass('hns-pinnable') ? $nav.find('.hns-card').outerHeight() : 0);
                $('body,html').animate({
                  scrollTop: $(href_id).offset().top - offset_nav - 20,
                }, 300);
              }
            } catch (err) {
              console.warn(err);
            }
          });

          $(document).on('input', '#lcf_email',function(e){
            $('#mic-verify').slideDown(300);
            var email_encryp = cipher('mri_pfgc_');
            sessionStorage.setItem("mri_pfgc_", email_encryp( $(this).val() ) );
          });

          if ( window.location.pathname.includes("thank-you") || $('body').hasClass('thank-you') ) {          
            if ( sessionStorage.getItem( "mri_pfgc_" ) ) {
              var email_decrypt = decipher('mri_pfgc_');
              var email_decrypted =  email_decrypt( sessionStorage.getItem( "mri_pfgc_" ) );
              if ( 'function' === typeof gtag && email_decrypted ) {
                // gtag('set', 'user_data', {
                //   "email": email_decrypted 
                // });
              }
            }
          }

          function mri_int_get_random_int(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
          }

          function mri_build_captcha( verify_wrap ) {
            verify_wrap.empty();
            var verify_html = '';
            var enc_num     = mri_int_get_random_int(1,9999);
            var key_num     = mri_int_get_random_int(1,24);
            var home_url    = verify_wrap.attr('data-hu');
            var theme_url   = verify_wrap.attr('data-td');

            verify_html += '<div class="mic-verify-w mic-left">';
            verify_html += '<input type="hidden" name="enc_num" value="'+enc_num+'">';
            verify_html += '<input type="hidden" name="key_num" value="'+key_num+'">';
            verify_html += '<a class="refresh" id="verify-refresh-captcha" href=""><img src="'+theme_url+'/dist/images/mic-refresh.png" alt="Refresh"></a>';
            verify_html += '<img id="verify_image" src="' + home_url + 'wp-json/mic/v1/cpid?enn=' + enc_num + '&ken=' + key_num + '" alt="Verification code" width="100" />';
            verify_html += '</div>';
            verify_html += '<div class="mic-verify-w mic-right">'
            // Keep phone keyboards and autofill from altering the typed code.
            verify_html += '<input type="text" name="mic_verify" id="mic_verify" class="text" autocapitalize="off" autocorrect="off" autocomplete="off" spellcheck="false" placeholder="Enter the captcha" title="This confirms you are a human user and not a bot."/>';
            verify_html += '</div>';
            verify_wrap.html(verify_html);
          }

          // A captcha that starts hidden is built on the first interaction with its
          // form. Building it on page load requested an uncached captcha image on
          // every page with a form, for a field most visitors never reach.
          jQuery('#mic-verify').each( function() {
            if ( this.style.display !== 'none' ) {
              mri_build_captcha( jQuery(this) );
            }
          });

          jQuery(document).on('focusin input change', 'form', function(){
            var verify_wrap = jQuery(this).find('#mic-verify');
            if ( verify_wrap.length && ! verify_wrap.children().length ) {
              mri_build_captcha( verify_wrap );
            }
          });

          jQuery(document).on('click','#verify-refresh-captcha', function(e){
            e.preventDefault();
            mri_build_captcha( jQuery(this).closest('#mic-verify') );
          });

          var itw_repeat = '';
          var aos_check = '';
          function iw_begin_animation( section ) {
            clearInterval(aos_check);
            var li_count  = section.find('.circle-menu-nav').find('li').length;
            var interval  = 250 * li_count + 2500;
            console.warn(interval);
            var iterate   = 0;
            var animating = false
            itw_repeat = setInterval(function() {
              if ( section.find('.circle-menu-nav').hasClass('aos-animate-repeat') ) {
                section.find('.circle-menu-nav').removeClass('aos-animate-repeat');  
              } else {
                section.find('.circle-menu-nav').addClass('aos-animate-repeat'); 
              }
            }, interval);
          }

          $(document).find('.article-inline-resource-card').each(function(){
            $(this).closest('section').addClass('has-popup-banner');
            $('body').addClass('body-has-popup-banner');
            console.log('haspopup');
          });

          jQuery(document).find('.section.interactive-wheel').each(function() {
            var section = jQuery(this);
            aos_check = setInterval(function() {
              if ( section.find('.circle-menu-nav.aos-animate').length > 0 ) {
                iw_begin_animation(section);
              }
            }, 1500);
          });

          jQuery(document).on('mouseenter', '.interactive-wheel .circle-menu-nav', function(){
            clearInterval( itw_repeat );
          });

          $(document).on('click','.btn.new-mri-btn', function(e){
            var id = $(this).attr('href');
            if ( id && id.indexOf("#") >= 0 && $(id).length > 0 ) {
              e.preventDefault();
              $('body,html').animate({
                  scrollTop: $(id).offset().top - 100
              }, 300);
            }

          });

   

          $(document).on('click', '.article-inline-resource-card .air-close, .air-close-layer',function() {
            $('.article-inline-resource-card').addClass('air-hidden');
          });

          $(document).find('video.wp-video-shortcode').each(function(){
            var video = $(this);
            var player = new Plyr( video[0], {
              controls: [],
              muted: true,
              clickToPlay: false,
              hideControls: true,
              autoplay: true,
              toggleInvert: false,
              fullscreen: { enabled: false, fallback: false, iosNative: false, container: null },
            });
            player.play();
          });

          $(document).find('video.wp-video-controls').each(function(){
            var video = $(this);
            var player = new Plyr( video[0], {
              clickToPlay: true,
              volume: 0.8,
              hideControls: true,
              toggleInvert: false,
              fullscreen: { enabled: true, fallback: false, iosNative: true, container: null },
            });
            player.volume = 0.8;
          });

          

          if ( $(document).find('section.interactive-wheel').length > 0 ) {

            var $carousel = new Flickity( '.iw-big-slider' );
            $carousel.on( 'change', function( index ) {
              var element = jQuery('.iw-big-slider').find('.carousel-cell.is-selected');
              if ( jQuery(element).length > 0 ) {
                var filter = jQuery(element).find('span[data-category]').attr('data-category');
                var tabs_wrapper = jQuery(element).closest('section').find('.iw-flex-tabs-col');

                if ( tabs_wrapper.find('li.iw-open').length > 0 ) {
                  var open_tab = tabs_wrapper.find('li.iw-open');
                  if ( open_tab.attr('data-filter') !== filter ) {
                    open_tab.removeClass('iw-open').find('.iw-tab-content').slideUp(300);
                    element = tabs_wrapper.find('li[data-filter='+filter+']');
                    element.addClass('iw-open').find('.iw-tab-content').slideDown(300);                   
                  }
                } else {
                  element = tabs_wrapper.find('li[data-filter='+filter+']');
                  element.addClass('iw-open').find('.iw-tab-content').slideDown(300);
                }
              }

            });

            $(document).on('click','.interactive-wheel .iw-tab-header .tab-toggler', function(e) {
              e.preventDefault();
              var parent = $(this).closest('li');
              var filter = parent.attr('data-filter');
              var is_open = parent.hasClass('iw-open');
              var accordion = $(this).closest('ul');
              var circle_menu = $(this).closest('section').find('.circle-menu');

              circle_menu.find('.iw-active').removeClass('iw-active');
              circle_menu.find('.iw-active-li').removeClass('iw-active-li');

              accordion.find('li.iw-open').each(function(){
                $(this).removeClass('iw-open');
                $(this).find('.iw-tab-content').slideUp(300);
              });
              if ( ! is_open ) {
                parent.addClass('iw-open').find('.iw-tab-content').slideDown(300);
                circle_menu.find('.circle-menu-middle-content [data-filter]').fadeOut(300);
                circle_menu.find('.circle-menu-middle-content [data-filter='+filter+']').fadeIn(300);
                circle_menu.find('.circle-menu-nav .cmn-toggle').removeClass('iw-focus');
                circle_menu.find('.circle-menu-nav .cmn-toggle:not([data-filter='+filter+'])').addClass('iw-focus');          
              } else {
                circle_menu.find('.circle-menu-middle-content [data-filter]').fadeOut(300);
                circle_menu.find('.circle-menu-middle-content [data-filter="default"]').fadeIn(300);
                circle_menu.find('.circle-menu-nav .cmn-toggle').removeClass('iw-focus');
              }
              circle_menu.find('.cmn-toggle').removeClass('rp-anim');
              if ( circle_menu.find('.iw-focus').length > 0 ) {
                circle_menu.find('.cmn-toggle:not(.iw-focus)').addClass('rp-anim');
              }
            });

            $(document).on('click','.circle-menu-nav .cmn-toggle', function(e){
              e.preventDefault();
              var content = $(this).attr('data-content');
              var filter = $(this).attr('data-filter');
              var circle_menu = $(this).closest('section').find('.circle-menu');
              var tabs_wrapper = $(this).closest('section').find('.iw-flex-tabs-col');

              if ( tabs_wrapper.find('li.iw-open').length > 0 ) {
                var open_tab = tabs_wrapper.find('li.iw-open');
                if ( open_tab.attr('data-filter') !== filter ) {
                  open_tab.removeClass('iw-open').find('.iw-tab-content').slideUp(300);
                  var element = tabs_wrapper.find('li[data-filter='+filter+']');
                  element.addClass('iw-open').find('.iw-tab-content').slideDown(300);
                  circle_menu.find('.circle-menu-nav .cmn-toggle').removeClass('iw-focus');
                  circle_menu.find('.circle-menu-nav .cmn-toggle:not([data-filter='+filter+'])').addClass('iw-focus');   
                }
              } else {
                var element = tabs_wrapper.find('li[data-filter='+filter+']');
                element.addClass('iw-open').find('.iw-tab-content').slideDown(300);
                circle_menu.find('.circle-menu-nav .cmn-toggle').removeClass('iw-focus');
                circle_menu.find('.circle-menu-nav .cmn-toggle:not([data-filter='+filter+'])').addClass('iw-focus');
              }

              var is_open = $(this).hasClass('iw-active');
              $(this).closest('ul').find('iw-active').removeClass('iw-active');
              $(this).closest('ul').find('.iw-active-li').removeClass('iw-active-li');
              if ( is_open ) {
                $(this).closest('ul').find('.cmn-toggle').removeClass('iw-active');
                $(this).closest('ul').find('.iw-active-li').removeClass('iw-active-li');
                

                circle_menu.find('.circle-menu-middle-content [data-filter]').fadeOut(300);
                circle_menu.find('.circle-menu-middle-content [data-filter="default"]').fadeIn(300);
                circle_menu.find('.circle-menu-nav .cmn-toggle').removeClass('iw-focus');
                tabs_wrapper.find('li.iw-open').removeClass('iw-open').find('.iw-tab-content').slideUp(300);
              } else {
                $(this).closest('ul').find('.cmn-toggle').removeClass('iw-active');
                $(this).closest('ul').find('.iw-active-li').removeClass('iw-active-li');

                $(this).addClass('iw-active');

                $(this).closest('.cmn-pulser').addClass('iw-active-li');

                circle_menu.find('.circle-menu-middle-content [data-filter]').fadeOut(300);
                if ( circle_menu.find('.circle-menu-middle-content [data-filter='+content+']').length > 0 ) {
                  circle_menu.find('.circle-menu-middle-content [data-filter='+content+']').fadeIn(300);
                } else {
                  circle_menu.find('.circle-menu-middle-content [data-filter="default"]').fadeIn(300);
                }
              }       

            });
          }

          $(document).find('.pricing-feature-section table').each(function(){
            $(this).rowspanizer({
              vertical_align:'middle',
              columns: [0]
            });
          });


          $(document).on('change','input[name="mpg-switch-ckb-currency"]', function(){
            var value = $(this).val();
            var period = $('#mpg-switch-ckb').is(':checked') ? 'annually' : 'monthly';
            $(document).find('.section [data-period]').hide();
            $(document).find('.section [data-period='+period+']').show();
            $(document).find('.section [data-currency]:visible').each(function(){
              $(this).fadeOut(300, function(){
                $(document).find('.section [data-currency='+value+']').fadeIn(300);
              });
            });
          });

          $(document).on('change','#mpg-switch-ckb', function() {
            var value = $(this).is(':checked') ? 'annually' : 'monthly';
            $(document).find('.section [data-period]:visible').each(function(){
              $(this).fadeOut(300, function(){
                $(document).find('.section [data-period='+value+']').fadeIn(300);
              });
            });
          });

          
          $(document).find('img').each(function() {
            var $img = $(this);
            var filename = $img.attr('src');
            var attr = $img.attr('alt');
            if ( typeof attr == 'undefined' || ! attr ) {
              var page_title = $(document).find('head title').text();
              page_title = page_title ? page_title + ' - ' : '';
              $img.attr('alt', page_title  + decodeURIComponent( filename.substring((filename.lastIndexOf('/'))+1, filename.lastIndexOf('.')) ).replace(/\+/g, '%20') ) ;
            }
          });
       

          $('.sticky-nav-fixed-wrap .sn-flex-wrap .select-wrap select').on('change', function() {
            var href_id = $(this).find('option:selected').attr('data-href');
            // console.warn(href_id);
            try {
              if ( href_id.indexOf("#") >= 0 && $(href_id).length > 0 ) {
                var offset_nav = 0;
                var offset = $(href_id).offset().top - 140 - offset_nav;
                $('body,html').animate({
                    scrollTop: offset,
                }, 300);
              } else {
                window.location.href = href_id;
              }
            } catch(err) {
              console.warn(err);
            }
          });

          if ( $(document).find('.mri-hero-sticky-nav.mri-hsn-new').length > 0 ) {
            $('body').addClass('mri-hsn-sticy-kit');
          }

          $( document ).ajaxComplete(function() {
            $('.page-template-partners-list .js-filter-item .grid_accordion_block--trigger').matchHeight();
            $('section.mri-app-integration-module .js-filter-item .grid_accordion_block--trigger').matchHeight();
          });

          $('section.multi-column-block.mcb-blue .mc-block h3').matchHeight();

          if ( $('body').is('.page-template-template-story') ) {
            new WOW().init();
          }

          $("body.single-jobs p").each(function(){
            if ($.trim($(this).text()) === ""){
              $(this).remove();
            } 
          });

          function parallaxUpdate(evt, obj){
            var vw = $(window).width();
            var vh = mriViewportHeight();
            var st = $(window).scrollTop();
            var sl = $(window).scrollLeft();
            var pos = $(obj).offset();
            var ot = pos.top;
            var ol = pos.left;
            var ow = $(obj).innerWidth();
            var oh = $(obj).innerHeight();

            // Check if element is in viewport
            if(st + vh < ot) {
              return;
            }
            if(st > ot + oh) {
              return;
            }

            var iw = parseInt($(obj).attr('data-parallax-img-width'));
            var ih = parseInt($(obj).attr('data-parallax-img-height'));
            var parallax_ratio = parseFloat($(obj).attr('data-parallax-ratio'));
            parallax_ratio = (isNaN(parallax_ratio)) ? 1 : parallax_ratio;
            var expand_ratio = parseFloat($(obj).attr('data-parallax-expand'));
            expand_ratio = (isNaN(expand_ratio)) ? 1 : expand_ratio;

            // Calculate image size
            var img_wh = ((iw / ih) < (ow / oh));
            var img_ratio = (img_wh) ? (iw / ow) : (ih / oh);
            var fw = iw / img_ratio * expand_ratio;
            var fh = ih / img_ratio * expand_ratio;
            var fsize = fw + 'px ' + fh + 'px';

            // Calculate scroll delta
            var t = Math.abs((ot - vh - st));
            var m = vh + oh;
            var d = t / m;

            // Vertical parallax only - centralizing image horizontally
            var px = ((fw - ow) / 2) * -1;
            
            // Calculate image position
            var py = 0;
            py = ((fh - oh) * d) * -1;
            var fpos = px + 'px ' + py + 'px';

            // Settings properties
            $(obj).css({
                'background-size': fsize,
                'background-position': fpos
            });
        }
        function parallaxUpdateAll(evt, cls){
            $(cls).each(function(idx, obj){
                parallaxUpdate(null, obj);
            });
        }
        function parallaxInit(cls){
            $(cls).each(function(idx, obj){
                var url = $(obj).attr('data-parallax-img');
                $(obj).css({
                    'background-image': 'url(' + url + ')',
                    'background-repeat': 'repeat'
                });
                parallaxUpdate(null, obj);
            });
            $(cls).on('resize', parallaxUpdate);
            $(window).on('scroll', function(evt){ parallaxUpdateAll(evt, cls); });
            $(window).on('resize', function(evt){ parallaxUpdateAll(evt, cls); });
        }

          if ( $('.mri-s-parallax').length > 0 ) {
              parallaxInit('.mri-s-parallax');
          }

          if ( $('.mri-s-parallax-video').length > 0 ) {
            $('.mri-s-parallax-video').each(function(){
              var src_mp4  = $(this).attr('data-mp4src');
              var src_webm = $(this).attr('data-webmsrc');
              var video_par = new BackgroundVideo('.mri-s-parallax-video', {
                src: [
                  src_mp4,
                  src_webm
                ]
              });
            });
            
          }

          $(document).on('click','.mri-mega-menu-v2 .top-navigation .menu-item-has-children > a > i', function(e) {
            e.preventDefault();
            e.stopPropagation();
            // console.warn('asdasd');
            $(this).closest('li').toggleClass('mri-mobile-toggle');
          });

          $(document).find('.section-post-content').each(function(){
            $(this).find('iframe[src*="youtube.com"]').each(function(){
              var content = $(this);
              content.wrap( "<div class='mri-responsive-embed-wrap'></div>" );
            });
          });
          // JavaScript to be fired on all pages
          $('.section-event-form iframe').attr('height','270');
          $('.side-box.subscribe-box.subscribe-box-blog iframe.pardotform').attr('height','95');
          $(document).find('.btn.new-mri-btn').each(function(){
            var button = $(this);
            if ( button.find('span').length < 1 ) {
              var text = button.text();
              button.html( '<span>' + text + '</span>' );
            }
          });

          (function ($) {
            var methods = ['addClass', 'toggleClass', 'removeClass'];

            $.each(methods, function (index, method) {
              var originalMethod = $.fn[method];

              $.fn[method] = function () {
                if ( this[0] ) {
                  var oldClass = this[0].className;
                  var result = originalMethod.apply(this, arguments);
                  var newClass = this[0].className;

                  this.trigger(method, [oldClass, newClass]);

                  return result;
                }
              };
            });
          }(window.jQuery || window.Zepto));



          $('body').on('addClass toggleClass removeClass', function (e, oldClass, newClass) {
            var covid_banner = $(document).find('.mri-header-covid-banner');
            var banner_height = 0;
            
            // if ( ! $('body').hasClass('gdpr-infobar-visible') ) {
              $('header#main-header').removeAttr('style');
              $('.site-content').removeAttr('style');    
              $('#mri-mobile-menu-container').removeAttr('style');   

              // if ( ! $('body').hasClass('gdpr-infobar-visible') ) {
                if ( covid_banner.length > 0 ) {
                  if ( ! covid_banner.is(':visible') ) {    
                    covid_banner.slideDown(300);          
                  }   
                  banner_height = covid_banner.innerHeight();
                  $(document).find('header#main-header').css( 'top', banner_height+'px' );
                }
              // }

            // } else {
              // if( window.innerWidth < 768 ) {
              //   $('header#main-header').css('top',$('#moove_gdpr_cookie_info_bar').height());
              //   $('.site-content').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
              //   $('#mri-mobile-menu-container').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);

              //   if ( covid_banner.length > 0 ) {
              //     if ( ! covid_banner.is(':visible') ) {    
              //       covid_banner.slideDown(300);          
              //     }   
              //     banner_height = covid_banner.innerHeight();
              //     $(document).find('header#main-header').css( 'top', banner_height+'px' );
              //   }
              // }
            // }
          });       

          $(document).on('click','.btn-inlinescroll',function(e){
            var id = $(this).attr('href');
            if ( $(id).length > 0 ) {
              e.preventDefault();
              $('body,html').animate({
                  scrollTop: $(id).offset().top - 100
              }, 300);
            }

          });

          $(document).on('click','.mri-interactive-image-modal .iw-text-content a',function(e){
            
            var id = $(this).attr('href');
            var id_l = id.toLowerCase();
            if ( $(id).length > 0 ) {
              e.preventDefault();
              $('.lity-close').trigger('click');
              $('body,html').animate({
                  scrollTop: $(id).offset().top - 100
              }, 300);
            } else {
              if ( $(id_l).length > 0 ) {
                e.preventDefault();
                $('.lity-close').trigger('click');
                $('body,html').animate({
                    scrollTop: $(id_l).offset().top - 100
                }, 300);
              }
            }

          });

          if( $('body').hasClass('page-template-team-list') ) {
            
            var active_item = $('.grid_accordion').attr('data-active');
            if(active_item && active_item !== '') {
              setTimeout(function(){ $('.grid_accordion .grid_accordion_block--trigger[data-slug='+active_item+']').click(); }, 1000);
            }
          }

          $('.offices-map .map-cont .city').click( function(e){
            e.preventDefault();
            $(this).closest('.city-cont').find('.location-modal').fadeIn().css("display","inline-block");
          });

          $('.offices-map .map-cont .location-modal-close, .offices-map .map-cont .location-modal-overlay').click(function(e){
            e.preventDefault();
            $('.offices-map .map-cont .location-modal').fadeOut();
          });

          $('.offices-map .mobile-modal-cont .mobile-modal-item .mobile-modal-item-header').click( function(e) {
            e.preventDefault();
            var is_active = $(this).closest('.mobile-modal-item').hasClass('active');
            $('.offices-map .mobile-modal-cont .mobile-modal-item').removeClass('active');
            $('.offices-map .mobile-modal-cont .mobile-modal-item .mobile-modal-item-body').hide();

            if( !is_active ) {
              $(this).closest('.mobile-modal-item').addClass('active');
              $(this).closest('.mobile-modal-item').find('.mobile-modal-item-body').fadeIn();
            } 

          });

          window.addEventListener('touchstart', function onFirstTouch() {
            $('body').addClass('touch-device');
            $('.btn.new-mri-btn').each(function(){
                var span = $(this).find('span');
                if(span.length > 0){
                    $(this).html( span.html() );
                }
            });
            window.removeEventListener('touchstart', onFirstTouch, false);
          }, false);

          /*
           Open Social Share in new window on click
           */
          $(document).on('click', '.social-share a.popup', function (e) {
              if ( ! $(this).closest('div').is('.media-center') ) {
                  e.preventDefault();
                  var w = 500, h = 400, left = Number((screen.width / 2) - (w / 2)), top = Number((screen.height / 2) - (h / 2));
                  window.open($(this).prop('href'), '', "width=" + w + ", height=" + h + ", top=" + top + ", left=" + left + "");
              }
          });        

        },
        browserCompatibility: function() {

          function getBrowserVersion() {
            var result = {};
            var ua= navigator.userAgent, tem, 
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE '+(tem[1] || '');
            }
            if(M[1] === 'Chrome'){
                tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
                if(tem!= null) {
                  return tem.slice(1).join(' ').replace('OPR', 'Opera');
                }
            }
            M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem= ua.match(/version\/(\d+)/i))!= null) {
              M.splice(1, 1, tem[1]);
            }
            result.app = M[0];
            result.ver     = M[1];
            return result;
          }

          //CSS justify-content for Chrome < v56 & Safari < v11
          var browser = getBrowserVersion();
          if( (browser.app === 'Chrome' && parseInt(browser.ver) < 56) || (browser.app === 'Safari' && parseInt(browser.ver) < 11) ) {
            $('body').addClass('no-justify-content');
          }

        },
        stickyKit: function() {
          $('.flex-section-container .social-share').stick_in_parent({
            // offset_top: 95,
          });

          if ( $(document).find('.mri-sidebar-main .widget').length === 1 ) {
            if (window.outerWidth >= 992) {
              if ( $('body').hasClass('logged-in') ) {
                var $scrollSpy = $('.mri-blog-sidebar .ssw-scroll_spy');
                var $stickyContainer = $('.mri-blog-sidebar .sticky-sidebar-widgets');
                if ( $scrollSpy.length && $stickyContainer.length ) {
                  // Neutralize CSS sticky (position: sticky; top: 100px) — let sticky-kit own position exclusively
                  $stickyContainer.css({ position: 'relative', top: '0' });
                  var scrollSpyFromTop = $scrollSpy.offset().top - $stickyContainer.offset().top;
                  $stickyContainer.stick_in_parent({
                    offset_top: 110 - scrollSpyFromTop,
                  });
                  // sticky-kit clears inline styles on unstick — re-apply override so CSS sticky doesn't re-engage
                  $stickyContainer.on('sticky_kit:unstick', function() {
                    $(this).css({ position: 'relative', top: '0' });
                  });
                }
              } else {
                $('.sticky-sidebar-widgets').stick_in_parent({
                  offset_top: 110,
                });
              }
            }
          }

          function mri_isScrolledIntoView($elem) {
            if ( $elem && $elem.length > 0 ) { 
              var elm = $elem[0];
              var rect = elm.getBoundingClientRect();
              var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
              return !(rect.bottom < 100 || rect.top - viewHeight >= 0);
              console.warn('scroolllinto');
            } else {
              return false;
            }
          }

          if (  $('#scrollspy-nav').length > 0 ) {
            var has_active = false;

            // Article text, flattened once, for finding text-fragment targets. Each text node is
            // kept with its start offset so a match can be mapped back to its element.
            var spy_text = null;
            function mri_scrollspyText() {
              if ( spy_text ) {
                return spy_text;
              }
              spy_text = { value: '', nodes: [] };
              var root = $('#scrollspy-nav').closest('.mv-article-body')[0] || document.body;
              var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
                acceptNode: function(node) {
                  if ( node.nodeType === 1 ) {
                    // Skip the sidebar, or a link's own label would match itself.
                    var skip = /^(SCRIPT|STYLE|NOSCRIPT)$/.test(node.nodeName) || ( node.classList && node.classList.contains('mri-sidebar-main') );
                    return skip ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
                  }
                  return NodeFilter.FILTER_ACCEPT;
                },
              }, false);
              while ( walker.nextNode() ) {
                spy_text.nodes.push({ node: walker.currentNode, start: spy_text.value.length });
                spy_text.value += walker.currentNode.nodeValue;
              }
              return spy_text;
            }

            function mri_textPattern(text) {
              return $.trim(text).replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
            }

            // Element a #:~:text=[prefix-,]start[,end][,-suffix] fragment points at — the format
            // Chrome's "Copy link to highlight" produces. Matching is case-insensitive and
            // whitespace-tolerant, like the browser's own.
            function mri_textFragmentTarget(directive) {
              var parts;
              try {
                parts = $.map(directive.split(','), decodeURIComponent);
              } catch(err) {
                return null;
              }
              var prefix = parts.length > 1 && /-$/.test(parts[0]) ? parts.shift().slice(0, -1) : '';
              var suffix = parts.length > 1 && /^-/.test(parts[parts.length - 1]) ? parts.pop().slice(1) : '';
              if ( ! parts[0] ) {
                return null;
              }
              var match = new RegExp(
                '(' + (prefix ? mri_textPattern(prefix) + '\\s*' : '') + ')' +
                mri_textPattern(parts[0]) +
                (suffix ? '(?=\\s*' + mri_textPattern(suffix) + ')' : ''),
                'i'
              ).exec(mri_scrollspyText().value);
              if ( ! match ) {
                return null;
              }
              var index = match.index + match[1].length;
              var nodes = mri_scrollspyText().nodes;
              var i = nodes.length - 1;
              while ( i > 0 && nodes[i].start > index ) {
                i--;
              }
              return $(nodes[i].node.parentNode);
            }

            // What a sidebar link points at on this page: an #id anchor, or a text fragment.
            // Links to other pages have no target and are left to behave as normal links.
            function mri_scrollspyTarget(link) {
              var href = link.getAttribute('href') || '';
              var hash_at = href.indexOf('#');
              if ( hash_at < 0 ) {
                return null;
              }
              // Compare paths only: links are saved with the live domain, which differs on local/staging.
              var path = href.slice(0, hash_at).replace(/^[a-z]+:\/\/[^/]+/i, '').replace(/\/+$/, '');
              if ( path && path !== window.location.pathname.replace(/\/+$/, '') ) {
                return null;
              }
              var fragment = href.slice(hash_at + 1);
              var directive_at = fragment.indexOf(':~:');
              if ( directive_at >= 0 ) {
                var text = fragment.slice(directive_at + 3).split('&').filter(function(d) { return d.indexOf('text=') === 0; })[0];
                return text ? mri_textFragmentTarget(text.slice(5)) : null;
              }
              var el = fragment ? document.getElementById(decodeURIComponent(fragment)) : null;
              return el ? $(el) : null;
            }

            $('#scrollspy-nav a').each(function() {
              $(this).data('scrollspy-target', mri_scrollspyTarget(this));
            });

            window.addEventListener("scroll", function () {
              $(document).find('#scrollspy-nav a').removeClass('active');
              has_active = false;
              $(document).find('#scrollspy-nav a').each(function(){
                var $target = $(this).data('scrollspy-target');
                if ( $target && $target.visible( true ) ) {
                  if ( ! has_active ) {
                    $(this).addClass('active');
                    has_active = true;
                  }
                }
              });

              // A long list scrolls inside its card (resource pages) — keep the highlighted link in view.
              var $active = $(document).find('#scrollspy-nav a.active');
              var list = $active.closest('.in-this-section-links')[0];
              if ( list && list.scrollHeight > list.clientHeight ) {
                var listRect = list.getBoundingClientRect();
                var linkRect = $active[0].getBoundingClientRect();
                if ( linkRect.top < listRect.top ) {
                  list.scrollTop -= listRect.top - linkRect.top;
                } else if ( linkRect.bottom > listRect.bottom ) {
                  list.scrollTop += linkRect.bottom - listRect.bottom;
                }
              }
            });

            $('#scrollspy-nav a.nav-link').on('click', function(e) {
              // Text fragments are left to the browser, which scrolls to and marks the matched text.
              var href_id = $(this).attr('href') || '';
              var $target = $(this).data('scrollspy-target');
              if ( $target && href_id.indexOf(':~:') < 0 ) {
                e.preventDefault();
                var offset_nav = 0;
                var offset = $target.offset().top - 140 - offset_nav;
                $('body,html').animate({
                    scrollTop: offset,
                }, 300);
              }
            });
          }

          if (window.outerWidth < 992) {
            $('.mv-article-body .mri-sidebar-main.mri-sticky-sidebar').trigger("sticky_kit:detach");
          } else {
            $('.mv-article-body .mri-sidebar-main.mri-sticky-sidebar').stick_in_parent({
              offset_top: 105,
            });
          }

          jQuery( window ).resize(function() {

            if (window.outerWidth < 992) {
              $('.mv-article-body .mri-sidebar-main.mri-sticky-sidebar').trigger("sticky_kit:detach");
              $('.sticky-sidebar-widgets').trigger("sticky_kit:detach");
              if ( $('body').hasClass('logged-in') ) {
                $('.sticky-sidebar-widgets').css({ position: '', top: '' });
              }
            } else {
              $('.mv-article-body .mri-sidebar-main.mri-sticky-sidebar').stick_in_parent({
                offset_top: 105,
              });
              if ( $('body').hasClass('logged-in') && $(document).find('.mri-sidebar-main .widget').length === 1 ) {
                var $scrollSpy = $('.mri-blog-sidebar .ssw-scroll_spy');
                var $stickyContainer = $('.mri-blog-sidebar .sticky-sidebar-widgets');
                if ( $scrollSpy.length && $stickyContainer.length ) {
                  $stickyContainer.css({ position: 'relative', top: '0' });
                  var scrollSpyFromTop = $scrollSpy.offset().top - $stickyContainer.offset().top;
                  $stickyContainer.stick_in_parent({
                    offset_top: 110 - scrollSpyFromTop,
                  });
                }
              }
            }

          });

          if( window.outerWidth > 768 ) {
            $('.page-template-shop-detail-order .order-side-cont').stick_in_parent({
              offset_top: 95
            });
          }
        },
        clients_logos_grid: function() {
          function isElementVisible($elem) {

            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + mriViewportHeight();
            var elemTop = $elem.offset().top;
            var returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 70));
            return returnvalue;

          }

          $(document).find('.clients-logo-grid').each(function(){
            var grid_wrap = $(this);
            var visible_items = [];
            var hidden_items  = [];
            function update_visible_items() {
              visible_items = [];
              hidden_items  = [];
              grid_wrap.find('.logo-wrap').each(function(){
                if ( $(this).is(':visible') ) {
                  visible_items.push( $(this).attr('data-logo') );
                  var logo_m = $(this).find('.lic-main-bg');
                } else {
                  hidden_items.push( $(this).attr('data-logo') );
                }
              });
              // console.warn(visible_items);
              // console.warn(hidden_items);
            }
            update_visible_items();

            $.fn.swapWith = function(that) {
              var $this = this;
              var $that = $(that);

              // create temporary placeholder
              var $temp = $("<span></span>");

              // 3-step swap
              $this.before($temp);
              $that.before($this);
              $temp.after($that).remove();

              return $this;
            };

            function change_logo() {
              var visible_index   = Math.floor(Math.random() * visible_items.length),
                  hidden_index    = Math.floor(Math.random() * hidden_items.length),
                  visible_replace = visible_items[visible_index],
                  hidden_replace  = hidden_items[hidden_index],
                  visible_item  = grid_wrap.find('.logo-wrap.logo-'+visible_replace),
                  hidden_item   = grid_wrap.find('.logo-wrap.logo-'+hidden_replace);

              hidden_item.find('.logo-image-cnt').hide();

              if ( hidden_items.length > 1 ) {
                visible_item.find('.logo-image-cnt').fadeOut(1500, function(){
                  var this_html = $(this).html();
                  $(this).empty().html( hidden_item.find('.logo-image-cnt').html() );
                  var logo_m = $(this).closest('.logo-wrap').find('.lic-main-bg');
                  $(this).closest('.logo-wrap').find('.logo-image-cnt').fadeIn(1500);
                  hidden_item.find('.logo-image-cnt').empty().html( this_html );

                  hidden_item.find('.logo-image-cnt').find('span[data-bg]').each(function(){
                    var image = $(this).attr('data-bg');
                    if ( image ) {
                      $(this).css('background-image','url('+image+')');
                    }
                  });
                  
                });
              }

              // visible_item.swapWith( hidden_item );

              update_visible_items();
            }
            setInterval(function() {
              if ( isElementVisible( grid_wrap ) ) {
                change_logo();
              }
            }, 1500);

          });
        },
        /**
         * Engage Suite Slider.
         *
         * Progressive enhancement only - the cards are real links laid out in a
         * native scroll container, so without this the module still scrolls by
         * touch and trackpad and every card is reachable. This adds the arrows,
         * arrow-key scrolling and the kicker preview on hover.
         *
         * Deliberately not a carousel library: scroll snap already does the
         * hard part, and a library that re-arms itself on transitionend stalls
         * the moment one transition is interrupted mid-scroll.
         */
        /**
         * Event 2026 countdown (template-parts/event-2026/countdown.php).
         *
         * Counts to a fixed instant rather than a remaining duration, because
         * NitroPack can serve the markup hours after it was rendered. Once the
         * event starts the block is removed, matching what the server does on
         * a fresh render.
         */
        event_countdown: function() {
          $('.event-countdown[data-countdown-end]').each(function() {
            var $section = $(this);
            var end      = parseInt($section.attr('data-countdown-end'), 10);
            var $values  = {
              days:    $section.find('[data-countdown-unit="days"]'),
              hours:   $section.find('[data-countdown-unit="hours"]'),
              minutes: $section.find('[data-countdown-unit="minutes"]'),
              seconds: $section.find('[data-countdown-unit="seconds"]')
            };
            var timer;

            function pad(n) {
              return n < 10 ? '0' + n : String(n);
            }

            function tick() {
              var remaining = Math.floor((end - Date.now()) / 1000);

              if (!end || remaining <= 0) {
                clearInterval(timer);
                $section.remove();
                return;
              }

              $values.days.text(pad(Math.floor(remaining / 86400)));
              $values.hours.text(pad(Math.floor(remaining % 86400 / 3600)));
              $values.minutes.text(pad(Math.floor(remaining % 3600 / 60)));
              $values.seconds.text(pad(remaining % 60));
            }

            timer = setInterval(tick, 1000);
            tick();
          });
        },
        /**
         * Event 2026 sticky registration form (_event-2026.scss).
         *
         * A form that fits the window simply sticks under the header. Pardot
         * forms are often taller than a laptop window, though, and then one
         * fixed position has to hide either the form's heading or its submit
         * button. So for a tall form the sticky offset follows the scroll: the
         * form travels with the page between two resting points - submit
         * button in view while scrolling down, heading back under the site
         * header while scrolling up.
         */
        event_sticky_form: function() {
          var sticky = document.querySelector('.event-2026-sidebar__sticky');
          if (!sticky) {
            return;
          }

          var offset  = NaN; // Resting top: heading just under the site header.
          var minTop  = 0;   // Resting top that brings the bottom edge into view.
          var top     = null;
          var lastY   = window.pageYOffset;
          var pending = false;

          function apply() {
            sticky.style.setProperty('--event-2026-sticky-top', top + 'px');
          }

          function measure() {
            offset = parseInt(getComputedStyle(sticky).getPropertyValue('--event-2026-sticky-offset'), 10);
            if (isNaN(offset)) {
              return; // Below the sticky breakpoint.
            }
            minTop = Math.min(offset, window.innerHeight - sticky.offsetHeight - 20);
            top    = Math.max(minTop, Math.min(offset, top === null ? offset : top));
            apply();
          }

          function follow() {
            pending = false;
            var y     = window.pageYOffset;
            var delta = y - lastY;
            lastY = y;
            if (isNaN(offset) || minTop >= offset) {
              return; // Fits the window, or not sticky: nothing to follow.
            }
            top = Math.max(minTop, Math.min(offset, top - delta));
            apply();
          }

          measure();
          $(window).on('resize load', measure);
          window.addEventListener('scroll', function() {
            if (!pending) {
              pending = true;
              window.requestAnimationFrame(follow);
            }
          }, { passive: true });
          // The Pardot iframe can change height after it loads.
          if (window.ResizeObserver) {
            new ResizeObserver(measure).observe(sticky);
          }
        },
        engage_suite_slider: function() {
          $('[data-ess]').each(function() {
            var frame  = this;
            var $frame = $(frame);
            var track  = frame.querySelector('[data-ess-track]');

            if ( !track ) {
              return;
            }

            var $prev  = $frame.find('[data-ess-prev]');
            var $next  = $frame.find('[data-ess-next]');
            var $section = $frame.closest('section');
            var $dots  = $section.find('[data-ess-dots]');
            var $dot   = $dots.find('[data-ess-dot]');
            var $kicker = $section.find('[data-ess-kicker-target]');
            var $cards  = $frame.find('[data-ess-card]');

            // The server already worked out which card is the current page;
            // hovering only previews another kicker, so the original has to be
            // kept to restore on mouseleave.
            var activeKicker = $kicker.length ? $kicker.text() : '';

            var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var behavior     = reduceMotion ? 'auto' : 'smooth';

            function cardWidth() {
              var first = track.firstElementChild;
              return first ? first.getBoundingClientRect().width : 240;
            }

            function scrollTrack(left) {
              // scrollTo with an options object is unsupported in older Safari,
              // where assigning scrollLeft still works - just without easing.
              if ( typeof track.scrollTo === 'function' ) {
                try {
                  track.scrollTo({ left: left, behavior: behavior });
                  return;
                } catch (e) { /* fall through to the assignment below */ }
              }
              track.scrollLeft = left;
            }

            // Whether the row can travel each way, spent twice: the arrows use
            // it on desktop, and below desktop - where the arrows are hidden -
            // the same two classes drive the fade on whichever edge still has
            // cards behind it. Working it out once keeps the two in step.
            function updateScrollState() {
              // A few px of slack: sub-pixel widths mean scrollLeft rarely
              // lands exactly on 0 or on the maximum.
              var atStart = track.scrollLeft <= 4;
              var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

              $prev.prop('disabled', atStart);
              $next.prop('disabled', atEnd);

              frame.classList.toggle('is-at-start', atStart);
              frame.classList.toggle('is-at-end', atEnd);

              // Which card the row has settled on. At the far end the last card
              // is rarely flush with the edge, so the arithmetic would keep
              // pointing at the one before it - hence the explicit case.
              var current = atEnd
                ? $dot.length - 1
                : Math.round(track.scrollLeft / cardWidth());

              current = Math.max(0, Math.min($dot.length - 1, current));

              $dot.each(function (index) {
                var on = index === current;

                this.classList.toggle('is-active', on);

                if (on) {
                  this.setAttribute('aria-current', 'true');
                } else {
                  this.removeAttribute('aria-current');
                }
              });

              // A row that fits has nothing to page through: no dots, and no
              // grab cursor promising a drag that would do nothing.
              $section.toggleClass('is-static', atStart && atEnd);
            }

            function scrollCardIntoView(card) {
              var left  = card.offsetLeft - track.offsetLeft;
              var right = left + card.offsetWidth;

              if ( left < track.scrollLeft ) {
                scrollTrack(left);
              } else if ( right > track.scrollLeft + track.clientWidth ) {
                scrollTrack(right - track.clientWidth);
              }
            }

            $prev.on('click', function() {
              scrollTrack(track.scrollLeft - (cardWidth() * 2));
            });

            $next.on('click', function() {
              scrollTrack(track.scrollLeft + (cardWidth() * 2));
            });

            /**
             * Drag the row with a mouse.
             *
             * A native scroll container cannot be dragged with a cursor - that
             * is a scrollbar's job, and this one is deliberately hidden. Below
             * desktop the arrows are hidden too, so on a narrow window with a
             * mouse there was no way at all to move the row. Touch was never
             * the broken case; it just looked that way because a desktop
             * browser resized narrow behaves nothing like a phone.
             *
             * Mouse only, on purpose. Touch and pen already pan this natively,
             * with momentum and snap-back that reimplementing would only make
             * worse.
             */
            var DRAG_THRESHOLD = 4;

            var dragFrom = 0;
            var dragScroll = 0;
            var dragged = 0;
            var dragPointer = null;
            var pressed = false;
            var dragging = false;

            track.addEventListener('pointerdown', function (e) {
              if (e.pointerType !== 'mouse' || e.button !== 0) {
                return;
              }

              pressed = true;
              dragged = 0;
              dragFrom = e.clientX;
              dragScroll = track.scrollLeft;
              dragPointer = e.pointerId;
            });

            track.addEventListener('pointermove', function (e) {
              if (!pressed || e.pointerId !== dragPointer) {
                return;
              }

              var distance = e.clientX - dragFrom;

              dragged = Math.max(dragged, Math.abs(distance));

              // Nothing happens until the cursor has actually travelled. A press
              // that never moves has to stay a plain click, and capturing the
              // pointer up front is what stopped it being one: a captured
              // pointer retargets the click onto the track, so the card's own
              // link never saw it and the cards stopped opening.
              if (!dragging) {
                if (dragged <= DRAG_THRESHOLD) {
                  return;
                }

                dragging = true;

                // Smooth scrolling would animate towards every position the drag
                // passes through, so the row lags behind the cursor; snapping
                // would fight it the same way. Both come back on release, which
                // is what settles the row onto a card.
                track.style.scrollBehavior = 'auto';
                track.style.scrollSnapType = 'none';

                // Safe now the drag is real: keeps the moves coming if the
                // cursor leaves the track mid-drag.
                if (track.setPointerCapture) {
                  track.setPointerCapture(e.pointerId);
                }

                frame.classList.add('is-dragging');
              }

              track.scrollLeft = dragScroll - distance;

              // Stops the drag turning into a text or image selection.
              e.preventDefault();
            });

            function endDrag(e) {
              pressed = false;

              if (!dragging) {
                return;
              }

              dragging = false;

              if (track.releasePointerCapture && e && track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
                track.releasePointerCapture(e.pointerId);
              }

              track.style.scrollBehavior = '';
              track.style.scrollSnapType = '';
              frame.classList.remove('is-dragging');
            }

            track.addEventListener('pointerup', endDrag);
            track.addEventListener('pointercancel', endDrag);

            // Every card is a link, so without this a drag that happens to
            // finish over one navigates away. Captured so it lands before the
            // link's own handling. The threshold lets an unsteady click through.
            track.addEventListener('click', function (e) {
              if (dragged > DRAG_THRESHOLD) {
                e.preventDefault();
                e.stopPropagation();
                dragged = 0;
              }
            }, true);

            // Images inside links are draggable by default, which would start a
            // native image drag instead of moving the row.
            track.addEventListener('dragstart', function (e) {
              e.preventDefault();
            });

            $dot.on('click', function () {
              var item = track.children[Number(this.getAttribute('data-ess-dot'))];

              if (item) {
                scrollTrack(item.offsetLeft - track.offsetLeft);
              }
            });

            $(track).on('scroll', updateScrollState);
            $(window).on('resize.engage_suite_slider', updateScrollState);

            $(track).on('keydown', function(e) {
              if ( e.key === 'ArrowRight' || e.keyCode === 39 ) {
                e.preventDefault();
                scrollTrack(track.scrollLeft + cardWidth());
              } else if ( e.key === 'ArrowLeft' || e.keyCode === 37 ) {
                e.preventDefault();
                scrollTrack(track.scrollLeft - cardWidth());
              }
            });

            if ( $kicker.length ) {
              $cards.on('mouseenter focus', function() {
                // getAttribute rather than .data(): jQuery coerces values that
                // look numeric, and a kicker is always meant to stay a string.
                $kicker.text(this.getAttribute('data-ess-kicker') || '');
              });

              // Bound on the section rather than each card so moving between
              // two cards does not flicker back to the active kicker in between.
              $frame.closest('section').on('mouseleave', function() {
                $kicker.text(activeKicker);
              });
            }

            // Tabbing to a card that is scrolled out of sight has to bring it
            // into view, or keyboard focus disappears off the edge of the track.
            $cards.on('focus', function() {
              if ( track.contains(this) ) {
                scrollCardIntoView(this);
              }
            });

            var $active = $cards.filter('.is-active').first();

            if ( $active.length && track.contains($active[0]) ) {
              scrollCardIntoView($active[0]);
            }

            updateScrollState();
          });
        },
        smart_pricing: function() {
          /* Pricing Range Swiper */
          var mri_price_slider_main = new Swiper('.mri_price_slider_main .swiper-container', {
              fadeEffect: {
                crossFade: true
              },
              effect: 'fade',
              loop: false,
              preventInteractionOnTransition: false,
              slidesPerView: 1,
              speed: 300,
              touchRatio: 0,
          });

          if($('.mri_price_slider_nav').length) {
            var items_count = parseInt( $('.mrisp_range-form').attr('data-count') );
            items_count = items_count ? items_count - 1 : 2;
            var mri_price_slider_nav = noUiSlider.create($('.mri_price_slider_nav')[0], {
                connect: 'lower',
                padding: [1, 0],
                range: {
                    'min': -1,
                    'max': items_count
                },
                start: 0,
                step: 1,
            });
            mri_price_slider_nav.on('update', function() {
                $('.mri_price_slider_input').val(parseInt(mri_price_slider_nav.get()));
                $('.mri_price_slider_select').val(parseInt(mri_price_slider_nav.get()));
                $('section.mri-price-module .mrisp_pricing_range .mrisp_range-form .mrisp_form-pips > .mri_sm_c.active').removeClass('active');
                $('section.mri-price-module .mrisp_pricing_range .mrisp_range-form .mrisp_form-pips > .mri_sm_c[data-rs="' + $('.mri_price_slider_input').val() + '"]').addClass('active');
                mri_price_slider_main.slideTo($('.mri_price_slider_input').val());
            });
            $(document).on('click touch', 'section.mri-price-module .mrisp_pricing_range .mrisp_range-form .mrisp_form-pips > .mri_sm_c', function(event) {
                event.stopPropagation();
                event.preventDefault();
                
                mri_price_slider_nav.set($(this).attr('data-rs'));

            });
            $(document).on('change', '.mri_price_slider_select', function(event) {
                event.stopPropagation();
                event.preventDefault();
                
                mri_price_slider_nav.set($(this).val());
                
            });
        }

        },
        owlCarousels: function() {

          $('.mri-s-text-carousel').each(function(){
            var autoplay = $(this).find('.owl-carousel').attr('data-autoplay');
            autoplay = autoplay === 'true' ? true : false;
            var autoplay_timeout = $(this).find('.owl-carousel').attr('data-at');
            var slider = $(this).find('.owl-carousel');
            slider.owlCarousel({
              center: false,
              items: 1,
              loop: true,
              nav: false,
              dots: true,
              margin: 40,
              autoplay: autoplay,
              autoplayTimeout: parseInt(autoplay_timeout),
              autoplayHoverPause: true,
              drag: true,
            });
          });

          $('.mri-full_size_cta_box_slider').each(function(){
            var autoplay = $(this).find('.owl-carousel').attr('data-autoplay');
            autoplay = autoplay === 'true' ? true : false;
            var autoplay_timeout = $(this).find('.owl-carousel').attr('data-at');
            var slider = $(this).find('.owl-carousel');
            slider.owlCarousel({
              center: false,
              items: 1,
              loop: true,
              nav: true,
              navText: ['',''],
              dots: true,
              margin: 40,
              autoplay: autoplay,
              autoplayTimeout: parseInt(autoplay_timeout),
              autoplayHoverPause: true,
              drag: true,
            });
          });

          $('.mri-testimonial-slider').each(function(){
            var testimonial_carousel = $(this).find('.owl-carousel');
            
            testimonial_carousel.on('initialized.owl.carousel', function(e) {            
              var current     = e.relatedTarget.current();
              if ( ! $(e.target).find(".owl-item").closest('section.mri-testimonial-slider').hasClass('bg-global') ) {
                var text_colour = $(e.target).find(".owl-item").eq(current).find('.article-items').attr('data-text-colour');
                var bg_colour   = $(e.target).find(".owl-item").eq(current).find('.article-items').attr('data-bg-colour');
                if ( text_colour && bg_colour ) {
                  $(e.target).find(".owl-item").closest('section.mri-testimonial-slider').css({'background-color' : bg_colour, 'color' : text_colour });
                } else {
                  $(e.target).find(".owl-item").closest('section.mri-testimonial-slider').removeAttr('style');
                }
              }
            });
            testimonial_carousel.on('changed.owl.carousel', function(e) {            
              var current     = e.relatedTarget.current();
              if ( ! $(e.target).find(".owl-item").closest('section.mri-testimonial-slider').hasClass('bg-global') ) {
                var text_colour = $(e.target).find(".owl-item").eq(current).find('.article-items').attr('data-text-colour');
                var bg_colour   = $(e.target).find(".owl-item").eq(current).find('.article-items').attr('data-bg-colour');
                if ( text_colour && bg_colour ) {
                  $(e.target).find(".owl-item").closest('section.mri-testimonial-slider').css({'background-color' : bg_colour, 'color' : text_colour });
                } else {
                  $(e.target).find(".owl-item").closest('section.mri-testimonial-slider').removeAttr('style');
                }
              }
            });

            var count = testimonial_carousel.find('.article-items').length;
            var autoplay_timeout = testimonial_carousel.closest('section').attr('data-ap');
            var slider_nav = testimonial_carousel.closest('section').attr('data-an');
            slider_nav = slider_nav === 'show' ? true : false;
            testimonial_carousel.owlCarousel({
              center: false,
              items: 1,
              loop: true,
              nav: slider_nav,
              navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
              navContainer: '.mri-testimonial-slider .owl-nav-container',
              dots: false,
              margin: 40,
              drag: count > 1 ? true : false,
              mouseDrag: count > 1 ? true : false,
              autoHeight: false,
              autoplay: count > 1 ? true : false,
              autoplayTimeout: autoplay_timeout,
              autoplayHoverPause: true
            });


          });



          $('.featured-customers .owl-carousel').owlCarousel({
            center: false,
            items: 1,
            loop: true,
            nav: false,
            dots: false,
            margin: 40,
            drag: true,
            navText: ['',''],
            responsive : {
              0 : {
                items: 1,
                margin: 20,
                stagePadding: 80,
                dots: true,
                nav: true,
              },
              768 : {
                items: 1,
                stagePadding: 200,
                dots: true,
                nav: true,
              },
              1010 : {
                items: 5,
                stagePadding: 0,
                dots: false,
                nav: false,
                drag: false,
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                freeDrag: false,
              }
            }
          });

          $('section.flipping-numbers .owl-carousel').each(function(){
            var count = 5;
            var tcount = 3;
            var items = $(this).find('.number-box-item');
            if ( items.length < 5 ) {
              count = items.length;
            }
            if ( items.length < 3 ) {
              tcount = items.length;
            }
            $(this).owlCarousel({
              center: false,
              items: 1,
              loop: false,
              nav: true,
              dots: false,
              margin: 30,
              drag: true,
              navText: ['',''],
              autoheight: true,
              startPosition: 0,
              responsive : {
                0 : {
                  items: 1,
                  dots: false,
                  nav: true,
                  loop: false,
                  center: true
                },
                768 : {
                  items: tcount,
                  stagePadding: 0,
                  center: false,
                  loop: false,
                  dots: false,
                },
                1010 : {
                  items: count,
                  stagePadding: 0,
                  dots: false,
                  nav: false,
                  drag: false,
                  mouseDrag: false,
                  touchDrag: false,
                  pullDrag: false,
                  freeDrag: false,
                }
              }
            });

          });

          $('section.home-hero-slider .owl-carousel').owlCarousel({
            center: true,
            items: 1,
            loop: true,
            nav: true,
            navContainer: 'section.home-hero-slider .owl-nav-container .container',
            navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
            dots: true,
            dotsContainer: 'section.home-hero-slider .owl-nav-container .container .owl-dots',
            margin: 30,
            drag: true,
            autoHeight: true,
            startPosition: 0
          });

          $('section.clients-slider .owl-carousel').each(function(){
            var client_slider = $(this);
            var class_id = '_' + Math.random().toString(36).substr(2, 9);
            $(this).closest('section').find('.owl-nav-container').addClass('owl'+class_id);
            client_slider.owlCarousel({
              center: false,
              items: 1,
              loop: false,
              nav: false,
              smartSpeed: 500,
              dots: false,
              dotsContainer: '.owl' + class_id + ' .owl-dots',
              margin: 0,
              drag: true,
              navContainer: '.owl' + class_id + ' .owl-nav',
              navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
              autoheight: true,
              responsive : {
                0 : {
                  items: 1,
                  stagePadding: 50,
                  dots:true
                },
                768 : {
                  items: 3,
                  stagePadding: 50,
                  dots:true
                },
                1010 : {
                  items: 5
                }
              }
            });
            $(this).on('click', '.owl-item', function() {
              if( window.outerWidth < 1010) {
                client_slider.trigger('to.owl.carousel', parseInt(  [$(this).find( '.client-box' ).attr('data-index'), 1, true] ) ) ;
              }
            });
          });

          var sync1 = $('section.full-image-slider .full-image-slider-body.owl-carousel');
          var sync2 = $('section.full-image-slider .full-image-slider-nav.owl-carousel');
          var syncedSecondary = true;

          function syncPosition(el) {
            //if you set loop to false, you have to restore this next line
            //var current = el.item.index;
            
            //if you disable loop you have to comment this block
            var count = el.item.count-1;
            var current = Math.round(el.item.index - (el.item.count/2) - 0.5);
            
            if(current < 0) {
              current = count;
            }
            if(current > count) {
              current = 0;
            }
            
            //end block

            sync2
              .find(".owl-item")
              .removeClass("current")
              .eq(current)
              .addClass("current");
            var onscreen = sync2.find('.owl-item.active').length - 1;
            var start = sync2.find('.owl-item.active').first().index();
            var end = sync2.find('.owl-item').last().index();
            
            if (current > end) {
              sync2.data('owl.carousel').to(current, 100, true);
            }
            if (current < start) {
              sync2.data('owl.carousel').to(current - onscreen, 100, true);
            }
          }
    
          function syncPosition2(el) {
            if(syncedSecondary) {
              var number = el.item.index;
              sync1.data('owl.carousel').to(number, 100, true);
            }
          }

          var slidesPerPage = 6; //globaly define number of elements per page

          var class_id = '_' + Math.random().toString(36).substr(2, 9);
          sync1.closest('section').find('.owl-nav-container').addClass('owl'+class_id);
          sync1.owlCarousel({
              center: false,
              items: 1,
              loop: true,
              nav: true,
              dots: true,
              dotsData : true,
              dotsContainer: '.owl' + class_id + ' .owl-dots',
              margin: 0,
              drag: true,
              navContainer: '.owl' + class_id + ' .owl-nav',
              navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
              autoHeight: true,
          }).on('changed.owl.carousel', function(e) {
            syncPosition(e);
            var current = e.relatedTarget.current();
            var bg_img = $(e.target).find(".owl-item").eq(current).find(".full-image-slider-item").attr("data-bg-img");
            $('.full-image-slider-cont').css('background-image', 'url('+bg_img+')' );
            // console.log( $(el).find('.owl-item.active .full-image-slider-item').attr('data-bg-img') );
          });

          sync2.on('initialized.owl.carousel', function () {
            sync2.find(".owl-item").eq(0).addClass("current");
          }).owlCarousel({
              items : slidesPerPage,
              dots: false,
              nav: false,
              slideBy: slidesPerPage,
              margin: 30,
              responsive:{
                0:{
                    items:1,
                    nav:false
                },
                600:{
                    items: 3
                },
                1000:{
                    items: slidesPerPage
                }
              }
          }).on('changed.owl.carousel', syncPosition2);

          
          
          sync2.on("click", ".owl-item", function(e){
            e.preventDefault();
            var number = $(this).index();
            sync1.data('owl.carousel').to(number, 300, true);
          });

        },
        multimediaTabs:function() {
          function iOS() {
            var iDevices = [
              'iPad Simulator',
              'iPhone Simulator',
              'iPod Simulator',
              'iPad',
              'iPhone',
              'iPod'
            ];

            if (!!navigator.platform) {
              while (iDevices.length) {
                if (navigator.platform === iDevices.pop()){ return true; }
              }
            }

            return false;
          }
          $(function(){var b="fadeInLeft";var c;var a;function d(e,f,g){e.click(function(i){i.preventDefault();$(this).tab("show");var h=$(this).data("easein");if(c){c.removeClass(a);}if(h){f.find("div.active").addClass("animated "+h);a=h;}else{if(g){f.find("div.active").addClass("animated "+g);a=g;}else{f.find("div.active").addClass("animated "+b);a=b;}}c=f.find("div.active");});}$("a[rel=popover]").popover().click(function(f){f.preventDefault();if($(this).data("easein")!==undefined){$(this).next().removeClass($(this).data("easein")).addClass("animated "+$(this).data("easein"));}else{$(this).next().addClass("animated "+b);}});d($(".multimedia-navs a"),$(".multimedia-box .tab-content"));});
          function detectmob() {
             if(window.innerWidth <= 800 && window.innerHeight <= 600) {
               return true;
             } else {
               return false;
             }
          }
          $('.multimedia-navs a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
            var target = $(e.target).attr("href"); // activated tab

            $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld').fadeOut(400);
            $(this).closest('.multimedia-box').find('.section-background-content video').each(function(){
              if ( ! $(this)[0].paused && ! iOS() && ! detectmob() ) {
                $(this)[0].pause();
              }
            });
            $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld[data-tab="'+target+'"]').fadeIn(400);
            var video = $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld[data-tab="'+target+'"]').find('video');
            if ( ( video.length > 0 ) && ! iOS() && ! detectmob() ) {
              if ( video[0].paused ) {
                video[0].play();
              }
            }
          });
          $('.multimedia-navs a[data-toggle="pill"]').each(function(e){
            if ( $(this).closest('li').hasClass('active') ) {
              var target = $(this).attr("href"); // activated tab

              $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld').fadeOut(400);
              $(this).closest('.multimedia-box').find('.section-background-content video').each(function(){
                if ( ! $(this)[0].paused && ! iOS() && ! detectmob() ) {
                  $(this)[0].pause();
                }
              });
              $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld[data-tab="'+target+'"]').fadeIn(400);
              var video = $(this).closest('.multimedia-box').find('.section-background-content .tab-bg-hld[data-tab="'+target+'"]').find('video');
              if ( ( video.length > 0 ) && ! iOS() && ! detectmob() ) {
                if ( video[0].paused ) {
                  video[0].play();
                }
              }
            }
          });
        },
        mobileNav: function(){
          $(document).on('click','#mobile-menu-trigger',function(e){
            e.preventDefault();
            $(this).toggleClass('menu-open');
            $('body').toggleClass('mobile-menu-open');
          });
          function isElementVisible($elem) {

            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + mriViewportHeight();
            var elemTop = $elem.offset().top;
            var returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 70));
            return returnvalue;

          }
          $(document).on('click','#mri-mobile-menu-container li.menu-item-has-children > a',function(e){
            e.preventDefault();
            var menu_parent = $(this).closest('li');
            menu_parent.closest('ul').find('li.menu-open').each(function(){
              if ( $(this)[0] !== menu_parent[0] ) {
                $(this).removeClass('menu-open');
              }
            });
            menu_parent.toggleClass('menu-open');
            if ( menu_parent.hasClass('menu-open') ) {
              if ( ! isElementVisible( menu_parent ) ) {
                menu_parent.get(0).scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }
          });
          $(document).on('change','.mobile-region-select-cnt select',function(e){
            e.preventDefault();
            var url = $(this).val();
            if ( url ) {
              window.location.href = url;
            }
          });
        },
        geolocation: function() {

          function mri_set_cookie( name, value, days ) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires + "; path=/";
          }
          function mri_get_cookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)===' ') {
                  c = c.substring(1,c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                  return c.substring(nameEQ.length,c.length);
                }
            }
            return null;
          }

          var read_geoip_cookie = mri_get_cookie( '_geo' );
          $(document).on('click','.geoip-overlay-b',function(e){
            e.preventDefault();
            $('body').removeClass('mri-geolocation-open');
            mri_set_cookie('_geo',1,0);
          });
          var load_geo_popup_started = false;
          $(window).load(function(){
            if ( ! read_geoip_cookie ) {
              var load_geo_popup = true;

              if ( typeof( sessionStorage ) !== "undefined" && parseInt(sessionStorage.getItem( '_geo' )) === 1 ) {
                load_geo_popup = false;
              }
              if ( load_geo_popup ) {
                $(window).scroll(function() {
                  if ( ! load_geo_popup_started ) {
                    var scrollTop = $(window).scrollTop();
                    if ( scrollTop >= 40 ) {
                      load_geo_popup_started = true;
                      $.post(
                        mri_moove_scripts.ajaxurl,
                        {
                          action: "mri_check_country_popup",
                          posturl: mri_moove_scripts.permalink,
                          post_id: mri_moove_scripts.post_id,
                          is_fp: mri_moove_scripts.is_fp
                        },
                        function( msg ) {
                          var obj = JSON.parse( msg );
                          // console.log(obj);
                          // console.log(obj.html);
                          if ( obj.success == true && obj.html && ! $('body').hasClass('page-template-cta-simple-template') && ! $('body').hasClass('page-template-cta-template') ) {
                            $('#geolocation-popup').empty().html(obj.html);
                            function region_format_template (state) {
                              var country_code = $(state.element).attr('data-country');

                              var $state = $('<span class="mri-country-flag f32"><i class="flag ' + country_code + '"></i>' + state.text + '</span>');
                              return $state;
                            }

                            $(document).find('.mri-region-select').select2({
                              templateResult: region_format_template,
                              minimumResultsForSearch: -1,
                              templateSelection: region_format_template
                            });
                            $(document).find('.mri-region-select').on('select2:select', function (e) {
                              var data = e.params.data;
                              if ( data.id ) {
                                var button = $('.mri-region-select-continue');
                                button.attr('href',data.id);
                                if ( data.id === '#mri-languge-selector' ) {
                                  button.attr('data-lity','').attr('data-litytype','lity-language-modal-cnt');
                                } else {
                                  button.removeAttr('data-lity').removeAttr('data-litytype');
                                }
                              }
                            });                          
                            $('body').addClass('mri-geolocation-open');
                            // var message_height = $('.geo-ip-redirect').height();
                            // $('.site-content').css('margin-top', message_height);
                            // $('header.header, header.header .header__main.sticky').css('top', message_height);
                          } else {
                            $('#geolocation-popup').empty();
                            $('body').removeClass('mri-geolocation-open');
                          }

                          if ( typeof( sessionStorage ) !== "undefined" ) {
                            sessionStorage.setItem( '_geo', 1 );
                          }
                        }
                      );
                    }
                  }
                });
              }
            }
          });
          

          $(document).on('click','.mri-region-select-continue',function(e){
            var region_selected = $(this).attr('data-litytype');

            if ( region_selected === 'lity-language-modal-cnt' ) {
              e.preventDefault();
            } else {
              mri_set_cookie('_geo',1,0);
            }
          });
          $(document).on('click','section.mri-language-popup .language-list li a',function(e){
            mri_set_cookie('_geo',1,0);
          });
          $(document).on('click','#geolocation-popup .mri-region-select-close',function(e){
            e.preventDefault();
            $('body').removeClass('mri-geolocation-open');
            // $('.site-content').css('margin-top', 0);
            // $('header.header, header.header .header__main.sticky').css('top', 0);
            mri_set_cookie('_geo',1,0);
          });

        },
        matchHeights: function() {

          $('.page-template-partners-list .js-filter-item .grid_accordion_block--trigger').matchHeight();
          $('section.mri-app-integration-module .js-filter-item .grid_accordion_block--trigger').matchHeight();
          $('.menu-item-products .products-matchheight').matchHeight();
          $('section.solution-boxes .box-content h6').matchHeight();
          $('section.solution-boxes .box-content .box-main-cnt').matchHeight();
          $('section.solution-boxes').matchHeight();
          $('.flex--multiple_columns .grid__item').matchHeight();
          // $('.social-housing-slider .shs-item').matchHeight();

          $('section.contact-locations .location-box').matchHeight();
          $('section.cards-without-icon .card-content').matchHeight();
          
          $('.mri-article-card').matchHeight();
          $('.new-mega-menu-navigation .dropdown-menu.menu-item-products').each(function(){
            $(this).find('.dropdown-submenu > li').matchHeight();
          });

          $('.section.flipping-numbers.numbers-separated-vr .mri-flipping-animate-item').matchHeight();

          $('section.quick-links .flexible-box .box-label').matchHeight();
          $('section.quick-links .flexible-box .box-title').matchHeight();
          $('section.quick-links .flexible-box').matchHeight();

          $('section.features .feature-box .box-title').matchHeight();
          $('section.features .feature-box .box-content').matchHeight();
          $('section.features .feature-box').matchHeight();

          $('section.features .feature-box').matchHeight();

          $('.mri-mh').matchHeight();
          $('.mri-mh-1').matchHeight();
          $('.mri-mh-2').matchHeight();

          $('section.section-resource-list .resource-list-cont article').matchHeight();
          $('section.section-resource-list .resource-list-cont .article-details').matchHeight();

          $('.card_equal_heights .team-member-info').matchHeight({byRow: true});

          $('.post-list-cont article .card-blog-mh').matchHeight({byRow: true});

          $('.new-mega-menu-navigation .dropdown-menu.menu-item-solution').each(function(){
            $(this).find('.dropdown-submenu > li.submenu-groups').matchHeight();
            $(this).find('.dropdown-submenu > li.submenu-groups .submenu-group-title').matchHeight();

            $('section.job-opportunities .job-body .job-meta').matchHeight();
            $('section.job-opportunities .job-body .job-title').matchHeight();
          });


          $('.top-navigation .menu-item-has-children.tiled-submenu-item ul.sub-menu li').matchHeight( {byRow: false } );

          $('.row-centered .col-centered').matchHeight();

          setTimeout(function(){
            $('.row-centered .col-centered').matchHeight();
            $('.page-template-partners-list .js-filter-item .grid_accordion_block--trigger').matchHeight();
            $('section.mri-app-integration-module .js-filter-item .grid_accordion_block--trigger').matchHeight();
          }, 1000);

          if ($(window).width() >= 768) {
            $('section.contact-boxes .box-mh').matchHeight( {byRow: false });
          }

        },
        flippingNumbers: function() {
          // FLIPPING NUMBERS
          function isInt(n) {
            return Number(n) === n && n % 1 === 0;
          }

          function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
          }

          function isScrolledIntoView($elem) {
            var returnvalue = false;
            if ( $elem.length > 0 ) {
              var docViewTop = $(window).scrollTop();
              var docViewBottom = docViewTop + mriViewportHeight();
              var elemTop = $elem.offset().top;
              returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 20));
            }
            return returnvalue;
          }

          function mri_animate_numbers($elem) {
            if (!$elem) {
              $('.mri-flipping-animate-numbers').each(function () {
                if (isScrolledIntoView($(this))) {
                  if (!$(this).hasClass('animated')) {
                    $(this).addClass('animated');
                    var duration = $(this).attr('data-duration');
                    $(this).find('.mri-flipping-animate-item').each(function () {
                      $(this).css('width',$(this).width());
                      var options = {
                        useEasing: false,
                        useGrouping: true,
                        separator: '',
                        decimal: '',
                        prefix: '',
                        suffix: ''
                      };
                      var suffix = $(this).attr('data-suffix'),
                        prefix = $(this).attr('data-prefix'),
                        number = $(this).attr('data-number'),
                        grouping = $(this).attr('data-grouping'),
                        separator = $(this).attr('data-separator'),
                        decimals = 0,
                        decimal = $(this).attr('data-decimal');
                      if (number.indexOf('.') !== -1) {
                        decimals = 1;
                      }
                      if (grouping === "true") {
                        options.useGrouping = true;
                        options.decimal = decimal;
                        options.separator = separator;
                      } else {
                        options.useGrouping = false;
                      }
                      if (prefix !== "false") {
                        options.prefix = prefix;
                      }
                      if (suffix !== "false") {
                        options.suffix = suffix;
                      }
                      var countup = new CountUp($(this).find('.mri-flipping-number-cnt')[0], 0, number, decimals, duration, options);
                      countup.start();
                    });
                  }
                }
              });
            } else {
              if (isScrolledIntoView($elem)) {
                var duration = $elem.attr('data-duration');
                $elem.find('.mri-flipping-animate-numbers').addClass('animated');
                $elem.find('.mri-flipping-animate-item').each(function () {
                  $(this).css('width',$(this).width());
                  var options = {
                      useEasing: false,
                      useGrouping: true,
                      separator: '',
                      decimal: '',
                      prefix: '',
                      suffix: ''
                  };
                  var suffix = $(this).attr('data-suffix'),
                      prefix = $(this).attr('data-prefix'),
                      number = $(this).attr('data-number'),
                      grouping = $(this).attr('data-grouping'),
                      separator = $(this).attr('data-separator'),
                      decimals = 0,
                      decimal = $(this).attr('data-decimal');
                  if (number.indexOf('.') !== -1) {
                      decimals = 1;
                  }
                  if (grouping === "true") {
                      options.useGrouping = true;
                      options.decimal = decimal;
                      options.separator = separator;
                  } else {
                      options.useGrouping = false;
                  }
                  if (prefix !== "false") {
                      options.prefix = prefix;
                  }
                  if (suffix !== "false") {
                      options.suffix = suffix;
                  }
                  var countup = new CountUp($(this).find('.mri-flipping-number-cnt')[0], 0, number, decimals, duration, options);
                  countup.start();
                });
              }
            }
          }

          mri_animate_numbers();

          $(window).scroll(function () {
            mri_animate_numbers();

            var covid_banner = $(document).find('.mri-header-covid-banner');
            var banner_height = 0;

            // if ( ! $('body').hasClass('gdpr-infobar-visible') ) {
              if ( covid_banner.length > 0 ) {
                if ( ! covid_banner.is(':visible') ) {    
                  covid_banner.slideDown(300);          
                }   
                banner_height = covid_banner.innerHeight();
                $(document).find('header#main-header').css( 'top', banner_height+'px' );
              }
            // }

          });
        },

        partners_isotope:function() {
          var grid_ids = [];
          $(document).find('section.mri-app-integration-module .card.card--accordion').matchHeight({byRow: false});
          function open_accordion(acc_hash, $grid) {

            var parent = $('.js-filter-item.grid__item.partner-'+ acc_hash );
            $('.page-template-partners-list .js-filter-item .partner-grid_accordion_block--trigger').matchHeight();
            $('section.mri-app-integration-module .js-filter-item .partner-grid_accordion_block--trigger').matchHeight();
            var __this = $('.js-filter-item.grid__item.partner-'+ acc_hash ).find('.partner-grid_accordion_block--trigger');
            var partnerwidth = parent.closest('.grid_accordion .wrapper').width(),
                partneralign = parent.closest('.grid_accordion').position().left,
                partnerblockalign = __this.closest('.grid_accordion_block').position().left,
                partnerleftalign = partneralign - partnerblockalign,
                partnerparentwidth = (__this.closest('.grid_accordion_block').width() / 2) + partnerblockalign - 15,
                itemHeight = __this.height() - 80;
            var slug = __this.attr('data-slug');

            parent.closest('.mri-post-filtering-partners').find('.grid_accordion_block').removeClass('active');
            parent.closest('.mri-post-filtering-partners').find('.grid_accordion_block--inner').css('opacity', '0');

            //scroll to top of active block
            __this.closest('.grid_accordion_block').toggleClass('active');
            // console.warn('open_accordion');
            __this.closest('.grid_accordion_block').find('.grid_accordion_block--content').css({
                'width' : partnerwidth,
                'left' : partnerleftalign
            }).find('.grid_accordion_block--inner').animate({opacity: "1"}, 150);
            __this.closest('.grid_accordion_block').find('.grid_accordion_block--content').find('.grid_accordion_block--arrow').css('left',partnerparentwidth);
            $(document).find('section.mri-app-integration-module .card.card--accordion').matchHeight({byRow: false});
            $grid.isotope();
            
            $('.page-template-partners-list .js-filter-item .partner-grid_accordion_block--trigger').matchHeight();
            $('section.mri-app-integration-module .js-filter-item .partner-grid_accordion_block--trigger').matchHeight();
          }

          if ( $('body').hasClass('page-template-template-roi-calculator-2025-energy') || $('body').hasClass('products-template-template-roi-calculator-2025-energy') ) {
            $('#building_type').each(function(){
              var placeholder = $(this).attr('placeholder');
              $(this).select2({
                minimumResultsForSearch: -1
                // placeholder: placeholder,
              });
            });

            $(document).on('change', '#building_type', function(){
              $('#building_type_ty').val( $('#building_type').val() );
            });
          }

          if ( $('body').hasClass('page-template-partners-list') || $('.mri-app-integration-module').length > 0 ) {
            $('.mri-post-filtering-partners .partners_filter select').each(function(){
              var placeholder = $(this).attr('placeholder');
              $(this).select2({
                minimumResultsForSearch: -1
                // placeholder: placeholder,
              });
            });

            

            var qs_regex;
            var button_filter;
            var region_filter = [];

            $(document).find('.mri-post-filtering-partners').each(function(){
              var id = $(this).attr('data-id');
              id = id ? id : 1;

              grid_ids.push( id );

               // init Isotope
              window['grid_'+id] = $(this).find('.post_filtering_post_wrapper.grid').isotope({
                itemSelector: '.js-filter-item',
                layoutMode: 'fitRows',
                filter: function() {
                  var $this = $(this);
                  var qs_regex_1 = $(document).find('.mri-post-filtering-partners[data-id='+id+']').find('.mri-partners-quicksearch').val();
                  
                  var qs_regex_val = new RegExp( qs_regex_1 ? qs_regex_1 : qs_regex, 'gi' );
                  var search_result   = ( qs_regex || qs_regex_1 ) ? $this.text().match( qs_regex_val ) : true;     
                  var region_results  = false;
                  var button_result   = true;
                  if ( region_filter.length > 0 ) {
                    for (var j = 0; j < region_filter.length; j++) {                  
                      if ( region_filter[j] !== '*' && ! region_results ) {
                        button_result   = $this.is( button_filter + region_filter[j] );
                        region_results  = button_result ? true : false;
                      }
                    }
                  } else {
                    button_result = button_filter ? $this.is( button_filter ) : true;
                  }

                  return search_result && button_result;
                }
              });

              var hash_has_opened = false;

              window['grid_'+id].on( 
                'arrangeComplete', 
                function( event, filteredItems ) {   
                  var target = $(event.target);
                  var id = target.closest('.mri-post-filtering-partners').attr('data-id');
                  id = id ? id : 1;
                  if( filteredItems.length > 0 ) {
                    window['grid_'+id].closest('.grid_accordion').find('.mri-partners-no-results').hide();
                  } else {
                    window['grid_'+id].closest('.grid_accordion').find('.mri-partners-no-results').show();
                  }
                  $(document).find('section.mri-app-integration-module .card.card--accordion').matchHeight({byRow: false});
                  if(window.location.hash && ! hash_has_opened) {
                    var acc_hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
                    if ( $('.js-filter-item.grid__item.partner-'+ acc_hash ).length > 0 ) {

                      $('.mri-post-filtering-partners .partners_filter select').each(function(){
                        $(this).val('*');
                        $(this).select2({
                          minimumResultsForSearch: -1
                          // placeholder: placeholder,
                        });
                      });

                      $('body,html').animate({
                        scrollTop: $('.js-filter-item.grid__item.partner-'+ acc_hash ).offset().top - 100
                      }, 300);

                      var id = $('.js-filter-item.grid__item.partner-'+ acc_hash ).closest('.mri-post-filtering-partners').attr('data-id');
                      id = id ? id : 1;

                      open_accordion(acc_hash, window['grid_'+id]);
                    }
                    hash_has_opened = true;
                  }
                });

              function mri_partner_update_filters() {
                var search_terms = [];
                region_filter = [];
                $('.mri-post-filtering-partners').each(function(){
                  var id = $(this).attr('data-id');
                  id = id ? id : 1;

                  $(this).find('.grid_accordion_block').removeClass('active');
                  // console.warn('mri_partner_update_filters');
                  $(this).find('.grid_accordion_block--content').css('width', '0');

                  $(this).find('.partners_filter select').each(function() {
                    var select_value = $(this).val();
                    if ( $(this).is('#partner-filter-region') ) {
                      if ( select_value.length > 0 ) {
                        for (var i = 0; i < select_value.length; i++) {
                          var select_v = select_value[i];
                          var region_ids = select_v.split("-");
                          if ( region_ids.length > 0 ) {
                            for (var j = 0; j < region_ids.length; j++) {
                              if ( region_ids[j] !== '*' ) {
                                region_filter.push( '.pft-' + region_ids[j] );
                              }
                            }
                          }
                        }
                      }                
                    } else {
                      if ( select_value !== '*' ) {
                        search_terms.push( '.' + select_value );
                      }
                    }
                  });

                  $(this).find('.mri-p-src-filter-dropdown select').each(function() {
                    var select_value = $(this).val();
                    if ( select_value !== '*' ) {
                      search_terms.push( '.' + select_value );
                    }
                  });

                  if ( search_terms.length < 1 ) {
                    search_terms.push('*');
                  }

                  button_filter = '';
                  for (var k = 0; k < search_terms.length; k++) {
                    button_filter += search_terms[k];
                  }
                  if ( id && typeof window['grid_'+id] !== 'undefined' ) {
                    // console.warn(id);
                    window['grid_'+id].isotope();
                  }
                });
                
              }

            $('.mri-post-filtering-partners .partners_filter select').on( 'change', function(e) {
              mri_partner_update_filters();
            });

            mri_partner_update_filters();

            $(document).on('change', '.mri-p-src-filter-dropdown select', function(){
              mri_partner_update_filters();
            });

            // use value of search field to filter
            var $quicksearch = $('#mri-partners-quicksearch, .mri-partners-quicksearch').keyup( debounce( function() {
              var parent_section = $(this).closest('section');
              parent_section.find('.grid_accordion_block').removeClass('active');
              // console.warn('mri-partners-quicksearch');
              parent_section.find('.grid_accordion_block--content').css('width', '0');
              qs_regex = new RegExp( $(this).val(), 'gi' );
              console.warn(qs_regex);
              var id = $(this).closest('.mri-post-filtering-partners').attr('data-id');
              id = id ? id : 1;
              window['grid_'+id].isotope();
            }) );   

            // debounce so filtering doesn't happen every millisecond
            function debounce( fn, threshold ) {
              var timeout;
              threshold = threshold || 100;
              return function debounced() {
                clearTimeout( timeout );
                var args = arguments;
                var _this = this;
                function delayed() {
                  fn.apply( _this, args );
                }
                timeout = setTimeout( delayed, threshold );
              };
            }

            function partner_grid_accordion_resize(){
              $('.grid_accordion_block').removeClass('active');
              // console.warn('partner_grid_accordion_resize');
              $('.grid_accordion_block--content').css('width', '0');
              if ( grid_ids ) {
                var i = 0;
                while (i < grid_ids.length) {
                  window['grid_'+grid_ids[i]].isotope();
                  i++;
                }
              }            
            }

            

            

            $(window).on("resize", function() {
                partner_grid_accordion_resize();
            });
            });
    

            function partner_grid_accordion(){
              var $ = jQuery;
              $('.mri-post-filtering-partners .partner-grid_accordion_block--trigger').each(function(){
                var $trigger = $(this);

                $trigger.on('click', function(e) {
                    var id = $(this).closest('.mri-post-filtering-partners').attr('data-id');
                    id = id ? id : 1;
                    var section = $(this).closest('.mri-post-filtering-partners');
                    $('.page-template-partners-list .js-filter-item .partner-grid_accordion_block--trigger').matchHeight();
                    $('section.mri-app-integration-module .js-filter-item .partner-grid_accordion_block--trigger').matchHeight();

                    e.preventDefault();
                    var partnerwidth = section.find('.grid_accordion .wrapper').width(),
                        partneralign = section.find('.grid_accordion').position().left,
                        partnerblockalign = $(this).closest('.grid_accordion_block').position().left,
                        partnerleftalign = partneralign - partnerblockalign,
                        partnerparentwidth = ($(this).closest('.grid_accordion_block').width() / 2) + partnerblockalign - 15,
                        itemHeight = $(this).height() - 80;

                    var slug = $(this).attr('data-slug');

                    if( $(this).closest('.grid_accordion_block').hasClass('active')){
                        $(this).closest('.grid_accordion_block').removeClass('active');
                        section.find('.grid_accordion_block').removeClass('active');
                        $(this).closest('.grid_accordion_block').find('.grid_accordion_block--content').css('width', '0');

                    }else{

                        section.find('.grid_accordion_block').removeClass('active');
                        section.find('.grid_accordion_block--inner').css('opacity', '0');

                        //scroll to top of active block
                        $(this).closest('.grid_accordion_block').addClass('active');
   
                        var p_style = 'width: ' + partnerwidth + 'px;left:' + partnerleftalign+ 'px';

                        $(this).closest('.grid_accordion_block').find('.grid_accordion_block--content').attr('style', p_style);
                        $(this).closest('.grid_accordion_block').find('.grid_accordion_block--inner').animate({opacity: "1"}, 150);

                        $(this).closest('.grid_accordion_block').find('.grid_accordion_block--content').find('.grid_accordion_block--arrow').css('left',partnerparentwidth);
                    }
                    window['grid_'+id].isotope();
                });

              });
              $('.grid_accordion_block--close').on('click', function() {
                var closest_section = $(this).closest('.mri-post-filtering-partners');
                closest_section.find('.grid_accordion_block').removeClass('active');
                $(this).parent('.grid_accordion_block--content').css('width', '0');
                var id = $(this).closest('.mri-post-filtering-partners').attr('data-id');
                id = id ? id : 1;
                window['grid_'+id].isotope();
              });
            }

            partner_grid_accordion();
            
          }
        },
        support_numbers_isotope: function() {
          var qs_regex;
          var button_filter;
          var region_filter = [];
          var grid_ids = [];

          $(document).find('.sn-cards-wrap').each(function(){
            var id = $(this).attr('data-id');
            id = id ? id : 1;

            grid_ids.push( id );

             // init Isotope
            window['grid_'+id] = $(this).find('.sbc-grid').isotope({
              itemSelector: '.sn-number-card-wrp',
              layoutMode: 'masonry',
              filter: function() {
                var $this = $(this);
                var qs_regex_1 = $(document).find('.sn-cards-wrap[data-id='+id+']').find('.snc__search--input').val();
                
                var qs_regex_val = new RegExp( qs_regex_1 ? qs_regex_1 : qs_regex, 'gi' );
                var search_result   = ( qs_regex || qs_regex_1 ) ? $this.text().match( qs_regex_val ) : true;     
                var region_results  = false;
                var button_result   = true;
                if ( region_filter.length > 0 ) {
                  for (var j = 0; j < region_filter.length; j++) {                  
                    if ( region_filter[j] !== '*' && ! region_results ) {
                      button_result   = $this.is( button_filter + region_filter[j] );
                      region_results  = button_result ? true : false;
                    }
                  }
                } else {
                  button_result = button_filter ? $this.is( button_filter ) : true;
                }

                return search_result && button_result;
              }
            });

            // use value of search field to filter
            var $quicksearch = $('.snc__search--input').keyup( debounce( function() {
              qs_regex = new RegExp( $(this).val(), 'gi' );
              console.warn(qs_regex);
              var id = $(this).closest('.sn-cards-wrap').attr('data-id');
              id = id ? id : 1;
              window['grid_'+id].isotope();
            }) );   

            // debounce so filtering doesn't happen every millisecond
            function debounce( fn, threshold ) {
              var timeout;
              threshold = threshold || 100;
              return function debounced() {
                clearTimeout( timeout );
                var args = arguments;
                var _this = this;
                function delayed() {
                  fn.apply( _this, args );
                }
                timeout = setTimeout( delayed, threshold );
              };
            }

            $(document).on('click','.sn-numbers-cards .snnb-accordion > a', function(e){
              e.preventDefault();
              if ( $(this).closest('.snnb-accordion').hasClass('snbb-open') ) {
                $(this).closest('.snnb-accordion').removeClass('snbb-open');
                $(this).closest('.snnb-accordion').find('ul').slideUp(0);
              } else {
                $(this).closest('.snnb-accordion').addClass('snbb-open');
                $(this).closest('.snnb-accordion').find('ul.snbb-acc').slideDown(0);
              }
              var id = $(this).closest('.sn-cards-wrap').attr('data-id');
              window['grid_'+id].isotope('layout');            
              
            });
          });
        },
        ga4_utm: function(){
          /**
           * Configuration
           */
          var INTERNAL_HOSTNAME = "www.mrisoftware.com"; // ONLY this hostname is internal

          // The session's source/medium is carried to later pages in sessionStorage.
          // Writing it onto every internal link instead gave each page a new URL, so
          // every click missed the page cache and was rebuilt from scratch.
          var STORAGE_KEY = "mri_lcf_utm";

          /**
           * Phase II: referrer -> source/medium for untagged sessions
           * Mediums keep a real space ("Organic Search"); persistToCurrentUrl encodes
           * it as %20, which is what Pardot already receives correctly.
           */
          // Authoritative exact-hostname table from the MRI marketing team.
          var REFERRER_EXACT = {
            "www.google.com":        { source: "google",                medium: "Organic Search" },
            "search.google.com":     { source: "search.google.com",     medium: "Organic Search" },
            "gemini.google.com":     { source: "gemini.google.com",     medium: "AI Assistant" },
            "www.bing.com":          { source: "bing",                  medium: "Organic Search" },
            "cn.bing.com":           { source: "cn.bing.com",           medium: "Organic Search" },
            "search.yahoo.com":      { source: "yahoo",                 medium: "Organic Search" },
            "in.search.yahoo.com":   { source: "in.search.yahoo.com",   medium: "Organic Search" },
            "ph.search.yahoo.com":   { source: "ph.search.yahoo.com",   medium: "Organic Search" },
            "es.search.yahoo.com":   { source: "es.search.yahoo.com",   medium: "Organic Search" },
            "us.search.yahoo.com":   { source: "us.search.yahoo.com",   medium: "Organic Search" },
            "hk.search.yahoo.com":   { source: "hk.search.yahoo.com",   medium: "Organic Search" },
            "nz.search.yahoo.com":   { source: "nz.search.yahoo.com",   medium: "Organic Search" },
            "ntp.msn.com":           { source: "ntp.msn.com",           medium: "Organic Search" },
            "duckduckgo.com":        { source: "duckduckgo",            medium: "Organic Search" },
            "chatgpt.com":           { source: "chatgpt.com",           medium: "AI Assistant" },
            "www.ecosia.org":        { source: "ecosia.org",            medium: "Organic Search" },
            "m.facebook.com":        { source: "m.facebook.com",        medium: "Organic Social" },
            "l.facebook.com":        { source: "l.facebook.com",        medium: "Organic Social" },
            "www.facebook.com":      { source: "facebook.com",          medium: "Organic Social" },
            "search.brave.com":      { source: "brave",                 medium: "Organic Search" },
            "www.aol.com":           { source: "aol",                   medium: "Organic Search" },
            "claude.ai":             { source: "claude.ai",             medium: "AI Assistant" },
            "www.perplexity.ai":     { source: "perplexity.ai",         medium: "AI Assistant" },
            "yandex.com":            { source: "yandex",                medium: "Organic Search" },
            "www.qwant.com":         { source: "qwant.com",             medium: "Organic Search" },
            "www.baidu.com":         { source: "baidu",                 medium: "Organic Search" },
            "copilot.com":           { source: "copilot.com",           medium: "AI Assistant" },
            "copilot.microsoft.com": { source: "copilot.microsoft.com", medium: "AI Assistant" },
            "www.naver.com":         { source: "naver",                 medium: "Organic Search" },
            "www.linkedin.com":      { source: "linkedin",              medium: "Organic Social" },
            "lnkd.in":               { source: "lnkd.in",               medium: "Organic Social" },
            "www.reddit.com":        { source: "reddit.com",            medium: "Organic Social" },
            "www.instagram.com":     { source: "instagram.com",         medium: "Organic Social" },
            "t.co":                  { source: "t.co",                  medium: "Organic Social" }
          };

          // Fallback for ccTLD / regional engine variants the table does not list.
          // Anchored so mail./docs./news./gemini.google.* do NOT match.
          var REFERRER_PATTERNS = [
            { re: /^(www\.)?google(\.[a-z]{2,3}){1,2}$/,              source: "google",     medium: "Organic Search" },
            { re: /^([a-z]{2,3}\.)?bing\.com$/,                       source: "bing",       medium: "Organic Search" },
            { re: /^([a-z]{2,}\.)?search\.yahoo(\.[a-z]{2,3}){1,2}$/, source: "yahoo",      medium: "Organic Search" },
            { re: /^([a-z]+\.)?duckduckgo\.com$/,                     source: "duckduckgo", medium: "Organic Search" },
            { re: /^(www\.)?ecosia\.org$/,                            source: "ecosia.org", medium: "Organic Search" },
            { re: /^(www\.)?qwant\.com$/,                             source: "qwant.com",  medium: "Organic Search" },
            { re: /^(www\.)?yandex(\.[a-z]{2,3}){1,2}$/,              source: "yandex",     medium: "Organic Search" },
            { re: /^(www\.)?baidu\.com$/,                             source: "baidu",      medium: "Organic Search" },
            { re: /^(search\.)?naver\.com$/,                          source: "naver",      medium: "Organic Search" }
          ];

          // Android in-app browsers report document.referrer as android-app://<package>.
          // Browsers, Gmail and Docs/Drive are deliberately absent so they stay untagged.
          var ANDROID_APP_MAP = {
            "com.facebook.katana":                     { source: "facebook.com",  medium: "Organic Social" },
            "com.facebook.lite":                       { source: "facebook.com",  medium: "Organic Social" },
            "com.instagram.android":                   { source: "instagram.com", medium: "Organic Social" },
            "com.linkedin.android":                    { source: "linkedin",      medium: "Organic Social" },
            "com.reddit.frontpage":                    { source: "reddit.com",    medium: "Organic Social" },
            "com.twitter.android":                     { source: "t.co",          medium: "Organic Social" },
            "com.google.android.googlequicksearchbox": { source: "google",        medium: "Organic Search" },
            "com.microsoft.bing":                      { source: "bing",          medium: "Organic Search" },
            "com.duckduckgo.mobile.android":           { source: "duckduckgo",    medium: "Organic Search" },
            "com.openai.chatgpt":                      { source: "chatgpt.com",   medium: "AI Assistant" },
            "com.microsoft.copilot":                   { source: "copilot.com",   medium: "AI Assistant" }
          };

          // Source present but medium empty -> force medium "AI Assistant".
          var AI_SOURCE_MEDIUM_BACKFILL = {
            "chatgpt.com": true,
            "copilot.com": true,
            "perplexity": true,
            "perplexity.ai": true
          };

          // Own-property lookup, so a value like "constructor" can't hit Object.prototype.
          var lookup = function(map, key) {
            return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : null;
          };

          /**
           * Query helpers (ES5-safe)
           */
          // Tolerate malformed escapes (e.g. "?q=100%") so they don't cost the visit
          // its attribution.
          var safeDecode = function(str) {
            str = str.replace(/\+/g, " ");
            try {
              return decodeURIComponent(str);
            } catch (e) {
              return str;
            }
          };

          var parseQuery = function(search) {
            var params = {};
            if (!search) return params;
            if (search.charAt(0) === "?") search = search.slice(1);
            if (!search) return params;
            var parts = search.split("&");
            for (var i = 0; i < parts.length; i++) {
              if (!parts[i]) continue;
              // Split on the first "=" only, so values containing "=" survive intact
              var eq = parts[i].indexOf("=");
              var key = safeDecode(eq === -1 ? parts[i] : parts[i].slice(0, eq));
              var val = safeDecode(eq === -1 ? "" : parts[i].slice(eq + 1));
              if (!params[key]) params[key] = [];
              params[key].push(val);
            }
            return params;
          };

          var getParam = function(params, key) {
            return params[key] && params[key].length ? params[key][0] : "";
          };

          var hasParam = function(params, key) {
            return !!(params[key] && params[key].length);
          };

          /**
           * Helpers
           */
          var hasNonEmpty = function(qs, key) {
            var v = (getParam(qs, key) || "").trim();
            return v.length > 0;
          };

          var hasAnyRelevant = function(qs) {
            var keys = ["utm_source", "utm_medium", "lcf_utm_source", "lcf_utm_medium"];
            for (var i = 0; i < keys.length; i++) {
              if (hasNonEmpty(qs, keys[i])) return true;
            }
            return false;
          };

          // "utm wins" over lcf per parameter
          var winningValue = function(qs, utmKey, lcfKey) {
            var utmVal = (getParam(qs, utmKey) || "").trim();
            if (utmVal) return utmVal;
            var lcfVal = (getParam(qs, lcfKey) || "").trim();
            if (lcfVal) return lcfVal;
            return "";
          };

          // Returns { source, medium } or null. Null means the session stays
          // untagged: an empty or unknown referrer is never labelled Direct.
          var classifyReferrer = function(ref) {
            if (!ref) return null; // no-referrer policy, most iOS apps

            var lower = ref.toLowerCase();

            // Android in-app browsers: android-app://<package>/...
            if (lower.indexOf("android-app://") === 0) {
              return lookup(ANDROID_APP_MAP, lower.slice(14).split("/")[0]);
            }

            var refUrl = document.createElement("a");
            refUrl.href = ref;
            var host = (refUrl.hostname || "").toLowerCase();

            // Internal navigation is not a referral
            if (!host || host === INTERNAL_HOSTNAME) return null;

            // Exact table first (www/non-www tolerant), so AI/social hosts win
            var hit = lookup(REFERRER_EXACT, host) ||
              lookup(REFERRER_EXACT, host.replace(/^www\./, "")) ||
              lookup(REFERRER_EXACT, "www." + host);
            if (hit) return hit;

            for (var i = 0; i < REFERRER_PATTERNS.length; i++) {
              if (REFERRER_PATTERNS[i].re.test(host)) {
                return { source: REFERRER_PATTERNS[i].source, medium: REFERRER_PATTERNS[i].medium };
              }
            }

            return null;
          };

          // Writes the derived or session-stored lcf_utm_* onto the current URL,
          // where the forms and Pardot iframes read them. No reload, no new history
          // entry; GA4 ignores lcf_ params.
          var persistToCurrentUrl = function(source, medium) {
            var qs = parseQuery(window.location.search);
            var added = [];
            if (source && !hasParam(qs, "lcf_utm_source")) {
              added.push("lcf_utm_source=" + encodeURIComponent(source));
            }
            if (medium && !hasParam(qs, "lcf_utm_medium")) {
              added.push("lcf_utm_medium=" + encodeURIComponent(medium));
            }
            if (!added.length) return;

            // Append to the raw query string rather than re-serialising it, so the
            // params already there (gclid, tokens, ...) stay byte-for-byte intact.
            var search = window.location.search;
            var newSearch = (search && search !== "?" ? search + "&" : "?") + added.join("&");
            try {
              window.history.replaceState(window.history.state, "", window.location.pathname + newSearch + window.location.hash);
            } catch (e) {
              // The URL can't be rewritten: this page's forms go unattributed, but
              // the values are still stored for the next page
            }
          };

          // Returns { source, medium } stored by an earlier page in this tab, or null.
          var readStored = function() {
            try {
              var stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
              if (stored && typeof stored.source === "string" && typeof stored.medium === "string") {
                return { source: stored.source, medium: stored.medium };
              }
            } catch (e) {
              // Storage blocked or value malformed: treat the page as untagged
            }
            return null;
          };

          var storeForSession = function(source, medium) {
            try {
              window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ source: source, medium: medium }));
            } catch (e) {
              // Storage blocked: attribution then covers the landing page only
            }
          };

          /**
           * Resolve source/medium: URL params first, then an external referrer,
           * then what an earlier page in this session stored
           */
          var currentQS = parseQuery(window.location.search);

          var lcfSourceValue = winningValue(currentQS, "utm_source", "lcf_utm_source");
          var lcfMediumValue = winningValue(currentQS, "utm_medium", "lcf_utm_medium");
          var derivedSomething = false;

          // Phase II: only when the URL carries no utm_* and no lcf_* at all.
          // An internal referrer classifies as null, so it falls through to storage.
          if (!hasAnyRelevant(currentQS)) {
            var derived = classifyReferrer(document.referrer) || readStored();
            if (derived) {
              lcfSourceValue = derived.source;
              lcfMediumValue = derived.medium;
              derivedSomething = true;
            }
          }

          // AI source-only backfill; also applies to a real inbound utm_source
          if (lcfSourceValue && !lcfMediumValue && lookup(AI_SOURCE_MEDIUM_BACKFILL, lcfSourceValue.toLowerCase())) {
            lcfMediumValue = "AI Assistant";
            derivedSomething = true;
          }

          // Nothing to persist -> leave the session untagged
          if (!lcfSourceValue && !lcfMediumValue) return;

          storeForSession(lcfSourceValue, lcfMediumValue);

          // Fully-tagged Phase I URLs are never rewritten
          if (derivedSomething) {
            persistToCurrentUrl(lcfSourceValue, lcfMediumValue);
          }
        },
        animated_image: function() {
          // Build point to be added to map
          function addPoint(sCX, sCY, scToolTipText, scURL, sNum, svg, svg_p ) {

            var box     = svg.viewBox.baseVal;
            var width   = svg_p.find('svg').innerWidth();
            var height  = svg_p.find('svg').innerHeight();
            if ( 'undefined' !== box.width ) {
              width = box.width;
            }

            if ( 'undefined' !== box.height ) {
              height = box.height;
            }



            var _sCX = ( sCX * 100 ) / width;
            var _sCY = ( sCY * 100 ) / height;
            svg_p.append('<span class="svg-marker" style="left: '+_sCX+'%; top: '+_sCY+'%" data-scx="'+sCX+'"  data-scy="'+sCY+'" data-title="'+scToolTipText+'" data-tid="'+scURL+'"><span></span></span>');
          }

          $(document).on('click','section.interactive-image .iw-tab-header .tab-toggler', function(e) {
            e.preventDefault();
            var parent = $(this).closest('li');
            var filter = parent.attr('data-filter');
            var is_open = parent.hasClass('iw-open');
            var accordion = $(this).closest('ul');
            var circle_menu = $(this).closest('section').find('.circle-menu');

            circle_menu.find('.iw-active').removeClass('iw-active');
            circle_menu.find('.iw-active-li').removeClass('iw-active-li');

            accordion.find('li.iw-open').each(function(){
              $(this).removeClass('iw-open');
              $(this).find('.iw-tab-content').slideUp(300);
            });
            if ( ! is_open ) {
              parent.addClass('iw-open').find('.iw-tab-content').slideDown(300);
              circle_menu.find('.circle-menu-middle-content [data-filter]').fadeOut(300);
              circle_menu.find('.circle-menu-middle-content [data-filter='+filter+']').fadeIn(300);
              circle_menu.find('.circle-menu-nav .cmn-toggle').removeClass('iw-focus');
              circle_menu.find('.circle-menu-nav .cmn-toggle:not([data-filter='+filter+'])').addClass('iw-focus');          
            } else {
              circle_menu.find('.circle-menu-middle-content [data-filter]').fadeOut(300);
              circle_menu.find('.circle-menu-middle-content [data-filter="default"]').fadeIn(300);
              circle_menu.find('.circle-menu-nav .cmn-toggle').removeClass('iw-focus');
            }
          });

          $(document).on('click', 'section.interactive-image .si-svg-main .svg-marker', function(e){
            e.preventDefault();
            var id = $(this).attr('data-tid');
            if ( id ) {
              var _section = $(this).closest('section');
              $('.lity-close').trigger('click');
              var modal_cnt = _section.find('.lity-modal-cnt');
              if ( modal_cnt.length > 0 ) {
                modal_cnt.empty();
                var accordion_content = _section.find('.mri-accordion-wrap li[data-filter='+id+']').html();
                if ( accordion_content && _section.find('.mri-accordion-wrap').is(':visible') ) {

                  var _accordion = _section.find('.mri-accordion-wrap li[data-filter='+id+']').closest('ul');
                  var circle_menu = _section.find('.mri-accordion-wrap li[data-filter='+id+']').closest('section').find('.circle-menu');

                  _accordion.find('li.iw-open').each(function(){
                    $(this).removeClass('iw-open');
                    $(this).find('.iw-tab-content').hide();
                  });

                  _section.find('.mri-accordion-wrap li[data-filter='+id+'] .iw-tab-header .tab-toggler').trigger('click');
                  $('body,html').animate({
                    scrollTop: _section.find('.mri-accordion-wrap li[data-filter='+id+']').offset().top - 100,
                  }, 300);
                } else {
                  if ( accordion_content ) {
                    modal_cnt.html('<ul class="mri-interactive-image-modal">' + accordion_content + '</ul>');
                    id = modal_cnt.attr('id');
                    $('html').addClass('interactive-image-modal');
                    lity( '#' + id );
                  }
                }
              }
            }
          });

          $(document).find('section.interactive-image').each(function(){
            var svg = $(this).find('.si-svg .si-svg-main > svg');
            var svg_p = $(this).find('.si-svg .si-svg-main');
            var sid = $(this).attr('data-sid');
            if ( svg.length > 0 ) {
              var svg = svg[0];
              var markers = $(this).find('.si-svg .si-svg-json').html();
              if ( markers ) {
                var markers_obj = JSON.parse(markers);
                markers_obj.forEach(function (key, index) {
                  var _value = markers_obj[index];
                  addPoint( _value.sCX, _value.sCY, _value.scToolTipText,  _value.scURL, _value.sNum, svg, svg_p );
                });
              }
            }
          });
        },
        select2: function(){

          if(window.innerWidth >= 768){

            $('.page-template-partners-list .post_filter_filter .select--filter').select2({minimumResultsForSearch: -1});
            $('section.mri-app-integration-module .post_filter_filter .select--filter').select2({minimumResultsForSearch: -1});

            $('.filter-section .filter-cont select').select2({minimumResultsForSearch: -1});          

            $('.filter-section .filter-cont .filter-open').click(function(){
              $(this).closest('.filter-group').find('select').data('select2').toggleDropdown();
            });

            $('.page-template-shop-detail-order .order-select').select2({minimumResultsForSearch: -1});

          } else {
              
            // $('.filter-section .filter-cont .filter-open').click(function(){
            //   $('.filter-section .filter-cont select').trigger('click');
            // });
          }

        },
        lazyLoad: function() {

            $(document).on('click','.load-more-cta-wrap-b button', function(e){
              var url = $(this).attr('data-href');
              var button = $(this);
              var paged = $(this).attr('data-paged');
              var max_paged = $(this).attr('data-maxnum');
              url = url + '?side=' + ( parseInt( paged ) + 1 );

              if ( !$('body').hasClass('ajax-loading') ) {
                var preloader      = $('.ajax-preloader')
                preloader.fadeIn();
                $('.load-more-cta-wrap-b button').addClass('disabled');
                var timer = setTimeout(function () {
                  
                  $('.post-list-cont-bottom').load(url + ' .post-list-cont', function(){
                    // console.warn('select-change');

                    var loader_section = $('.section-post-list .post-list-cont-bottom');

                    var parent_listing = loader_section.closest('.section-post-list > .post-list-cont');

                    loader_section.find('article').each(function(){
                      parent_listing.append( $(this) );
                    });
                    var next_page = $('.post-list-cont-bottom').find('.post-list-cont').attr('data-paged');

                    $('.load-more-cta-wrap-b button').attr('data-paged', next_page);

                    if ( ( parseInt(next_page) + 1 ) > parseInt( max_paged )  ) {
                      button.hide();
                    }

                    $('.post-list-cont-bottom').empty();

                    $('.load-more-cta-wrap-b button').removeClass('disabled');
                    preloader.fadeOut();
                  });

                }, 500);
              }

            });

            var ajaxurl = mri_moove_scripts.ajaxurl ;
            var doc = $(document), w = $(window), timer;
            var preloader      = $('.ajax-preloader');
            var post_type      = 'post';
            var current_page   = 1;
            var action         = null;
            var list_cont      = $('.lazy-load-cont');
            var auto_load      = false;
            var tax            = null;
            var term           = null;
            var filter         = [];
            var search         = null;
            var post_per_page  = null;
            var exclude        = [];
            var permalink      = mri_moove_scripts.permalink; 
            var featured_posts = [];
            var featured_res   = [];
            var online_events_loaded = false;
            var page_id        = $('body').attr('data-postid');

            function update_events_url_history( permalink ) {
              var new_link = permalink;
              // if( $('#region-filter').val() !== 'all' ) {
                // new_link = new_link + 'region/' + $('#region-filter').val() + '/';
              // }

              if( $('#sector-filter').val() !== 'all' ) {
                new_link = new_link + 'sector/' + $('#sector-filter').val() + '/';
              }

              if( $('#format-filter').val() !== 'all' ) {
                new_link = new_link + 'format/' + $('#format-filter').val() + '/';
              }


              history.pushState(null, null, new_link );  
            }

            function autoLoad() {

              if ( $('.load-more-cta-wrap').length > 0 ) {
                $('.load-more-cta-wrap').on('click', 'a', function(e){
                  e.preventDefault();

                  if ( !$('body').hasClass('ajax-loading') && list_cont.attr('data-max-pages') > 1 && current_page < list_cont.attr('data-max-pages') ) {

                    var __link = $(this).attr('data-pr');
                    var __paged = $('.lazy-load-cont').attr('data-paged');
                    var __button = $(this);

                    preloader.fadeIn();
                    $('.load-more-cta-wrap a').addClass('disabled');
                    timer = setTimeout(function () {
                        $('.lazy-load-cont').attr('data-paged', parseInt( $('.lazy-load-cont').attr('data-paged' ) ) + 1);
                        if ( __link ) {
                          var __cr_link = __link + "side/" + ( parseInt( __paged ) + 1 ) + "/";
                          var __new_link = __link + "side/" + ( parseInt( __paged ) + 2 ) + "/";
                          __button.attr( 'href', __new_link );
                          $('link[rel="canonical"]').attr('href', __cr_link);
                        }

                        loadList();


                      }, 500);
                    } 

                    

                    
                });
              } else {
                doc.on('scroll', function () {
                  var footer_top  = $('footer.site-footer').offset().top;
                  var list_bottom = list_cont.offset().top + list_cont.outerHeight();
                  
                  if (doc.scrollTop() + w.height() >= list_bottom && auto_load ) {

                    if (typeof timer !== 'undefined') {
                      clearTimeout(timer);
                    }

                    if ( !$('body').hasClass('ajax-loading') && list_cont.attr('data-max-pages') > 1 && current_page < list_cont.attr('data-max-pages') ) {

                      preloader.fadeIn();
                      $('.load-more-cta-wrap a').addClass('disabled');
                      timer = setTimeout(function () {
                        current_page++;
                        $('.lazy-load-cont').attr('data-paged', $('.lazy-load-cont').attr('data-paged' ) + 1);
                        loadList();

                      }, 500);

                    } 

                  }
                });
              }

             
            }

            function afterAutoload() {

              if ( $('body').hasClass('page-template-events-list') ) {
                $(document).find('.mri-no-results-label').addClass('hide');
                $('body').addClass('ajax-loading');
                $('body').attr('data-s', $(window).scrollTop());
                $.get(ajaxurl, {
                  action: 'load_online_event_list',
                  post_type: post_type,
                  page: current_page,
                  search: search,
                  filter: filter,
                  post_per_page: post_per_page,
                  exclude: exclude
                }, function (data) {

                  online_events_loaded = true;

                  $('body').removeClass('ajax-loading');

                  if ( post_type === 'resources' ) {
                    $('body,html').animate({
                      scrollTop: $('body').attr('data-s'),
                    }, 300);
                  }

                  if ( data.items.length <= 0 ) {
                    $(document).find('.mri-no-results-label').removeClass('hide');
                  }

                  $.each(data.items, function(i, v) {
                    list_cont.append(v);
                  });
                  preloader.fadeOut();
                  $('.load-more-cta-wrap a').removeClass('disabled');

                }, 'JSON');
              }

            }

            function loadList() {
                $('body').addClass('ajax-loading');
                $('body').attr('data-s', $(window).scrollTop());
                var url = permalink;
                if ( post_type === 'post' ) {
                  var _listing_wrap = $('.mri-archive-page');
                  var _sector = _listing_wrap.attr('data-sector');
                  var _search = _listing_wrap.attr('data-search');
                  if ( _sector && _sector != '' ) {
                    var fltr = {};
                    fltr.tax  = 'sector';
                    fltr.term = _sector;
                    filter.push(fltr);
                  }

                  if ( _search && _search != '' ) {
                    search = _search;
                  }
                }

                if ( post_type === 'event' ) {
                  search = '';
                }

                var _current_page = $('.lazy-load-cont').attr('data-paged');

                current_page = parseInt( _current_page ) ? parseInt( _current_page ) : current_page;


                $.get(ajaxurl, {
                  action: action,
                  post_type: post_type,
                  side: current_page,
                  // page: current_page,
                  search: search,
                  filter: filter,
                  featured_res: featured_res,
                  page_id: page_id,
                  post_per_page: post_per_page,
                  exclude: exclude
                }, function (data) {
                  $('body').removeClass('ajax-loading');
                  if ( post_type === 'resources' ) {
                    $('body,html').animate({
                      scrollTop: $('body').attr('data-s'),
                    }, 300);
                  }
                  if( filter.length > 0 )  {
                    if( !$('.featured-list-cont').hasClass('hide') ) {
                      $('.featured-list-cont').addClass('hide');
                    }
                  } else {
                    $('.featured-list-cont').removeClass('hide');
                  }

                  list_cont.attr('data-max-pages', data.max_pages );                
                  if(data.items.length > 0) {
                    $.each(data.items, function(i, v) {
                      list_cont.append(v);
                    });
                    auto_load = true;
                  } else {
                    list_cont.append('<h3 class="mri-no-results-label">Sorry, no results were found.</h3>');
                    auto_load = false;
                  }

                  $('.lazy-load-cont').attr('data-paged', data.current_page);

                  if( data.last_page === true ) {
                    afterAutoload();
                    $('.load-more-cta-wrap a').hide().removeAttr('href');
                  } else {
                    $(document).find('.mri-no-results-label').removeClass('hide');
                    $('.load-more-cta-wrap a').show();
                  }

                 
                  if ( $('body').hasClass('page-template-resources-list') ) {
                    update_resource_url_history(permalink);
                  } else {
                    if ( $('body').hasClass('page-template-events-list') ) {
                      update_events_url_history(permalink);
                    } else {
                      var new_link = permalink;
                      if ( $('.widget-sector-filters').find('li.active').length ) {
                        var new_link = $('.widget-sector-filters').find('li.active a').attr('href');
                      } 

                      $.each( filter, function(i,v) {
                        if( v.tax === 'resource_type' ) {
                          new_link = new_link + 'type/' + v.term + '/';
                        }
                      });

                      if ( $('#search-list').val() !== '' ) {
                         new_link = new_link + 'search/' + $('#search-list').val() + '/';
                      }

                      if ( $('.load-more-cta-wrap').length > 0 ) {
                        var page = $('.lazy-load-cont').attr('data-paged');
                        if ( page && parseInt( page ) > 1 ) {
                          new_link = new_link + 'side/' + page + '/';
                        }
                      }

                      history.pushState(null, null, new_link );
                    }
                  }

                  
                  
                  Sage.common.matchHeights();

                  preloader.fadeOut();
                  $('.load-more-cta-wrap a').removeClass('disabled');

                  if ( action === 'load_post_list' && post_type === 'news' ) {
                    $('.post-list-cont').find('article').each(function(){
                      var _art_id = $(this).attr('id');
                      $('[id="' + _art_id + '"]:gt(0)').remove();
                    });
                  }

                }, 'JSON');
            }

            function loadPopularList( post_type, post_id, sector ) {

                var popular_list_cont = $('.side-box.most-popular-box .most-popular-list-cont');

                $.get(ajaxurl, {
                  action: 'load_popular_list',
                  post_type: post_type,
                  sector: sector,
                  exclude: post_id
                }, function (data) {

                  popular_list_cont.empty();

                  $.each(data.items, function(i, v) {
                    popular_list_cont.append(v);
                  });

                  if(sector && data.items.length == 0 ) {
                    loadPopularList( post_type, post_id, null );
                  }

                }, 'JSON');
            }

            $(document).on('click', '.mri-sidebar-main button[data-cat]', function(e){
              e.preventDefault();
              var slug = $(this).attr('data-cat');
              $('#solution-filter').val(slug).trigger('change');
              $(this).closest('ul').find('.active').removeClass('active');
              $(this).closest('li').addClass('active');
            });


            function update_resource_url_history( permalink ) {
              var new_link = permalink;
              if( $('#type-filter').val() !== 'all' ) {
                new_link = new_link + 'type/' + $('#type-filter').val() + '/';
              }

              if( $('#solution-filter').val() !== 'all' ) {
                new_link = new_link + 'category/' + $('#solution-filter').val() + '/';
              }
              var srval = $('#search-list').val();
              if ( srval.trim() !== '' ) {
                new_link = new_link + 'search/' + srval.trim() + '/';
              }

              if ( $('.load-more-cta-wrap').length > 0 ) {
                var page = $('.lazy-load-cont').attr('data-paged');
                if ( page && parseInt( page ) > 1 ) {
                  new_link = new_link + 'side/' + page + '/';
                }
              }
              history.pushState(null, null, new_link );  
            }

            if( typeof list_cont.attr('data-exclude') !== typeof undefined && list_cont.attr('data-exclude') !== false ) {
              exclude = list_cont.attr('data-exclude').split(',');
            }

            $('.filter-form').submit( function() {
              var form = $(this);
              current_page = 1;
              $('.lazy-load-cont').attr('data-paged', 1);

              online_events_loaded = false;
              search = form.find('#search-list').val();
              filter = [];


              $(form.find('.filter-field')).each( function() {
                var term = $(this).val();
                if( term !== 'all' && term !== '' ) {
                  var fltr = {};
                  fltr.tax = $(this).attr('data-tax');
                  fltr.term = $(this).val();
                  filter.push(fltr);
                } 
              });

              if ( !$('body').hasClass('ajax-loading') ) {
                list_cont.empty();
                preloader.fadeIn();
                $('.load-more-cta-wrap a').addClass('disabled');
                timer = setTimeout(function () {
                  loadList();
                }, 500);
              }
              
              return false;
            });

            $('.filter-form select.filter-field').each( function() {

              var term = $(this).val();
              if( term !== 'all' && term !== '' ) {
                var fltr = {};
                fltr.tax = $(this).attr('data-tax');
                fltr.term = $(this).val();
                filter.push(fltr);
              } 

            });

            $('.filter-form select.filter-field').change( function() {
              $(this).closest('form').submit();
              $('.featured-list-cont').addClass('hide');

              if ( $('body').hasClass('page-template-news-list') || $('body').hasClass('page-template-blog-list') ) {
                if( $(this).is('#sector-filter') ) {
                  var popular_sector = null;
                  if( $(this).val() !== 'all' ) {
                    popular_sector = $(this).val();
                  }
                  loadPopularList( post_type, null, popular_sector );
                }
              }
              if ( $('body').hasClass('page-template-resources-list') ) {
                update_resource_url_history(permalink);
              } 

              $('.lazy-load-cont').attr('data-paged',1);

            });

            if ( $('body').hasClass('page-template-news-list') ) {
              auto_load = true;
              post_type = 'news';
              action = 'load_post_list';

            }

            if ( $('body').hasClass('page-template-blog-list') ) {
              auto_load = true;
              post_type = 'post';
              action = 'load_post_list';
            }

            if ( $('body').hasClass('page-template-resources-list') ) {
              auto_load = true;
              post_type = 'resources';
              post_per_page = 6;
              action = 'load_resources_list';
              featured_res = list_cont.attr('data-featured');
              featured_res = JSON.parse( featured_res );
            }

            if ( $('body').hasClass('page-template-events-list') ) {
              auto_load = true;
              post_type = 'event';
              post_per_page = -1;
              action = 'load_event_list';
            }

            if( auto_load ) {
              autoLoad();
            }


        },
        shop: function() {
          
          $('.shop-form-worldpay').submit( function() {
                    //format the amount accordingly
              //      document.payform..cartid.value = "Invoice " + s;
            if (document.payform.invoiceno.value == "") {
              alert("Please enter invoice number.");
              return false;
            }

            if (document.payform.iamount.value == "") {
              alert("Please enter your payment amount.");
              return false;
            }
            
            document.payform.cartId.value = "Invoice #" + document.payform.invoiceno.value;
            document.payform.desc.value = "Invoice #" + document.payform.invoiceno.value;
            document.payform.amount.value = document.payform.iamount.value;

          });

          $('.sms-form-select').select2({minimumResultsForSearch: -1});

          $('.shop-form-worldpay-sms').submit( function() {

            var select_credit = $('#select-sms-credit').val();

            // document.buysmsfor.dropdown.value = select_credit;
            select_credit = select_credit.split('|');
            document.buysmsfor.amount.value = select_credit[0];
            document.buysmsfor.desc.value = select_credit[1];

          });

          $('.shop-form-worldpay-sms .btn-edit').click(function(e){
            e.preventDefault();
            var input = $(this).closest('.form-group').find('.form-control');
            input.removeClass('input-readonly');
            input.attr('readonly', false);
            input.focus();
            $(this).addClass('hide');
          });

          if( $('.order #of_postcode_lookup').length > 0 ) {
            $('.order #of_postcode_lookup').getAddress({
              api_key: '93bd-cmjm-rchK-ZZfQ',
              block_no_organisation: 'true',
              output_fields: {
                  block: '#of_address',
                  organisation: '#of_company'
              },
              complete : function() {
                // $('#order-form').submit();
                form_validator.element( "#of_address" );
                form_validator.element( "#of_company" );
                return;

              }

            });

            $('.order #of_postcode_lookup #searchbox').attr('name', 'of_postcode');
            $('.order #of_postcode_lookup #searchbox').attr('required', true);
            $('.order #of_postcode_lookup #searchbox').addClass("form-control of-field");

            
          }

          if( $('.order-content').length ) {

            var order_content = $('.order-content');

            var tab_nr      = 1;
            var tab_count   = order_content.find('.order-content-tab').length;

            var promo_discount = 0;
            var promo_type;

            var order_data  = {};

            var countries = $.fn.countrySelect.getCountryData();

            var county_select = $('.order-country').select2({minimumResultsForSearch: -1});

            var valid_vat_nr = false;

            $(countries).each(function(i,v){
              var c_name = v.name; 
              c_name = c_name.replace(/\(.*\)/g,'').trim();

              county_select.append( $('<option>', {value: c_name, text: c_name} ) );
              if( v.name == 'United Kingdom') {
                county_select.val( 'United Kingdom' );
              }
            });

            $('.order .order-content .order-product-selection-payment a').click( function(e) {
              e.preventDefault();
              $(this).closest('.order-product-selection-payment').find('a').removeClass('active');
              $(this).addClass('active');
              if( $(this).hasClass('order-payment-collective') ) {
                $('.order-side-cart .order-cart-total .order-cart-total-coll').removeClass('hide');
                $('.order-side-cart .order-cart-total .order-cart-total-basic').addClass('hide');
                $('.order-side-cart .order-cart-collective').fadeIn().css('display','flex');
              } else {
                $('.order-side-cart .order-cart-total .order-cart-total-coll').addClass('hide');
                $('.order-side-cart .order-cart-total .order-cart-total-basic').removeClass('hide');
                $('.order-side-cart .order-cart-collective').fadeOut();
              }
              getPrice();
            });

            $('.order .order-promo-code-field').keyup(function(e){
              var val = $(this).val();
              if( val.length >= 1 ) {
                $(this).parent().find('.order-promo-code-btn').show();
              } else {
                $(this).parent().find('.order-promo-code-btn').hide();
                $('.order-promo-code-msg').hide();
              }
              var key = e.which; 
              if( key==13 ) {
                checkPromoCode( val );
              }
            });

            $('.order .order-promo-code-btn').click( function(e) {
              e.preventDefault();
              var promo_code = $(this).parent().find('.order-promo-code-field').val();
              checkPromoCode( promo_code );
            });

            var form_validator = $('.order-form').validate({
              onkeyup: false,
              errorClass : 'has-error', 
              rules: {
                'of_salutation' : 'required',
                'of_first_name' : 'required',
                'of_last_name'  : 'required',
                'of_job_title'  : 'required',
                'of_company'    : 'required',
                'of_phone'      : 'required',
                'of_email'      : {
                    required: true,
                    email: true
                },
                'of_postcode'   : 'required',
                'of_address'    : 'required',
                'of_website'    : 'required',
                'of_terms[]'      : {
                  required: true,
                  minlength: 1
                },
                "of_vat_nr": {
                  required: false,
                  remote: {
                    url: mri_moove_scripts.ajaxurl,
                    type: 'post',
                    data: {
                      action: 'vat_number_checker'
                    }
                  }
                },
              },
              messages: {
                'of_salutation' : 'Please enter your salutation',
                'of_first_name' : 'Please enter your first name',
                'of_last_name'  : 'Please enter your last name',
                'of_job_title'  : 'Please enter your job title',
                'of_company'    : 'Please enter your company',
                'of_phone'      : 'Please enter your phone number',
                'of_email'      : {
                    required  : 'Please enter your email',
                    email     : 'Please enter valid email address'
                },
                'of_postcode'   : 'Please enter your postcode',
                'of_address'    : 'Please enter your address',
                'of_website'    : 'Please enter your website URL',
                'of_terms'      : 'Please tick the checbox to accept the terms and conditions!',
                'of_vat_nr'     : {
                  remote: 'Incorrect VAT number!'
                }
              },
              errorPlacement: function(error, element) {
                error.appendTo(element.closest('.form-group'));
                if( window.outerWidth > 768 ) {
                  $('.order-side-cont').closest('.row').find('.match-height').matchHeight();
                }
              },
              highlight: function(element, errorClass, validClass) {
                  $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
                  if( window.outerWidth > 768 ) {
                    $('.order-side-cont').closest('.row').find('.match-height').matchHeight();
                  }
              },
              unhighlight: function(element, errorClass, validClass) {
                  $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
              },
              submitHandler: function(e) {

                $('.order-form .of-field').each( function() {
                  var name  = $(this).attr('name');
                  var value = $(this).val();
                  var type  = $(this).prop("tagName").toLowerCase();

                  if( type  === 'textarea' ){
                    // value = value.replace(/<br\s*\/?>/mg,"\n");
                  } else if( type === 'select' ) {
                    value = $(this).find('option:selected').text();
                  } else {
                    if( $(this).is(":checked") ) {
                      value = true;
                    }
                  }
                  order_data[name] = value;

                });


                $.post(
                    mri_moove_scripts.ajaxurl,
                    {
                        action: "send_pardot_order_form",
                        formdata: order_data,
                    },
                    function(data) {
                        data = JSON.parse( data );
                        if( data.success == true ) {
                          console.log('Order data sent to pardot!');
                        } else {
                          console.log('Failed to send Pardot data. Err:'+ data.response);
                        }
                    }
                );

                $.each( order_data, function(i,v) {
                  $('.order-summary-cont').find('.order-summary-box-value[data-id="'+i+'"]').html( v );
                });

                tab_nr = 3;
                switchTab(tab_nr);

                return false;

              }
            });

            $('.order .order-navigation a').click(function(e) {
              e.preventDefault();
              
              if( $(this).hasClass('order-navigation-next') ) {

                if( tab_nr == 2 ) {

                  $('#order-form').submit();

                  return;
                }

                if( tab_nr == 3 ) {

                  $('#order-payment-form').submit( function() {
                
                    var interval = $('.order-product-selection-payment a.active').attr('data-interval');

                    document.buyuniWPform.amount.value = document.buyuniWPform.normalAmount.value = order_data.of_total_w_vat;
                    document.buyuniWPform.desc.value    = 'MRI Agency Central subscription - '+interval+' months';

                    document.buyuniWPform.name.value         = document.buyuniWPform.MC_name.value = order_data.of_first_name+' '+order_data.of_last_name;
                    document.buyuniWPform.email.value        = document.buyuniWPform.MC_email.value = order_data.of_email;
                    document.buyuniWPform.tel.value          = order_data.of_phone;
                    document.buyuniWPform.MC_compName.value  = order_data.of_company;
                    document.buyuniWPform.address.value      = document.buyuniWPform.MC_address.value = order_data.of_address;
                    document.buyuniWPform.postcode.value     = document.buyuniWPform.MC_postcode.value = order_data.of_postcode;

                    if( $('.order-payment-basic').hasClass('active') ) {
                      $(this).append('<input type="hiden" name="futurePayType" />');
                      $(this).append('<input type="hiden" name="noOfPayments" />');
                      $(this).append('<input type="hiden" name="intervalUnit" />');
                      $(this).append('<input type="hiden" name="intervalMult" />');
                      $(this).append('<input type="hiden" name="startDelayUnit" />');
                      $(this).append('<input type="hiden" name="startDelayMult" />');

                      document.buyuniWPform.futurePayType.value  = 'regular';
                      document.buyuniWPform.noOfPayments.value   = 0;
                      document.buyuniWPform.intervalUnit.value   = interval;
                      document.buyuniWPform.intervalMult.value   = interval;
                      document.buyuniWPform.startDelayUnit.value   = interval;
                      document.buyuniWPform.startDelayMult.value   = interval;
                    } else if( $('.order-payment-collective').hasClass('active') ) {
                      $('input[name=futurePayType]').remove();
                      $('input[name=noOfPayments]').remove();
                      $('input[name=intervalUnit]').remove();
                      $('input[name=intervalMult]').remove();
                      $('input[name=startDelayUnit]').remove();
                      $('input[name=startDelayMult]').remove();
                    }

                  }).trigger('submit');

                }

                if( tab_nr < tab_count ) {
                  tab_nr++;
                }

              } else if( $(this).hasClass('order-navigation-back') ){
                if( tab_nr > 1 ) {
                  tab_nr--;
                }
              }

              switchTab( tab_nr );

            });

            $('.order .order-head-tabs .order-head-tab').click(function(e){
              e.preventDefault();
              if( $(this).parent().hasClass('visited') ) {
                tab_nr = $(this).attr('data-index');
                switchTab( tab_nr );
              }
            });

            var user_count = 0;
            var mg_count = 0;

            var slider_options = {
              'tooltip' : 'hide',
            };
            var user_slider = $('#order-user-select-slider').slider( slider_options );
            var mg_slider   = $('#order-mg-select-slider').slider( slider_options );

            user_count  = user_slider.slider('getValue');
            mg_count    = mg_slider.slider('getValue');

            user_slider.on('change', function(e){
              user_count = e.value.newValue;
              showSliderValue(e.currentTarget, user_count);
              getPrice();
            });

            user_slider.on('slideStop', function(e){
              if( user_count < mg_count ) {
                mg_count = user_count;
                mg_slider.slider('setValue', user_count, true );
                showSliderValue(mg_slider, user_count);
                getPrice();
              }
            });

            mg_slider.on('change', function(e){
              mg_count = e.value.newValue;
              if( mg_count > user_count ) {
                mg_count = user_count;
                mg_slider.slider('setValue', mg_count, true );
                // showSliderValue(e.currentTarget, mg_count);
                return false;
              } else {
                showSliderValue(e.currentTarget, mg_count);
              }
              getPrice();
            });

            if( window.outerWidth > 768 ) {
              $('.order-side-cont').closest('.row').find('.match-height').matchHeight();
            }
            
            function switchTab( tab_nr ) {

              if( tab_nr == 2 ) {
                order_data.of_user_count = user_count;
                order_data.of_mg_count   = mg_count;
              }

              if( !$('.order-content-tab[data-index="'+tab_nr+'"]').hasClass('active') ) {
                $('.order-content-tab').hide().removeClass('active');
                $('.order-content-tab[data-index="'+tab_nr+'"]').fadeIn().addClass('active');
              }
              $('.order-head-tabs ul li').each( function() {
                var tab = $(this).find('.order-head-tab');
                if( tab.attr('data-index') < tab_nr ) {
                  $(this).addClass('visited');
                  $(this).removeClass('active');
                } else if( tab.attr('data-index') == tab_nr ) {
                  $(this).removeClass('visited');
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('visited');
                  $(this).removeClass('active');
                }
              });

              if( tab_nr == 1 ) {
                $(".order-navigation-back").hide();
                $('.order .order-promo-code-field').attr('disabled', false);
                $('.order .order-promo-code-btn').show();
              } else {
                $(".order-navigation-back").show();
                $('.order .order-promo-code-field').attr('disabled', true);
                $('.order .order-promo-code-btn').hide();
              }

              if( window.outerWidth > 768 ) {
                $('.order-side-cont').closest('.row').find('.match-height').matchHeight('remove').matchHeight();
              }
            }

            function showSliderValue(e, val) {
              var label = 'users';
              if( val == 1 ) {
                label = 'user';
              }
              $(e).closest('.order-user-select').find('.order-user-select-count').text(val+' '+label);
              
            }

            function checkPromoCode( code ) {
              $.ajax({
                url: mri_moove_scripts.ajaxurl,
                type : 'get',
                data : {
                  action : "check_promo_code",
                  code: code
                },
                success: function( response ) {
                  response = JSON.parse(response);
                  if( response.status === true || response.code.length ) {
                    promo_discount  = response.code.value;
                    promo_type      = response.code.type;
                    getPrice();
                    $('.order-cart-discount').fadeIn().css('display','flex');
                    $('.order-promo-code-msg').fadeOut();
                    order_data.of_promo_code = code;
                  } else {
                    promo_discount  = 0;
                    promo_type      = null;
                    $('.order-cart-discount').fadeOut();
                    $('.order-promo-code-msg').text('Invalid promo code!').fadeIn().css('display','block');
                    getPrice();
                    delete order_data.of_promo_code;
                  }
                }
              });
            }

            function getPrice() {

              var cart      = $('.order-side-cart');
              var currency  = cart.attr('data-currency');

              var user_price = cart.attr('data-user-price');
              var mg_price   = cart.attr('data-mg-price');

              var users_price_cont  = cart.find('.order-cart-users');
              var mg_price_cont     = cart.find('.order-cart-mg');
              var vat_cont          = cart.find('.order-cart-vat');
              var total_cont        = cart.find('.order-cart-total');

              var coll_discount     = $('.order-payment-collective').attr('data-discount');

              var vat         = vat_cont.attr('data-value');

              var price_data  = JSON.parse( cart.find('.order-price-data').text() );

              $.each( price_data, function(i,v){
                if( user_count >= i ) {
                  user_price = v;
                }
              });

              var interval      = order_data.of_payment_interval = $('.order-product-selection-payment a.active').attr('data-interval');

              var coll_interval = $('.order-product-selection-payment a.order-payment-collective').attr('data-interval');
              
              var user_total  = user_price * user_count * interval;
              var mg_total    = mg_price * mg_count * interval;

              var user_total_coll = user_price * user_count * coll_interval;
              var mg_total_coll   = mg_price * mg_count * coll_interval;

              var coll_total = user_total_coll + mg_total_coll;
              
              var total       = user_total + mg_total;

              var coll_discount_value = (total * coll_discount)/100;

              var coll_saving         = order_data.of_coll_saving = ( (coll_total * coll_discount)/100 ).toFixed(2);

              coll_discount_value = order_data.of_coll_discount  =  (total * coll_discount)/100;

              $('.order-cart-coll-label .order-cart-item-value').text( currency+coll_saving );

              if( $('.order-payment-collective').hasClass('active') ) {
                $('.order-cart-collective .order-cart-item-value').text( '-'+currency+coll_discount_value.toFixed(2) );
                total = total - coll_discount_value;
                $('.order-cart-coll-label').fadeOut();
                order_data.of_payment_type = $('.order-payment-collective span').text();
              } else if( $('.order-payment-basic').hasClass('active') ) {
                order_data.of_payment_type = $('.order-payment-basic span').text();
                delete order_data.of_coll_discount;
                $('.order-cart-coll-label').fadeIn();
              }

              if( promo_discount ) {
                if( promo_type === 'amount' ) {
                  total = total - promo_discount;
                  $('.order-cart-discount .order-cart-item-value').text('-'+currency+promo_discount);
                } else if( promo_type == 'percentage' ) {
                  var promo_amount = ( total*promo_discount )/100;
                  total = total - promo_amount;
                  $('.order-cart-discount .order-cart-item-value').text('-'+currency+promo_amount );
                }
              }

              var vat_total    = (total * vat)/100;
              var total_w_vat  = total + vat_total;

              vat_total   = order_data.of_vat_total = vat_total.toFixed(2);
              total_w_vat = order_data.of_total_w_vat = total_w_vat.toFixed(2);

              user_total = order_data.of_user_total = user_total.toFixed(2);
              mg_total   = order_data.of_mg_total   = mg_total.toFixed(2);

              users_price_cont.find('.order-cart-item-value').text( currency+user_total );
              mg_price_cont.find('.order-cart-item-value').text( currency+mg_total );
              vat_cont.find('.order-cart-item-value').text( currency+vat_total );
              total_cont.find('.order-cart-item-value').text( currency+total_w_vat );

              if( user_count ) {
                $('.order-navigation .order-navigation-next').fadeIn();
              } else {
                $('.order-navigation .order-navigation-next').fadeOut();
              }

            }

            function matchCustom(params, data) {
                // If there are no search terms, return all of the data
                if ($.trim(params.term) === '') {
                  return data;
                }

                // Do not display the item if there is no 'text' property
                if (typeof data.text === 'undefined') {
                  return null;
                }

                // `params.term` should be the term that is used for searching
                // `data.text` is the text that is displayed for the data object
                if (data.text.indexOf(params.term) > -1) {
                  var modifiedData = $.extend({}, data, true);
                  modifiedData.text += ' (matched)';

                  // You can return modified objects from here
                  // This includes matching the `children` how you want in nested data sets
                  return modifiedData;
                }

                // Return `null` if the term should not be displayed
                return null;
            }

          }

        },
        misc: function() {
          window.addEventListener('iframe_message', function(e) {
            var url = e.detail.url;
            console.log(url);
            if ( url ) {
              window.top.location.href = url;
            }
          }, false);

          // $('.gated-content').show().css('opacity', 0);

          function mri_has_url_param( url ) {
            if ( url.indexOf('?utm_') !== -1 ) {
              return true;
            }
            else {
              if ( url.indexOf('&utm_') !== -1 ) {
                return true;
              }
            }
            return false;
          }

          function addParameterToURL( _url, param ) {
            _url += (_url.split('?')[1] ? '&':'?') + param;
            return _url;
          }

          $(document).find('.pardotform').each(function() {
            var iframe_src  = $(this).attr('nitro-lazy-src');
            var iframe      = $(this); 
            var utm_query_string = window.location.search;
            if ( iframe_src && utm_query_string && ! mri_has_url_param( iframe_src ) ) {
              try {
                var utm_url_params  = new URLSearchParams(utm_query_string);

                var utm_source      = utm_url_params.get('utm_source');
                utm_source = utm_source ? utm_source : utm_url_params.get('lcf_utm_source');

                var utm_medium      = utm_url_params.get('utm_medium');
                utm_medium = utm_medium ? utm_medium : utm_url_params.get('lcf_utm_medium');

                var utm_campaign    = utm_url_params.get('utm_campaign');
                utm_campaign = utm_campaign ? utm_campaign : utm_url_params.get('lcf_utm_campaign');

                var utm_term        = utm_url_params.get('utm_term');
                utm_term  = utm_term ? utm_term : utm_url_params.get('lcf_utm_term');

                var utm_content     = utm_url_params.get('utm_content');
                utm_content  = utm_content ? utm_content : utm_url_params.get('lcf_utm_content');

                var has_change      = false;
                if ( utm_source ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_source='+encodeURIComponent(utm_source) );
                  has_change = true;
                }

                if ( utm_medium ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_medium='+encodeURIComponent(utm_medium) );
                  has_change = true;
                }

                if ( utm_campaign ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_campaign='+encodeURIComponent(utm_campaign) );
                  has_change = true;
                }

                if ( utm_term ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_term='+encodeURIComponent(utm_term) );
                  has_change = true;
                }

                if ( utm_content ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_content='+encodeURIComponent(utm_content) );
                  has_change = true;
                }
                if ( has_change ) {
                  iframe.attr('nitro-lazy-src', iframe_src);
                }
              } catch(err) {
                console.warn(err);
              }
            }
          });

          $(document).find('.pardotform').each(function() {
            var iframe_src  = $(this).attr('src');
            var iframe      = $(this); 
            var utm_query_string = window.location.search;
            if ( utm_query_string && ! mri_has_url_param( iframe_src ) ) {
              try {
                var utm_url_params  = new URLSearchParams(utm_query_string);
                var utm_source      = utm_url_params.get('utm_source');
                utm_source = utm_source ? utm_source : utm_url_params.get('lcf_utm_source');

                var utm_medium      = utm_url_params.get('utm_medium');
                utm_medium = utm_medium ? utm_medium : utm_url_params.get('lcf_utm_medium');

                var utm_campaign    = utm_url_params.get('utm_campaign');
                utm_campaign = utm_campaign ? utm_campaign : utm_url_params.get('lcf_utm_campaign');

                var utm_term        = utm_url_params.get('utm_term');
                utm_term  = utm_term ? utm_term : utm_url_params.get('lcf_utm_term');

                var utm_content     = utm_url_params.get('utm_content');
                utm_content  = utm_content ? utm_content : utm_url_params.get('lcf_utm_content');

                var has_change      = false;
                if ( utm_source ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_source='+encodeURIComponent(utm_source) );
                  has_change = true;
                }

                if ( utm_medium ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_medium='+encodeURIComponent(utm_medium) );
                  has_change = true;
                }

                if ( utm_campaign ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_campaign='+encodeURIComponent(utm_campaign) );
                  has_change = true;
                }

                if ( utm_term ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_term='+encodeURIComponent(utm_term) );
                  has_change = true;
                }

                if ( utm_content ) {
                  iframe_src = addParameterToURL( iframe_src, 'utm_content='+encodeURIComponent(utm_content) );
                  has_change = true;
                }
                
                if ( has_change ) {
                  iframe.attr('src', iframe_src);
                }
              } catch(err) {
                console.warn(err);
              }
            }
          });

          iFrameResize({ 
            log: false,
            autoResize: false,
            checkOrigin: false,
            heightCalculationMethod : 'max',
            onInit : function(iframe){
              Sage.common.matchHeights();
              $('.gated-content').hide().css('opacity', 1);
              $('.js-show-form.not-loaded').hide().removeClass('not-loaded');
            },
          }, '.pardotform');


          jQuery('.scrollbar-outer').scrollbar();
          

          $(window).load(function() {
            // Animate loader off screen
            $('section.page-header-hero .content-image-cnt .animated-content-image img').addClass('tilt');
          });
          
          $(document).on('click','#header_search_trigger',function() {
              $('#main-header .header__search').toggleClass( "focused" );
          });

          $('.card_equal_heights .grid_accordion_block--trigger ').matchHeight({byRow: true});

          // Sticky nav
          window.onscroll = function() {
            if ( $(window).scrollTop() > 200 ) {
              $('#main-header').addClass( 'header-affix' );
              $('body').addClass('mri-header-affix');
            } else {
              $('#main-header').removeClass( 'header-affix' );
              $('body').removeClass('mri-header-affix');
            }

            if ( $(document).find('.mri-hero-sticky-nav').length ) {
              // Sticky nav
              var nav_affix_top = $(document).find('.mri-hero-sticky-nav').offset().top;
           
              if ( $(window).scrollTop() > ( nav_affix_top - 80 ) ) {
                $('.mri-hero-sticky-nav').addClass( 'nav-affix' );
              } else {
                $('.mri-hero-sticky-nav').removeClass( 'nav-affix' );
              }
            }
          
          };

          if( window.innerWidth >= 768 ) {
           $('.mri-hero-sticky-nav li a').on('click', function(e){
            
              var href_id = $(this).attr('href');
              try {
                if ( href_id.indexOf("#") >= 0 && $(href_id).length > 0 ) {
                  e.preventDefault();
                  var offset_nav = 0;
                  var offset = $(href_id).offset().top - 140 - offset_nav;
                  $('body,html').animate({
                      scrollTop: offset,
                  }, 300);
                }
              } catch(err) {
                console.warn(err);
              }
       
            
            });
          }

          function isElementVisible($elem) {

            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + mriViewportHeight();
            var elemTop = $elem.offset().top;
            var returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 70));
            return returnvalue;

          }

          // MRI TABS
          $(document).on('click','.mri-tab-section button.tablinks',function(e){
            e.preventDefault();
            var parent = $(this).closest('.mri-tab-section');
            if ( ! $(this).hasClass('active') ) {
              var tab_id = $(this).attr('data-tab');

              $(parent).find('button.tablinks').removeClass('active');
              $(this).addClass('active');
              $(parent).find('.tab-main-content').removeClass('active');
              $(parent).find('#' + tab_id).addClass('active');
            }
          });

          $(document).on('click','.mri-tab-section .tabaccordion a',function(e){
            e.preventDefault();
            var tab_id = $(this).attr('data-href');
            var button = $(this);
            var is_active = $(this).parent('.tabaccordion').hasClass('active');
            $('.mri-tab-section .tabaccordion').removeClass('active');
            $('.mri-tab-section .tab-main-content, .mri-tab-section button.tablinks').removeClass('active');
             

            if( !is_active ){
              $(this).parent('.tabaccordion').addClass('active');
              $('#'+tab_id).addClass('active');
              $('.mri-tab-section button.tablinks[data-tab='+tab_id+']').addClass('active');
              
              $('body,html').animate({
                  scrollTop: button.offset().top - 100
              }, 300);

            }

          });

          $(document).on('click','.close-lng-popup',function(e){
            e.preventDefault();
            $('.lity-close').click();
          });

          $(document).on('lity:open', function(event, instance) {
            var opener = instance.opener();
            $('body').toggleClass('lity-opened');
            if ( typeof opener.attr('data-litytype') !== 'undefined' ) {
              $('.lity').addClass( opener.attr('data-litytype') ).attr('data-extraclass',opener.attr('data-litytype'));
              if ( opener.attr('data-litytype') === 'lity-language-modal-cnt' ) {
                $('.mri-flipping-animate-numbers').removeClass('animated');
                $('html,body').animate({ scrollTop: 10 }, 0);
                $('html,body').animate({ scrollTop: 0 }, 0);
                $('.mri-lng-container .language-list a').matchHeight();
              }
            }
          });

          $(document).on('lity:close',function(event, instance) {
            $('body').toggleClass('lity-opened');
            $('html').removeClass('interactive-image-modal');
          });

          $(document).on('hover','.new-mega-menu-navigation .dropdown-submenu .submenu-tabs li:not(.active-tab)',function(e){
            e.preventDefault();
            var menu_id = $(this).attr('data-menuid');
            var parent = $(this).closest('.dropdown-submenu');
            parent.find('.submenu-tabs li').removeClass('active-tab');
            $(this).addClass('active-tab');
            parent.find('.submenu-tabcontent li').removeClass('active-tab');
            parent.find('.submenu-tabcontent li[data-menuid='+menu_id+']').addClass('active-tab');
            parent.find('.submenu-related li').removeClass('active-tab');
            parent.find('.submenu-related li[data-menuid='+menu_id+']').addClass('active-tab');
          });

          // Partners infinite scroll
          $(window).scroll(function() {
            if ( $('body').hasClass('page-template-partners-list') ) {
              if( $(window).scrollTop() + mriViewportHeight()  >= $(document).find('footer.site-footer').offset().top ) {
                if ( ! $('body').hasClass('load-more-in-progress') ) {
                  $(document).find('.post_filtering_more').click();
                }
              }
            }
          });

          $('.btn-scroll-to').click( function(e) {
            var href = $(this).attr('href');
            // Only in-page anchors that exist: $() of a full URL throws, and a
            // missing target used to swallow the click with nothing to scroll to.
            var target = href && href.indexOf('#') === 0 && href.length > 1 ? $( href ) : $();
            if ( target.length ) {
              e.preventDefault();
              var margin = $('#main-header').height();
              $('html,body').animate({
                 scrollTop: ( target.offset().top - margin )
              });
            }
          });

          $('.mri-s-page-hero-story .scroll-btn > a').click( function(e) {
            e.preventDefault();
            var item = $(this).closest('section').next('section:visible');
            var margin = $('#main-header').height();
            if ( item.length > 0 ) {
              $('html,body').animate({
                 scrollTop: ( item.offset().top - margin )
              });
            }

          });

          function showHideAccordion(){
            var nav_tabs = $('.mri-tab-section button.tablinks');
            var nav_accordion = $('.mri-tab-section div.tabaccordion');

            var covid_banner = $(document).find('.mri-header-covid-banner');
            var banner_height = 0;
            if(window.innerWidth >= 768){
                nav_tabs.show();
                nav_accordion.remove();
                if( $('.mri-tab-section .tab-main-content.active').length <= 0) {
                  $('.mri-tab-section .tab-main-content').eq(0).addClass('active');
                }      
                $('header#main-header').removeAttr('style');
                $('.site-content').removeAttr('style');    
                $('#mri-mobile-menu-container').removeAttr('style');
                // if ( ! $('body').hasClass('gdpr-infobar-visible') ) {
                  if ( covid_banner.length > 0 ) {
                    if ( ! covid_banner.is(':visible') ) {    
                      covid_banner.slideDown(300);          
                    }   
                    banner_height = covid_banner.innerHeight();
                    $(document).find('header#main-header').css( 'top', banner_height+'px' );

                    $(document).find('#page.site').css( 'padding-top', banner_height+'px' );
                    $(document).find('.sticky-nav-fixed-wrap').css( 'margin-top', banner_height+'px' );
                  }
                // }   
                setTimeout(function(){
                  // if ( ! $('body').hasClass('gdpr-infobar-visible') ) {
                    if ( covid_banner.length > 0 ) {
                      if ( ! covid_banner.is(':visible') ) {    
                        covid_banner.slideDown(300);          
                      }   
                      banner_height = covid_banner.innerHeight();
                      $(document).find('header#main-header').css( 'top', banner_height+'px' );
                      $(document).find('#page.site').css( 'padding-top', banner_height+'px' );
                      $(document).find('.sticky-nav-fixed-wrap').css( 'margin-top', banner_height+'px' );
                    }
                  // }
                }, 1000);

            } else {
              // if ( $('body').hasClass('gdpr-infobar-visible') ) {
              //   $('header#main-header').css('top',$('#moove_gdpr_cookie_info_bar').height());
              //   $('.site-content').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
              //   $('#mri-mobile-menu-container').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
              // }
              setTimeout(function(){
                // if ( $('body').hasClass('gdpr-infobar-visible') ) {
                //   $('header#main-header').css('top',$('#moove_gdpr_cookie_info_bar').height());
                //   $('.site-content').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
                //   $('#mri-mobile-menu-container').css('padding-top',$('#moove_gdpr_cookie_info_bar').height() + 70);
                // } else {
                  if ( covid_banner.length > 0 ) {
                    if ( ! covid_banner.is(':visible') ) {    
                      covid_banner.slideDown(300);          
                    }   
                    banner_height = covid_banner.innerHeight();
                    $(document).find('header#main-header').css( 'top', banner_height+'px' );
                    $(document).find('#page.site').css( 'padding-top', banner_height+'px' );
                    $(document).find('.sticky-nav-fixed-wrap').css( 'margin-top', banner_height+'px' );
                  }
                // }
              }, 1000);
              
              if(nav_accordion.length <= 0) {
                $('.mri-tab-section .tab-main-content').removeClass('active');
                nav_tabs.each(function(){
                  var tab_id = $(this).attr('data-tab');
                  var tab_title = $(this).text();
                  $(this).hide();
                  $('#'+tab_id).before('<div class="tabaccordion" ><a data-href="'+tab_id+'" >'+tab_title+'</a></div>');
                });
              }
            }
          }

          showHideAccordion();

          $( window ).resize(function() {
            showHideAccordion();
            $('.lity-close').trigger('click');
          });

        },
        roi_calculator: function() {
          // ROI Calculator Toggle Sliders
          var case_load_steps = [15, 20, 30];

          var lts_slide = jQuery('#case_load_toggle_slider').slider({
              range: "min",
              min: 0,
              max: case_load_steps.length - 1,
              value: 0,
              slide: function(event, ui) {              
                jQuery('#case_load_percentage').text(case_load_steps[ui.value]);
                calculateTotals(case_load_steps[ui.value], jQuery('#letter_recommendations_percentage').text());
              }
          }).on('slide', function(ev){
            var cls_text    = jQuery('#case_load_percentage').text();
            var slide_val   = case_load_steps[lts_slide.slider('getValue')[0]]
            if ( parseInt( cls_text ) !== slide_val ) {
              jQuery('#case_load_percentage').text(slide_val);
              calculateTotals(slide_val, jQuery('#letter_recommendations_percentage').text());
            }
          });

          var letter_recommendation_steps = [10, 20, 30, 40, 50];

          var rts_slide = jQuery('#letter_recommendations_toggle_slider').slider({
            range: "min",
            min: 0,
            max: letter_recommendation_steps.length - 1,
            value: 3, // Defaults to 40
            slide: function(event, ui) {
              jQuery('#letter_recommendations_percentage').text(letter_recommendation_steps[ui.value]);

              calculateTotals(jQuery('#case_load_percentage').text(), letter_recommendation_steps[ui.value]);
            }
          }).on('slide', function(ev){
            var rts_text    = jQuery('#letter_recommendations_percentage').text();
            var slide_val   = letter_recommendation_steps[rts_slide.slider('getValue')[0]]
            if ( parseInt( rts_text ) !== slide_val ) {
              jQuery('#letter_recommendations_percentage').text(slide_val);
              calculateTotals(jQuery('#case_load_percentage').text(), slide_val);
            }
          });;

          // ROI Calculator
          if (jQuery('#calculatorForm').length) {
            var $form = jQuery('#calculatorForm');

            $form.find('input.form-control-number').on( "keyup", function( event ) {
              // When user select text in the document, also abort.
              var selection = window.getSelection().toString();
              if ( selection !== '' ) {
                return;
              }
              
              // When the arrow keys are pressed, abort.
              if ( $.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
                return;
              }
              
              
              var $this = $( this );
              
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

              $this.val( function() {
                return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );;
              } );

              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );
              console.warn(input)
            });

            $form.on('submit', function(e) {
              jQuery('.js-show-form').show();
                e.preventDefault();

                jQuery('html, body').animate({
                  scrollTop: jQuery('.roi-calculator-signup-section').offset().top - 100
                }, 500);

                calculateTotals(jQuery('#case_load_percentage').text(), jQuery('#letter_recommendations_percentage').text(), false);
            });

          }

          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

          eventer(messageEvent, function (e) {
            if ( $('.roi-calculator-contact-form').length > 0 ) {
              if (e.data === "mri_pardot_form_submit" || e.message === "mri_pardot_form_submit") {
                // code to be trigger when confirmation page is loaded
                jQuery('.roi-calculator-contact-form').hide();
                jQuery('.js-open-onsubmit').show();
                calculateTotals(jQuery('#case_load_percentage').text(), jQuery('#letter_recommendations_percentage').text(), true);
              }
            }
            
          });

          function calculateTotals( caseLoadReduction, letterRecommendations, scrollDown) {
              var average_minutes_per_case = 15;

              // Calculate and update case load removals
              var arrears_cases_removed = jQuery('#number_of_arrears').val() * (caseLoadReduction / 100),
                  arrears_cases_removed_hours = arrears_cases_removed * average_minutes_per_case / 60,
                  arrears_cases_removed_total = parseFloat(arrears_cases_removed_hours.toFixed(1));

              jQuery('#arrears_cases_removed').html(parseFloat(arrears_cases_removed.toFixed(2)));
              jQuery('#arrears_cases_removed_hours').html(arrears_cases_removed_total);

              // Calculate and update weekly recommendations
              var weekly_recommendations = jQuery('#weekly_recommendations').val() * (letterRecommendations / 100),
                  weekly_recommendations_hours = weekly_recommendations * average_minutes_per_case / 60,
                  weekly_recommendations_total = parseFloat(weekly_recommendations_hours.toFixed(1));


              jQuery('#letter_recommendations_cases_removed').html(parseFloat(weekly_recommendations.toFixed(2)));
              jQuery('#letter_recommendations_cases_removed_hours').html(weekly_recommendations_total);

              // Calculate and update case reduction total
              var case_load_reduction = jQuery('#weekly_accounts').val(),
                  case_load_reduction_hours = case_load_reduction * average_minutes_per_case / 60,
                  case_load_reduction_total = parseFloat(case_load_reduction_hours.toFixed(1));

              if (case_load_reduction) {
                jQuery('#number_of_low_level_arrears').html(case_load_reduction);
                jQuery('#low_level_case_arrears').html(case_load_reduction);
                jQuery('#low_level_case_arrears_hours').html(case_load_reduction_total);
              }

              var total = arrears_cases_removed_total + weekly_recommendations_total + case_load_reduction_total;
              calcDataLayer.push('savings_result', total.toFixed(1));
              jQuery('#total_hours_saved').html(total.toFixed(1));

              if (scrollDown) {
                jQuery('html, body').animate({
                  scrollTop: jQuery('#calculator_results_title').offset().top - 100
                }, 500);
              }
          }

          jQuery(document).on('gform_confirmation_loaded', function(event, formId){
            // code to be trigger when confirmation page is loaded
          });
        },

        roi_calculator_2023: function() {
          // ROI Calculator
          if (jQuery('#calculatorForm_2023').length) {

            function roi_mri_has_url_param( url, parameter ) {
              if ( url.indexOf('?' + parameter) !== -1 ) {
                return true;
              }
              else {
                if ( url.indexOf('&' + parameter) !== -1 ) {
                  return true;
                }
              }
              return false;
            }

            function addParameterToURL_ROI( _url, param ) {
              _url += (_url.split('?')[1] ? '&':'?') + param;
              return _url;
            }

            var $form = jQuery('#calculatorForm_2023');

            $form.find('input.form-control-number').on( "keyup", function( event ) {
              // When user select text in the document, also abort.
              var selection = window.getSelection().toString();
              if ( selection !== '' ) {
                return;
              }
              
              // When the arrow keys are pressed, abort.
              if ( $.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
                return;
              }
              
              
              var $this = $( this );
              
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );
              var _id = $(this).closest('.form-holder').find('input[type="hidden"]').attr('id');

              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input );
              // console.warn(input)
            });

            $form.on('submit', function(e) {
              // console.warn('show_next');
              if ( $(this).closest('.calculator-form').attr('data-fvis') === 'visible' ) {

                jQuery('.js-show-form').show().removeClass('not-loaded');
                  e.preventDefault();

                  jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                    var iframe_src  = $(this).attr('nitro-lazy-src');
                    var iframe      = $(this); 
                    var input_1     = $('#number_of_locations_2023').val();
                    var input_2     = $('#average_lease_cost_2023').val();
                    var input_3     = $('#average_sale_per_location_2023').val();

                    if ( iframe_src && ( input_1 || input_2 || input_3 ) ) {
                      try {
                        var has_change      = false;
                        var input_pname     = '';
                        if ( input_1 ) {
                          input_pname = $('#number_of_locations_2023').closest('.form-group').attr('data-pname');
                          if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                            iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                            has_change = true;
                          }
                        }

                        if ( input_2 ) {
                          input_pname = $('#average_lease_cost_2023').closest('.form-group').attr('data-pname');
                          if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                            iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                            has_change = true;
                          }
                        }

                        if ( input_3 ) {
                          input_pname = $('#average_sale_per_location_2023').closest('.form-group').attr('data-pname');
                          if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                            iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_3) );
                            has_change = true;
                          }
                        }
                        
                        // console.warn(has_change);
                        if ( has_change ) {
                          iframe.attr('nitro-lazy-src', iframe_src);
                          iframe.attr('src', iframe_src);
                        }
                      } catch(err) {
                        console.warn(err);
                      }
                    }
                  });

                  jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                    var iframe_src  = $(this).attr('src');
                    var iframe      = $(this); 
                    var input_1     = $('#number_of_locations_2023').val();
                    var input_2     = $('#average_lease_cost_2023').val();
                    var input_3     = $('#average_sale_per_location_2023').val();
                    if ( iframe_src && ( input_1 || input_2 || input_3 ) ) {
                      try {
                        var has_change      = false;
                        var input_pname     = '';
                        if ( input_1 ) {
                          input_pname = $('#number_of_locations_2023').closest('.form-group').attr('data-pname');
                          if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                            iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                            has_change = true;
                          }
                        }

                        if ( input_2 ) {
                          input_pname = $('#average_lease_cost_2023').closest('.form-group').attr('data-pname');
                          if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                            iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                            has_change = true;
                          }
                        }

                        if ( input_3 ) {
                          input_pname = $('#average_sale_per_location_2023').closest('.form-group').attr('data-pname');
                          if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                            iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_3) );
                            has_change = true;
                          }
                        }
                        // console.warn(has_change);
                        
                        if ( has_change ) {
                          iframe.attr('nitro-lazy-src', iframe_src);
                          iframe.attr('src', iframe_src);
                        }
                      } catch(err) {
                        console.warn(err);
                      }
                    }
                  });

                  jQuery('html, body').animate({
                    scrollTop: jQuery('.roi-calculator-signup-section').offset().top - 100
                  }, 500);

                  calculate_totals_2023(false);
              } 

              if ( $(this).closest('.calculator-form').attr('data-fvis') === 'hidden' ) {
                e.preventDefault();
                if ( $('#calculatorForm_2023_ty').length > 0 ) {
                  $('#calculatorForm_2023_ty').submit();                
                } else {
                  jQuery('.roi-calculator-contact-form-2023').hide();
                  jQuery('.js-open-onsubmit').show();
                  calculate_totals_2023(true);
                }
              }
            });

          }

          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

          eventer(messageEvent, function (e) {
            if ( $('.roi-calculator-contact-form-2023').length > 0 ) {
              if (e.data === "mri_pardot_form_submit" || e.message === "mri_pardot_form_submit") {
                // code to be trigger when confirmation page is loaded
                
                if ( $('#calculatorForm_2023_ty').length > 0 ) {
                  $('#calculatorForm_2023_ty').submit();        
                  console.warn('1');        
                } else {
                  jQuery('.roi-calculator-contact-form-2023').hide();
                  jQuery('.js-open-onsubmit').show();
                  calculate_totals_2023(true);

                }
              }
            }
          });

          if ( $('body').hasClass('products-template-template-roi-2023-ty') || $('body').hasClass('page-template-template-roi-2023-ty') ) {
            jQuery('.js-open-onsubmit').show();

            $(document).find('input.form-control-number').each( function() {

              var $this = $( this );
              
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );
              var _id = $(this).closest('.form-holder').find('input[type="hidden"]').attr('id');

              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input );
              // console.warn(input)
            });

            calculate_totals_2023(true);

            if ( $('.roi-calculator-signup-section-ty').length > 0 ) {
              jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                var iframe_src  = $(this).attr('nitro-lazy-src');
                var iframe      = $(this); 
                var input_1     = $(document).find('#number_of_locations_2023').val();
                var input_2     = $(document).find('#average_lease_cost_2023').val();
                var input_3     = $(document).find('#average_sale_per_location_2023').val();


                if ( iframe_src && ( input_1 || input_2 || input_3 ) ) {
                  try {
                    var has_change      = false;
                    var input_pname     = '';
                    if ( input_1 ) {
                      input_pname = $(document).find('#number_of_locations_2023').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                        has_change = true;
                      }
                    }

                    if ( input_2 ) {
                      input_pname = $(document).find('#average_lease_cost_2023').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    if ( input_3 ) {
                      input_pname = $(document).find('#average_sale_per_location_2023').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_3) );
                        has_change = true;
                      }
                    }
                    
                    // console.warn(has_change);
                    if ( has_change ) {
                      iframe.attr('nitro-lazy-src', iframe_src);
                      iframe.attr('src', iframe_src);
                    }
                  } catch(err) {
                    console.warn(err);
                  }
                }
              });

              jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                var iframe_src  = $(this).attr('src');
                var iframe      = $(this); 
                var input_1     = $(document).find('#number_of_locations_2023').val();
                var input_2     = $(document).find('#average_lease_cost_2023').val();
                var input_3     = $(document).find('#average_sale_per_location_2023').val();
                if ( iframe_src && ( input_1 || input_2 || input_3 ) ) {
                  try {
                    var has_change      = false;
                    var input_pname     = '';
                    if ( input_1 ) {
                      input_pname = $(document).find('#number_of_locations_2023').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                        has_change = true;
                      }
                    }

                    if ( input_2 ) {
                      input_pname = $(document).find('#average_lease_cost_2023').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    if ( input_3 ) {
                      input_pname = $(document).find('#average_sale_per_location_2023').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI( iframe_src, input_pname+'='+encodeURIComponent(input_3) );
                        has_change = true;
                      }
                    }
                    // console.warn(has_change);
                    
                    if ( has_change ) {
                      iframe.attr('nitro-lazy-src', iframe_src);
                      iframe.attr('src', iframe_src);
                    }
                  } catch(err) {
                    console.warn(err);
                  }
                }
              });
            }
          }

          function calculate_totals_2023( scrollDown ) {

            var currency = $('.calculator-form').attr('data-currency');
            var apac = $('.calculator-form').hasClass('calculator-form-apac');
            if ( apac ) {
              // APAC VERSION
              console.warn('apac version');
              // Table: 
              // https://docs.google.com/spreadsheets/d/13JyIxAGZKnhbCYRhdTbPW4dyQvUV43Gb8BJib-YY6lY/edit#gid=252130270

              // Input Numbers
              var _c1 = jQuery('#number_of_locations_2023').val(),
                  _c2 = jQuery('#average_lease_cost_2023').val(),
                  _c3 = jQuery('#average_sale_per_location_2023').val(),
                  _currency = 0;
              _c3 = _c3 ? _c3 : 0;
              /** 
               * Renewal Lease Costs
               */

              var _c6 = 1 / 100;
              var _c7 = 1 / 100;
              var _c8 = 1 / 100;

              var _d6 = _c6 * _c1 / 5;
              var _d7 = _c7 * _c1 / 5;
              var _d8 = _c8 * _c1 / 10;

              var _e6 = _c2;
              var _e7 = _c3 / 2;
              var _e8 = _c2;

              var _f6 = _d6 * _e6;
              var _f7 = _d7 * _e7;
              var _f8 = _d8 * _e8;

              var _total_renewal = _f6 + _f7 + _f8;
              var calc_currency = $('.calculator-form').attr('data-currency');

              _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_total_renewal);

              
              $('#renewal_lease_savings_2023').html( _currency );


              /** 
               * Operational Lease Costs
               */

              var _c12 = 1  / 100;
              var _c13 = 10 / 100;
              var _c14 = 2  / 100;
              var _c15 = 1;
              var _c16 = 2  / 100;
              var _c17 = 1  / 100;
              var _c18 = 3  / 100;
              var _c19 = 1  / 100;
              var _c20 = 5  / 100;

              var _d12 = _c12 * _c1;
              var _d13 = _c13 * _c1;
              var _d14 = _c14 * _c1;
              var _d15 = _c15 * _c1;
              var _d16 = _c16 * _c1;
              var _d17 = _c17 * _c1;
              var _d18 = _c18 * _c1;
              var _d19 = _c19 * _c1;
              var _d20 = _c20 * _c1;

              var _e12 = ( _c2 / 12 ) * 0.5;
              var _e13 = ( _c2 * 0.15 ) * 0.15;
              var _e14 = 1000;
              var _e15 = 250;
              var _e16 = ( _c2 * 0.1 ) / 12;
              var _e17 = _c2 / 4;
              var _e18 = (_c2 * 0.05) * 0.2;
              var _e19 = (_c2 * 0.02) * 0.2;
              var _e20 = (_c2 * 0.15) * 0.1;

              var _f12 = _d12 * _e12;
              var _f13 = _d13 * _e13;
              var _f14 = _d14 * _e14;
              var _f15 = _d15 * _e15;
              var _f16 = _d16 * _e16;
              var _f17 = _d17 * _e17;
              var _f18 = _d18 * _e18;
              var _f19 = _d19 * _e19;
              var _f20 = _d20 * _e20;

              var _total_operational = _f12 + _f13 + _f14 + _f15 + _f16 + _f17 + _f18 + _f19 + _f20;
              _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol',  maximumFractionDigits: 0 }).format(_total_operational);
              $('#operational_lease_savings_2023').html( _currency );

              /** 
               * Labour Lease Costs
               */

              var _total_labour = 360 * _c1;
              _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_total_labour);
              $('#labour_lease_savings_2023').html( _currency );


              var _global_total = _total_renewal + _total_operational + _total_labour;
              _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_global_total);
              $('#total_hours_saved_2023').html( _currency );


              var _perc_renewal = _total_renewal > 0 ? _total_renewal * 100 / _global_total : 0;
              var _perc_operational = _total_operational > 0 ? _total_operational * 100 / _global_total : 0;
              var _perc_labour = _total_labour > 0 ? _total_labour * 100 / _global_total : 0;

              $('#renewal_lease_percentage_2023').html(Math.round(_perc_renewal));
              $('#operational_lease_percentage_2023').html(Math.round(_perc_operational));
              $('#labour_lease_percentage_2023').html(Math.round(_perc_labour));

              if (scrollDown) {
                jQuery('html, body').animate({
                  scrollTop: jQuery('#calculator_results_title_2023').offset().top - 100
                }, 500);
              }

              // END OF APAC VERSION
            } else {
              if ( 'ZAR' === currency ) {
                // ZA version

                // Table: 
                // https://docs.google.com/spreadsheets/d/1q3u6eL3WGQF2nZn8haHo-wzSR6-56dyU/edit#gid=1800441466

                // Input Numbers
                var _c1 = jQuery('#number_of_locations_2023').val(),
                    _c2 = jQuery('#average_lease_cost_2023').val(),
                    _c3 = jQuery('#average_sale_per_location_2023').val(),
                    _currency = 0;
                _c3 = _c3 ? _c3 : 0;
                /** 
                 * Renewal Lease Costs
                 */

                var _c6 = 1 / 100;
                var _c7 = 1 / 100;
                var _c8 = 1 / 100;
                var _c9 = 1 / 100;

                var _d6 = _c6 * _c1 / 5;
                var _d7 = _c7 * _c1 / 5;
                var _d8 = _c8 * _c1 / 10;
                var _d9 = _c9 * _c1 / 10;

                var _e6 = _c2;
                var _e7 = _c3 / 2;
                var _e8 = _c2 / 2;
                var _e9 = _c3 > 0 ? _c2 / 2 : 0;

                var _f6 = _d6 * _e6;
                var _f7 = _d7 * _e7;
                var _f8 = _d8 * _e8;
                var _f9 = _d9 * _e9;

                var _total_renewal = _f6 + _f7 + _f8 + _f9;
                var calc_currency = $('.calculator-form').attr('data-currency');

                _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 1 }).format(_total_renewal);

                
                $('#renewal_lease_savings_2023').html( _currency );


                /** 
                 * Operational Lease Costs
                 */

                var _c12 = 1  / 100;
                var _c13 = 20 / 100;
                var _c14 = 2  / 100;
                var _c15 = 0;
                var _c16 = 2  / 100;
                var _c17 = 1  / 100;
                var _c18 = 1  / 100;
                var _c19 = 1  / 100;
                var _c20 = 5  / 100;

                var _d12 = _c12 * _c1;
                var _d13 = _c13 * _c1;
                var _d14 = _c14 * _c1;
                var _d15 = 1;
                var _d16 = _c16 * _c1;
                var _d17 = _c17 * _c1;
                var _d18 = _c18 * _c1;
                var _d19 = _c19 * _c1;
                var _d20 = _c20 * _c1;

                var _e12 = _c2 / 12;
                var _e13 = _c2 / 4 / 4;
                var _e14 = 1000;
                var _e15 = _c1 * 500;
                var _e16 = _c2 / 10 / 12;
                var _e17 = _c2 / 6;
                var _e18 = ( _c2 / 10 ) * 0.2;
                var _e19 = 20000 * 0.2;
                var _e20 = 20000 * 0.2;

                var _f12 = _d12 * _e12;
                var _f13 = _d13 * _e13;
                var _f14 = _d14 * _e14;
                var _f15 = _d15 * _e15;
                var _f16 = _d16 * _e16;
                var _f17 = _d17 * _e17;
                var _f18 = _d18 * _e18;
                var _f19 = _d19 * _e19;
                var _f20 = _d20 * _e20;

                var _total_operational = _f12 + _f13 + _f14 + _f15 + _f16 + _f17 + _f18 + _f19 + _f20;
                _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol',  maximumFractionDigits: 1 }).format(_total_operational);
                $('#operational_lease_savings_2023').html( _currency );

                /** 
                 * Labour Lease Costs
                 */

                var _total_labour = 420 * _c1;
                _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 1 }).format(_total_labour);
                $('#labour_lease_savings_2023').html( _currency );


                var _global_total = _total_renewal + _total_operational + _total_labour;
                _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 1 }).format(_global_total);
                $('#total_hours_saved_2023').html( _currency );


                var _perc_renewal = _total_renewal > 0 ? _total_renewal * 100 / _global_total : 0;
                var _perc_operational = _total_operational > 0 ? _total_operational * 100 / _global_total : 0;
                var _perc_labour = _total_labour > 0 ? _total_labour * 100 / _global_total : 0;

                $('#renewal_lease_percentage_2023').html(Math.round(_perc_renewal));
                $('#operational_lease_percentage_2023').html(Math.round(_perc_operational));
                $('#labour_lease_percentage_2023').html(Math.round(_perc_labour));

                if (scrollDown) {
                  jQuery('html, body').animate({
                    scrollTop: jQuery('#calculator_results_title_2023').offset().top - 100
                  }, 500);
                }

              } 
              else {
                // UK & US versions

                // Table: 
                // https://docs.google.com/spreadsheets/d/1q3u6eL3WGQF2nZn8haHo-wzSR6-56dyU/edit#gid=1800441466

                // Input Numbers
                var _c1 = jQuery('#number_of_locations_2023').val(),
                    _c2 = jQuery('#average_lease_cost_2023').val(),
                    _c3 = jQuery('#average_sale_per_location_2023').val(),
                    _currency = 0;
                _c3 = _c3 ? _c3 : 0;
                /** 
                 * Renewal Lease Costs
                 */

                var _c6 = 1 / 100;
                var _c7 = 1 / 100;
                var _c8 = 1 / 100;
                var _c9 = 1 / 100;

                var _d6 = _c6 * _c1 / 5;
                var _d7 = _c7 * _c1 / 5;
                var _d8 = _c8 * _c1 / 10;
                var _d9 = _c9 * _c1 / 10;

                var _e6 = _c2;
                var _e7 = _c3 / 2;
                var _e8 = _c2 / 2;
                var _e9 = _c3 > 0 ? _c2 / 2 : 0;

                var _f6 = _d6 * _e6;
                var _f7 = _d7 * _e7;
                var _f8 = _d8 * _e8;
                var _f9 = _d9 * _e9;

                var _total_renewal = _f6 + _f7 + _f8 + _f9;
                var calc_currency = $('.calculator-form').attr('data-currency');

                _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_total_renewal);

                
                $('#renewal_lease_savings_2023').html( _currency );


                /** 
                 * Operational Lease Costs
                 */

                var _c12 = 1  / 100;
                var _c13 = 20 / 100;
                var _c14 = 2  / 100;
                var _c15 = 0;
                var _c16 = 2  / 100;
                var _c17 = 1  / 100;
                var _c18 = 1  / 100;
                var _c19 = 1  / 100;
                var _c20 = 5  / 100;

                var _d12 = _c12 * _c1;
                var _d13 = _c13 * _c1;
                var _d14 = _c14 * _c1;
                var _d15 = 1;
                var _d16 = _c16 * _c1;
                var _d17 = _c17 * _c1;
                var _d18 = _c18 * _c1;
                var _d19 = _c19 * _c1;
                var _d20 = _c20 * _c1;

                var _e12 = _c2 / 12;
                var _e13 = _c2 / 4 / 4;
                var _e14 = 1000;
                var _e15 = _c1 * 200;
                var _e16 = _c2 / 10 / 12;
                var _e17 = _c2 / 6;
                var _e18 = 20000 * 0.2;
                var _e19 = 20000 * 0.2;
                var _e20 = 20000 * 0.2;

                var _f12 = _d12 * _e12;
                var _f13 = _d13 * _e13;
                var _f14 = _d14 * _e14;
                var _f15 = _d15 * _e15;
                var _f16 = _d16 * _e16;
                var _f17 = _d17 * _e17;
                var _f18 = _d18 * _e18;
                var _f19 = _d19 * _e19;
                var _f20 = _d20 * _e20;

                var _total_operational = _f12 + _f13 + _f14 + _f15 + _f16 + _f17 + _f18 + _f19 + _f20;
                _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol',  maximumFractionDigits: 0 }).format(_total_operational);
                $('#operational_lease_savings_2023').html( _currency );

                /** 
                 * Labour Lease Costs
                 */

                var _total_labour = 120 * _c1;
                _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_total_labour);
                $('#labour_lease_savings_2023').html( _currency );


                var _global_total = _total_renewal + _total_operational + _total_labour;
                _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_global_total);
                $('#total_hours_saved_2023').html( _currency );


                var _perc_renewal = _total_renewal > 0 ? _total_renewal * 100 / _global_total : 0;
                var _perc_operational = _total_operational > 0 ? _total_operational * 100 / _global_total : 0;
                var _perc_labour = _total_labour > 0 ? _total_labour * 100 / _global_total : 0;

                $('#renewal_lease_percentage_2023').html(Math.round(_perc_renewal));
                $('#operational_lease_percentage_2023').html(Math.round(_perc_operational));
                $('#labour_lease_percentage_2023').html(Math.round(_perc_labour));

                if (scrollDown) {
                  jQuery('html, body').animate({
                    scrollTop: jQuery('#calculator_results_title_2023').offset().top - 100
                  }, 500);
                }
              }
            }
          }
        },
        roi_calculator_2023_energy: function() {
          // ROI Calculator
          if (jQuery('#calculatorForm_2023_energy').length) {

            function roi_mri_has_url_param_e( url, parameter ) {
              if ( url.indexOf('?' + parameter) !== -1 ) {
                return true;
              }
              else {
                if ( url.indexOf('&' + parameter) !== -1 ) {
                  return true;
                }
              }
              return false;
            }

            function addParameterToURL_ROI_e( _url, param ) {
              _url += (_url.split('?')[1] ? '&':'?') + param;
              return _url;
            }

            var $form = jQuery('#calculatorForm_2023_energy');

            $form.find('input.form-control-number').on( "keyup", function( event ) {
              // When user select text in the document, also abort.
              var selection = window.getSelection().toString();
              if ( selection !== '' ) {
                return;
              }
              
              // When the arrow keys are pressed, abort.
              if ( $.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
                return;
              }
              
              
              var $this = $( this );
              
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );;
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );
              console.warn(input)
            });

            $form.on('submit', function(e) {
              console.warn('show_next');
              jQuery('.js-show-form').show().removeClass('not-loaded');
                e.preventDefault();

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('nitro-lazy-src');
                  var iframe      = $(this); 
                  var input_1     = $('input[name="property_type"]:checked').val();
                  var input_2     = $('#energy_cost_2023_energy').val();

                  if ( iframe_src && ( input_1 || input_2 ) ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';
                      if ( input_1 ) {
                        input_pname = $('input[name="property_type"]:checked').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( input_2 ) {
                        input_pname = $('#energy_cost_2023_energy').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      console.warn(has_change);
                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('src');
                  var iframe      = $(this); 
                  var input_1     = $('input[name="property_type"]:checked').val();
                  var input_2     = $('#energy_cost_2023_energy').val();
                  if ( iframe_src && ( input_1 || input_2 || input_3 ) ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';
                      if ( input_1 ) {
                        input_pname = $('input[name="property_type"]:checked').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( input_2 ) {
                        input_pname = $('#energy_cost_2023_energy').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      console.warn(has_change);
                      
                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('html, body').animate({
                  scrollTop: jQuery('.roi-calculator-signup-section').offset().top - 100
                }, 500);

                calculate_totals_2023_energy(false);
            });

          }

          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

          eventer(messageEvent, function (e) {
            if ( $('.roi-calculator-contact-form-2023_energy').length > 0 ) {
              if (e.data === "mri_pardot_form_submit" || e.message === "mri_pardot_form_submit") {
                // code to be trigger when confirmation page is loaded
                jQuery('.roi-calculator-contact-form-2023_energy').hide();
                jQuery('.js-open-onsubmit').show();
                calculate_totals_2023_energy(true);
              }
            }
            
          });

          function calculate_totals_2023_energy( scrollDown ) {
            // Table: 
            // https://docs.google.com/spreadsheets/d/1q3u6eL3WGQF2nZn8haHo-wzSR6-56dyU/edit#gid=1800441466

            var input_1       = $('input[name="property_type"]:checked').val();
            var input_2       = parseInt( $('#energy_cost_2023_energy').val() );
            var calc_currency = $('.calculator-form').attr('data-currency');

            var savings     = 0;

            if ( input_1 === 'Commercial Office' ) {
              console.warn('1');
              if ( input_2 > 0 && input_2 < 1000000 ) {
                savings = ( 22 * input_2 ) / 100;
                console.warn('1.1');
              }

              if ( input_2 >= 1000000 && input_2 < 3000000 ) {
                savings = ( 20 * input_2 ) / 100;
                console.warn('1.2');
              }

              if (  input_2 >= 3000000 ) {
                savings = ( 15 * input_2 ) / 100;
                console.warn('1.3');
              }
            }

            if ( input_1 === 'Industrial' ) {
              console.warn('2');
              if ( input_2 > 0 && input_2 < 2000000 ) {
                savings = ( 12 * input_2 ) / 100;
                console.warn('2.1');
              }

              if ( input_2 >= 2000000 && input_2 < 10000000 ) {
                savings = ( 10 * input_2 ) / 100;
                console.warn('2.2');
              }

              if (  input_2 >= 10000000 ) {
                savings = ( 5 * input_2 ) / 100;
                console.warn('2.3');
              }
            }

            if ( input_1 === 'Retail' ) {
              console.warn('3');
              if ( input_2 > 0 && input_2 < 2000000 ) {
                savings = ( 20 * input_2 ) / 100;
                console.warn('3.1');
              }

              if ( input_2 >= 2000000 && input_2 < 5000000 ) {
                savings = ( 16 * input_2 ) / 100;
                console.warn('3.2');
              }

              if (  input_2 >= 5000000 ) {
                savings = ( 12 * input_2 ) / 100;
                console.warn('3.3');
              }
            }

            if ( input_1 === 'Healthcare' ) {
              console.warn('4');
              if ( input_2 > 0 && input_2 < 2000000 ) {
                savings = ( 15 * input_2 ) / 100;
                console.warn('4.1');
              }

              if ( input_2 >= 2000000 && input_2 < 5000000 ) {
                savings = ( 12 * input_2 ) / 100;
                console.warn('4.2');
              }

              if (  input_2 >= 5000000 ) {
                savings = ( 9 * input_2 ) / 100;
                console.warn('4.3');
              }
            }

            var savings = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(savings);

            $('#total_hours_saved_2023_energy').html(savings)


            // $('#renewal_lease_percentage_2023').html(Math.round(_perc_renewal));
            // $('#operational_lease_percentage_2023').html(Math.round(_perc_operational));
            // $('#labour_lease_percentage_2023').html(Math.round(_perc_labour));

            if (scrollDown) {
              jQuery('html, body').animate({
                scrollTop: jQuery('#calculator_results_2023_energy').offset().top - 100
              }, 500);
            }
          }
        },

        roi_calculator_2024_energy4: function() {
          // ROI Calculator
          if (jQuery('#calculatorForm_2024_energy4').length) {

            function roi_mri_has_url_param_e( url, parameter ) {
              if ( url.indexOf('?' + parameter) !== -1 ) {
                return true;
              }
              else {
                if ( url.indexOf('&' + parameter) !== -1 ) {
                  return true;
                }
              }
              return false;
            }

            function addParameterToURL_ROI_e( _url, param ) {
              _url += (_url.split('?')[1] ? '&':'?') + param;
              return _url;
            }

            var $form = jQuery('#calculatorForm_2024_energy4');

            $form.find('input.form-control-number').on( "keyup", function( event ) {
              // When user select text in the document, also abort.
              var selection = window.getSelection().toString();
              if ( selection !== '' ) {
                return;
              }
              
              // When the arrow keys are pressed, abort.
              if ( $.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
                return;
              }
              
              
              var $this = $( this );
              
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );;
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );

              var _id = $(this).closest('.form-holder').find('input[type="hidden"]').attr('id');
              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input );
              // console.warn(input)

            });

            $form.find('input.form-control').on( "change", function( event ) {
              var input_val = $(this).val();
              var _id = $(this).attr('id');
              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input_val );
              console.warn('ccha23 - ' + input_val);
            });

            $form.on('submit', function(e) {
              // console.warn('show_next');
              if ( $(this).closest('.calculator-form').attr('data-fvis') === 'visible' ) {

                jQuery('.js-show-form').show().removeClass('not-loaded');
                e.preventDefault();

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('nitro-lazy-src');
                  var iframe      = $(this); 
                  var input_1       = $('#avg_sqft').val();
                  var input_2       = $('#energy_costs').val();
                  var input_3       = $('#lighting_costs').val();
                  var input_4       = $('#locations').val();

                  if ( iframe_src && ( input_1 || input_2 || input_3 || input_4 ) ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';
                      if ( input_1 ) {
                        input_pname = $('#avg_sqft').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( input_2 ) {
                        input_pname = $('#energy_costs').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      if ( input_3 ) {
                        input_pname = $('#lighting_costs').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      if ( input_4 ) {
                        input_pname = $('#locations').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      console.warn(has_change);
                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('src');
                  var iframe      = $(this); 
                  var input_1       = $('#avg_sqft').val();
                  var input_2       = $('#energy_costs').val();
                  var input_3       = $('#lighting_costs').val();
                  var input_4       = $('#locations').val();
                  if ( iframe_src && ( input_1 || input_2 || input_3 || input_4 ) ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';

                      if ( input_1 ) {
                        input_pname = $('#avg_sqft').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( input_2 ) {
                        input_pname = $('#energy_costs').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      if ( input_3 ) {
                        input_pname = $('#lighting_costs').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      if ( input_4 ) {
                        input_pname = $('#locations').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      console.warn(has_change);
                      
                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('html, body').animate({
                  scrollTop: jQuery('.roi-calculator-signup-section').offset().top - 100
                }, 500);

                calculate_totals_2024_energy4(false);
              }

              if ( $(this).closest('.calculator-form').attr('data-fvis') === 'hidden' ) {
                e.preventDefault();
                if ( $('#calculatorForm_2024_energy4_ty').length > 0 ) {
                  $('#calculatorForm_2024_energy4_ty').submit();                
                } else {
                  jQuery('.roi-calculator-contact-form-2024_energy4').hide();
                  jQuery('.js-open-onsubmit').show();
                  calculate_totals_2024_energy4(true);
                }
              }
            });

          }

          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

          eventer(messageEvent, function (e) {
            if ( $('.roi-calculator-contact-form-2024_energy4').length > 0 ) {
              if (e.data === "mri_pardot_form_submit" || e.message === "mri_pardot_form_submit") {
                // code to be trigger when confirmation page is loaded

                if ( $('#calculatorForm_2024_energy4_ty').length > 0 ) {
                  $('#calculatorForm_2024_energy4_ty').submit();        
                  console.warn('1');        
                } else {
                  jQuery('.roi-calculator-contact-form-2024_energy4').hide();
                  jQuery('.js-open-onsubmit').show();
                  calculate_totals_2024_energy4(true);
                }
              }
            }
            
          });

          if ( $('body').hasClass('products-template-template-roi-calculator-2024-energy4-ty') || $('body').hasClass('page-template-template-roi-calculator-2024-energy4-ty') ) {
            jQuery('.js-open-onsubmit').show();

            $(document).find('input.form-control-number').each( function() {
              var $this = $( this );
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );
              var _id = $(this).closest('.form-holder').find('input[type="hidden"]').attr('id');

              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input );
            });

            $form.find('input.form-control').on( "change", function( event ) {
              var input_val = $(this).val();
              var _id = $(this).attr('id');
              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input_val );
              console.warn('ccha23 - ' + input_val);
            });

            calculate_totals_2024_energy4(true);

            if ( $('.roi-calculator-signup-section-ty').length > 0 ) {
              jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                var iframe_src  = $(this).attr('nitro-lazy-src');
                var iframe      = $(this); 
                var input_1       = $('#avg_sqft').val();
                var input_2       = $('#energy_costs').val();
                var input_3       = $('#lighting_costs').val();
                var input_4       = $('#locations').val();

                if ( iframe_src && ( input_1 || input_2 || input_3 || input_4 ) ) {
                  try {
                    var has_change      = false;
                    var input_pname     = '';
                    if ( input_1 ) {
                      input_pname = $('#avg_sqft').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                        has_change = true;
                      }
                    }

                    if ( input_2 ) {
                      input_pname = $('#energy_costs').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    if ( input_3 ) {
                      input_pname = $('#lighting_costs').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    if ( input_4 ) {
                      input_pname = $('#locations').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    console.warn(has_change);
                    if ( has_change ) {
                      iframe.attr('nitro-lazy-src', iframe_src);
                      iframe.attr('src', iframe_src);
                    }
                  } catch(err) {
                    console.warn(err);
                  }
                }
              });

              jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                var iframe_src  = $(this).attr('src');
                var iframe      = $(this); 
                var input_1       = $('#avg_sqft').val();
                var input_2       = $('#energy_costs').val();
                var input_3       = $('#lighting_costs').val();
                var input_4       = $('#locations').val();
                if ( iframe_src && ( input_1 || input_2 || input_3 || input_4 ) ) {
                  try {
                    var has_change      = false;
                    var input_pname     = '';

                    if ( input_1 ) {
                      input_pname = $('#avg_sqft').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                        has_change = true;
                      }
                    }

                    if ( input_2 ) {
                      input_pname = $('#energy_costs').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    if ( input_3 ) {
                      input_pname = $('#lighting_costs').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    if ( input_4 ) {
                      input_pname = $('#locations').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    console.warn(has_change);
                    
                    if ( has_change ) {
                      iframe.attr('nitro-lazy-src', iframe_src);
                      iframe.attr('src', iframe_src);
                    }
                  } catch(err) {
                    console.warn(err);
                  }
                }
              });
            }

          }

          function calculate_totals_2024_energy4( scrollDown ) {
            // Table: 
            // https://docs.google.com/spreadsheets/d/1C7QHAUvQvZd0RKNM7Z-R3SNCQDMn72GsEmd3LoPGnRw/edit?gid=942817942#gid=942817942
            var _currency = 0;
            var input_1       = $('#avg_sqft').val();
            var input_2       = $('#energy_costs').val();
            var input_3       = $('#lighting_costs').val();
            var input_4       = $('#locations').val();

            var calc_currency = $('.calculator-form').attr('data-currency');

            var savings     = 0;

            var _b1 = input_1;
            var _b5 = input_2;
            var _b6 = input_3;
            var _c5 = input_4;
            var _c6 = _c5;


            var _e5 = _b5 * _b1; // Energy / Location
            var _e6 = _b6 * _b1; // Light / Location
            var _g5 = _c5 * _e5; // Total Energy
            var _g6 = _c6 * _e6; // Total Light


            // Lighting & overheads 

            var _e10 = ( _g5 * 5 ) / 100;
            var _e11 = ( _g5 * 3 ) / 100;
            var _e12 = ( _g6 * 6 ) / 100;
            var _e13 = ( _g6 * 6 ) / 100;

            var _e14 = _e10 + _e11 + _e12 + _e13; // TOTAL 
            console.warn(_e14);

            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_e14);
            $('#lighting_overheads_2024').html( _currency );
            
            // ******************* //

            // Energy Savings

            var _e15 = ( _g5 * 2 ) / 100;
            var _e16 = ( _g5 * 5 ) / 100;
            var _e17 = ( _g5 * 1 ) / 100;

            var _e18 = _e15 + _e16 + _e17; // TOTAL 
            console.warn(_e18);

            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_e18);
            $('#energy_savings_2024').html( _currency );

            // ******************* //

            // Cost Avoidance

            var _e19 = ( 5000 * _c5 ) * 5 / 100;
            var _e20 = ( 10000 * _c5 ) * 5 / 100;
            var _e21 = ( 10000 * _c5 ) * 3 / 100;
            var _e22 = ( 1000 * _c5 ) * 5 / 100;

            var _e24 = _e19 + _e20 + _e21 + _e22; // TOTAL 
            console.warn(_e24);

            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_e24);
            $('#cost_avoidance_2024').html( _currency );


            // ===***===***=== //
            var _global_total = _e14 + _e18 + _e24;
            console.warn(_global_total);


            var _perc_lighting        = _e14 > 0 ? _e14 * 100 / _global_total : 0;
            var _perc_energy          = _e18 > 0 ? _e18 * 100 / _global_total : 0;
            var _perc_cost_avoidance  = _e24 > 0 ? _e24 * 100 / _global_total : 0;

            $('#lighting_overheads_percentage_2024').html(parseFloat(_perc_lighting).toFixed(1));
            $('#energy_savings_percentage_2024').html(parseFloat(_perc_energy).toFixed(1));
            $('#cost_avoidance_percentage_2024').html(parseFloat(_perc_cost_avoidance).toFixed(1));

            var savings = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_global_total);

            $('#total_hours_saved_2024_energy4').html(savings)

            if (scrollDown) {
              jQuery('html, body').animate({
                scrollTop: jQuery('#calculator_results_title_2024').offset().top - 100
              }, 500);
            }
          }
        },
        roi_calculator_2024_ram: function() {
          // ROI Calculator
          if (jQuery('#calculatorForm_2024_ram').length) {
            function roi_mri_has_url_param_e( url, parameter ) {
              if ( url.indexOf('?' + parameter) !== -1 ) {
                return true;
              }
              else {
                if ( url.indexOf('&' + parameter) !== -1 ) {
                  return true;
                }
              }
              return false;
            }

            function addParameterToURL_ROI_e( _url, param ) {
              _url += (_url.split('?')[1] ? '&':'?') + param;
              return _url;
            }

            var $form = jQuery('#calculatorForm_2024_ram');

            $form.find('input.form-control-number').on( "keyup", function( event ) {
              // When user select text in the document, also abort.
              var selection = window.getSelection().toString();
              if ( selection !== '' ) {
                return;
              }
              
              // When the arrow keys are pressed, abort.
              if ( $.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
                return;
              }
              
              
              var $this = $( this );
              
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );;
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );
            });

            $form.on('submit', function(e) {
              jQuery('.js-show-form').show().removeClass('not-loaded');
                e.preventDefault();

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('nitro-lazy-src');
                  var iframe      = $(this); 
                  var input_1     = $('input[name="number_of_areas"]').val();

                  if ( iframe_src && input_1 ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';
                      if ( input_1 ) {
                        input_pname = $('input[name="number_of_areas"]').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }
                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('src');
                  var iframe      = $(this); 
                  var input_1     = $('input[name="number_of_areas"]').val();
                  if ( iframe_src && input_1 ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';
                      if ( input_1 ) {
                        input_pname = $('input[name="number_of_areas"]').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('html, body').animate({
                  scrollTop: jQuery('.roi-calculator-signup-section').offset().top - 100
                }, 500);

                calculate_totals_2024_ram(false);
            });

          }

          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

          eventer(messageEvent, function (e) {
            if ( $('.roi-calculator-contact-form-2024_ram').length > 0 ) {
              if (e.data === "mri_pardot_form_submit" || e.message === "mri_pardot_form_submit") {
                // code to be trigger when confirmation page is loaded
                jQuery('.roi-calculator-contact-form-2024_ram').hide();
                jQuery('.js-open-onsubmit').show();
                calculate_totals_2024_ram(true);
              }
            }
            
          });

          function calculate_totals_2024_ram( scrollDown ) {
            // Table: 
            // https://docs.google.com/spreadsheets/d/1PfLg8zJuXDTYXazLDMsSou8CXqMZm460/edit#gid=74865556

            var _b6       = $('input[name="number_of_areas"]').val();
            
            var calc_currency = $('.calculator-form').attr('data-currency');

            var savings     = 0;
            var _currency   = 0;

            var savings = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(savings);

            var _b7   = _b6 * 0.04;
            var _b8   = _b6 * 0.2;
            var _b9   = 30000;
            var _b10  = 15;
            var _b13  = (_b6 /100) * 43;
            var _c13  = (_b13 * _b10) / 60;
            var _d13  = (_b9 / 52) / 37.5;
            var _e13  = ( _d13 * _c13 ) * 52; // total 1

          
            var _b16  = (_b7 / 100) * 40;
            var _c16  = (_b16 * _b10) / 60;
            var _d16  = (_b9 / 52) / 37.5;
            var _e16  = (_d16 * _c16) * 52; // total 2

            var _b19  = _b8;
            var _c19  = (_b19 * _b10) / 60;
            var _d19  = (_b9 / 52) / 37.5;
            var _e19  = (_d19 * _c19 ) * 52; // total 3

            var _e20  = ( ( _b16 * 52 ) * 10 ) - ( ( _b16 * 52) * 0.04 ); // sms total

            var _e21  = _e13 + _e16 + _e19 + _e20; // global total

            var _output1 = _e21;
            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_output1);
            $('#output_1').html( _currency );

            var _output2 = _e13 + _e16 + _e19;
            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_output2);
            $('#output_2').html( _currency );

            var _output3 = _e20;
            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(_output3);
            $('#output_3').html( _currency );

            var _output4 = _c13 + _c16 + _c19; // hours, we don't need currency;          
            $('#output_4').html( _output4 );

            if (scrollDown) {
              jQuery('html, body').animate({
                scrollTop: jQuery('#calculator_results_title_2024_ram').offset().top - 100
              }, 500);
            }
          }
        },
        roi_calculator_2024_mci: function() {
          // ROI Calculator
          if (jQuery('#calculatorForm_2024_mci').length) {
            function roi_mri_has_url_param_e( url, parameter ) {
              if ( url.indexOf('?' + parameter) !== -1 ) {
                return true;
              }
              else {
                if ( url.indexOf('&' + parameter) !== -1 ) {
                  return true;
                }
              }
              return false;
            }

            function addParameterToURL_ROI_e( _url, param ) {
              _url += (_url.split('?')[1] ? '&':'?') + param;
              return _url;
            }

            var $form = jQuery('#calculatorForm_2024_mci');

            $form.find('input.form-control-number').on( "keyup", function( event ) {
              // When user select text in the document, also abort.
              var selection = window.getSelection().toString();
              if ( selection !== '' ) {
                return;
              }
              
              // When the arrow keys are pressed, abort.
              if ( $.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
                return;
              }
              
              
              var $this = $( this );
              
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );;
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );
            });

            $form.on('submit', function(e) {
              jQuery('.js-show-form').show().removeClass('not-loaded');
                e.preventDefault();

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('nitro-lazy-src');
                  var iframe      = $(this); 
                  var input_1     = $('input[name="number_of_areas"]').val();
                  var input_2     = $('input[name="average_annual_contract_value"]').val();

                  if ( iframe_src && input_1 && input_2 ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';
                      if ( input_1 ) {
                        input_pname = $('input[name="number_of_areas"]').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( input_2 ) {
                        input_pname = $('input[name="average_annual_contract_value"]').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('src');
                  var iframe      = $(this); 
                  var input_1     = $('input[name="number_of_leases"]').val();
                  var input_2     = $('input[name="average_annual_contract_value"]').val();
                  if ( iframe_src && input_1 && input_2 ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';
                      if ( input_1 ) {
                        input_pname = $('input[name="number_of_leases"]').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( input_2 ) {
                        input_pname = $('input[name="average_annual_contract_value"]').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('html, body').animate({
                  scrollTop: jQuery('.roi-calculator-signup-section').offset().top - 100
                }, 500);

                calculate_totals_2024_mci(false);
            });

          }

          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

          eventer(messageEvent, function (e) {
            if ( $('.roi-calculator-contact-form-2024_mci').length > 0 ) {
              if (e.data === "mri_pardot_form_submit" || e.message === "mri_pardot_form_submit") {
                // code to be trigger when confirmation page is loaded
                jQuery('.roi-calculator-contact-form-2024_mci').hide();
                jQuery('.js-open-onsubmit').show();
                calculate_totals_2024_mci(true);
              }
            }
            
          });

          function calculate_totals_2024_mci( scrollDown ) {
            // Table: 
            var input_1     = $('input[name="number_of_leases"]').val();
            var input_2     = parseInt( $('input[name="average_annual_contract_value"]').val() );

            var multiplier = '1.1x';
            if ( input_2 >= 100000 ) {
              multiplier = '3.5x';
            }

            if ( input_2 >= 200000 ) {
              multiplier = '5.8x';
            }

            if ( input_2 >= 300000 ) {
              multiplier = '8.1x';
            }

            if ( input_2 >= 400000 ) {
              multiplier = '10.5x';
            }

            if ( input_2 >= 500000 ) {
              multiplier = '12.8x';
            }

            $('strong.multiplier').html(multiplier)

            if (scrollDown) {
              jQuery('html, body').animate({
                scrollTop: jQuery('#calculator_results_title_2024_mci').offset().top - 100
              }, 500);
            }

          }
        },
        roi_calculator_2025_energy: function() {
          // ROI Calculator
          if (jQuery('#calculatorForm_2025_energy').length) {

            function roi_mri_has_url_param_e( url, parameter ) {
              if ( url.indexOf('?' + parameter) !== -1 ) {
                return true;
              }
              else {
                if ( url.indexOf('&' + parameter) !== -1 ) {
                  return true;
                }
              }
              return false;
            }

            function addParameterToURL_ROI_e( _url, param ) {
              _url += (_url.split('?')[1] ? '&':'?') + param;
              return _url;
            }

            var $form = jQuery('#calculatorForm_2025_energy');

            $form.find('input.form-control-number').on( "keyup", function( event ) {
              // When user select text in the document, also abort.
              var selection = window.getSelection().toString();
              if ( selection !== '' ) {
                return;
              }
              
              // When the arrow keys are pressed, abort.
              if ( $.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
                return;
              }
              
              
              var $this = $( this );
              
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );;
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );

              var _id = $(this).closest('.form-holder').find('input[type="hidden"]').attr('id');
              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input );
              // console.warn(input)

            });

            $form.find('input.form-control').on( "change", function( event ) {
              var input_val = $(this).val();
              var _id = $(this).attr('id');
              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input_val );
              console.warn('ccha23 - ' + input_val);
            });

            $form.on('submit', function(e) {
              // console.warn('show_next');
              if ( $(this).closest('.calculator-form').attr('data-fvis') === 'visible' ) {

                jQuery('.js-show-form').show().removeClass('not-loaded');
                e.preventDefault();

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('nitro-lazy-src');
                  var iframe      = $(this); 
                  var input_1       = $('#building_type').val();
                  var input_2       = $('#number_of_locations').val();
                  var input_3       = $('#total_energy_costs').val();

                  if ( iframe_src && ( input_1 || input_2 || input_3 || input_4 ) ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';
                      if ( input_1 ) {
                        input_pname = $('#building_type').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( input_2 ) {
                        input_pname = $('#number_of_locations').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      if ( input_3 ) {
                        input_pname = $('#total_energy_costs').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      console.warn(has_change);
                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                  var iframe_src  = $(this).attr('src');
                  var iframe      = $(this); 
                  var input_1       = $('#building_type').val();
                  var input_2       = $('#number_of_locations').val();
                  var input_3       = $('#total_energy_costs').val();
                  if ( iframe_src && ( input_1 || input_2 || input_3  ) ) {
                    try {
                      var has_change      = false;
                      var input_pname     = '';

                      if ( input_1 ) {
                        input_pname = $('#building_type').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                          has_change = true;
                        }
                      }

                      if ( input_2 ) {
                        input_pname = $('#number_of_locations').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      if ( input_3 ) {
                        input_pname = $('#total_energy_costs').closest('.form-group').attr('data-pname');
                        if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                          iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                          has_change = true;
                        }
                      }

                      console.warn(has_change);
                      
                      if ( has_change ) {
                        iframe.attr('nitro-lazy-src', iframe_src);
                        iframe.attr('src', iframe_src);
                      }
                    } catch(err) {
                      console.warn(err);
                    }
                  }
                });

                jQuery('html, body').animate({
                  scrollTop: jQuery('.roi-calculator-signup-section').offset().top - 100
                }, 500);

                calculate_totals_2025_energy(false);
              }

              if ( $(this).closest('.calculator-form').attr('data-fvis') === 'hidden' ) {
                e.preventDefault();
                if ( $('#calculatorForm_2025_energy_ty').length > 0 ) {
                  $('#calculatorForm_2025_energy_ty').submit();                
                } else {
                  jQuery('.roi-calculator-contact-form-2025_energy').hide();
                  jQuery('.js-open-onsubmit').show();
                  calculate_totals_2025_energy(true);
                }
              }
            });

          }

          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

          eventer(messageEvent, function (e) {
            if ( $('.roi-calculator-contact-form-2025_energy').length > 0 ) {
              if (e.data === "mri_pardot_form_submit" || e.message === "mri_pardot_form_submit") {
                // code to be trigger when confirmation page is loaded

                if ( $('#calculatorForm_2025_energy_ty').length > 0 ) {
                  $('#calculatorForm_2025_energy_ty').submit();        
                  console.warn('1');        
                } else {
                  jQuery('.roi-calculator-contact-form-2025_energy').hide();
                  jQuery('.js-open-onsubmit').show();
                  calculate_totals_2025_energy(true);
                }
              }
            }
            
          });

          if ( $('body').hasClass('products-template-template-roi-calculator-2025-energy-ty') || $('body').hasClass('page-template-template-roi-calculator-2025-energy-ty') ) {
            jQuery('.js-open-onsubmit').show();

            $(document).find('input.form-control-number').each( function() {
              var $this = $( this );
              // Get the value.
              var input = $this.val();
              
              var input = input.replace(/[\D\s\._\-]+/g, "");
                  input = input ? parseInt( input, 10 ) : 0;

                  $this.val( function() {
                    return ( input === 0 ) ? "" : input.toLocaleString( "en-US" );
                  } );
              $(this).closest('.form-holder').find('input[type="hidden"]').val( input );
              var _id = $(this).closest('.form-holder').find('input[type="hidden"]').attr('id');

              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input );
            });

            $form.find('input.form-control').on( "change", function( event ) {
              var input_val = $(this).val();
              var _id = $(this).attr('id');
              $(this).closest('.calculator-form').find('#' + _id + '_ty').val( input_val );
              console.warn('ccha23 - ' + input_val);
            });

            calculate_totals_2025_energy(true);

            if ( $('.roi-calculator-signup-section-ty').length > 0 ) {
              jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                var iframe_src  = $(this).attr('nitro-lazy-src');
                var iframe      = $(this); 
                var input_1       = $('#building_type').val();
                var input_2       = $('#number_of_locations').val();
                var input_3       = $('#total_energy_costs').val();

                if ( iframe_src && ( input_1 || input_2 || input_3 ) ) {
                  try {
                    var has_change      = false;
                    var input_pname     = '';
                    if ( input_1 ) {
                      input_pname = $('#building_type').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                        has_change = true;
                      }
                    }

                    if ( input_2 ) {
                      input_pname = $('#number_of_locations').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    if ( input_3 ) {
                      input_pname = $('#total_energy_costs').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    console.warn(has_change);
                    if ( has_change ) {
                      iframe.attr('nitro-lazy-src', iframe_src);
                      iframe.attr('src', iframe_src);
                    }
                  } catch(err) {
                    console.warn(err);
                  }
                }
              });

              jQuery('.roi-calculator-signup-section').find('.pardotform').each(function() {
                var iframe_src  = $(this).attr('src');
                var iframe      = $(this); 
                var input_1       = $('#building_type').val();
                var input_2       = $('#number_of_locations').val();
                var input_3       = $('#total_energy_costs').val();
                if ( iframe_src && ( input_1 || input_2 || input_3 ) ) {
                  try {
                    var has_change      = false;
                    var input_pname     = '';

                    if ( input_1 ) {
                      input_pname = $('#building_type').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_1) );
                        has_change = true;
                      }
                    }

                    if ( input_2 ) {
                      input_pname = $('#number_of_locations').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    if ( input_3 ) {
                      input_pname = $('#total_energy_costs').closest('.form-group').attr('data-pname');
                      if ( input_pname && ! roi_mri_has_url_param_e( iframe_src, input_pname ) ) {
                        iframe_src = addParameterToURL_ROI_e( iframe_src, input_pname+'='+encodeURIComponent(input_2) );
                        has_change = true;
                      }
                    }

                    console.warn(has_change);
                    
                    if ( has_change ) {
                      iframe.attr('nitro-lazy-src', iframe_src);
                      iframe.attr('src', iframe_src);
                    }
                  } catch(err) {
                    console.warn(err);
                  }
                }
              });
            }
          }
          function calculate_totals_2025_energy( scrollDown ) {
            // Table: 
            // https://docs.google.com/spreadsheets/d/13oiIpJn_BFKo8Ft8pp05GkgVah1uOYVjQeejWgCl3gc/edit?gid=468851763#gid=468851763
            var _currency = 0;
            var input_1       = $('#building_type').val();
            var input_2       = $('#number_of_locations').val();
            var input_3       = $('#total_energy_costs').val();

            var calc_currency = $('.calculator-form').attr('data-currency');

            var savings     = 0;

            var lo              = input_3 * 0.08;   // industrial - default
            var hvac            = input_3 * 0.15;  // industrial - default
            var percentage_1    = 0.09;   // industrial - default
            var percentage_2    = 0.038;  // industrial - default
            var cost_avoidance  = ( input_3 * 3 * 0.62 ) * ( 16 / 3 ) / 100;

            if ( input_1 === 'commercial-office' ) {
              lo    = input_3 * 0.12;
              hvac  = input_3 * 0.59;
              percentage_1  = 0.05;
              percentage_2  = 0.048;
              cost_avoidance  = input_3 * 3 * 0.02;
            }

            if ( input_1 === 'education' ) {
              lo    = input_3 * 0.15;
              hvac  = input_3 * 0.61;
              percentage_1  = 0.06;
              percentage_2  = 0.05;
              cost_avoidance  = input_3 * 3 * 0.02;
            }

            if ( input_1 === 'healthcare' ) {
              lo    = input_3 * 0.15;
              hvac  = input_3 * 0.63;
              percentage_1  = 0.065;
              percentage_2  = 0.044;
              cost_avoidance  = input_3 * 3 * 0.02;
            }

            if ( input_1 === 'other' ) {
              lo    = input_3 * 0.12;
              hvac  = input_3 * 0.59;
              percentage_1  = 0.05;
              percentage_2  = 0.048;
              cost_avoidance  = input_3 * 3 * 0.02;
            }

            var lighting_eff = ( lo * 2 ) * percentage_1;

            var hvac_dhw_off = ( hvac * 5 ) * percentage_2;

            var savings = lighting_eff + hvac_dhw_off + cost_avoidance;
            var savings_perc = savings / input_3;

            console.warn('inputs here');

            console.warn(input_1);
            console.warn(input_2);
            console.warn(input_3);

            console.warn('Fixed Results');
            console.warn('Light - Office ' + lo);
            console.warn('HVAC+DHW - Off ' + hvac);

            console.warn('Calculated Results');
            console.warn('Lighting Efficiencies  ->  ' + lighting_eff);
            console.warn('HVAC and Equipment Savings  ->  ' + hvac_dhw_off);
            console.warn('Cost Avoidance  ->  ' + cost_avoidance);



            var _perc_lighting        = lighting_eff > 0 ? lighting_eff * 100 / input_3 : 0;
            var _perc_energy          = hvac_dhw_off > 0 ? hvac_dhw_off * 100 / input_3 : 0;
            var _perc_cost_avoidance  = cost_avoidance > 0 ? cost_avoidance * 100 / input_3 : 0;

            $('#lighting_overheads_percentage_2025').html(parseFloat(_perc_lighting).toFixed(1));
            $('#energy_savings_percentage_2025').html(parseFloat(_perc_energy).toFixed(1));
            $('#cost_avoidance_percentage_2025').html(parseFloat(_perc_cost_avoidance).toFixed(1));

            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format( lighting_eff );
            $('#lighting_overheads_2025').html( _currency );

            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format( hvac_dhw_off );
            $('#energy_savings_2025').html( _currency );

            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format( cost_avoidance );
            $('#cost_avoidance_2025').html( _currency );


            _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(savings);

            var curperc = _perc_lighting + _perc_energy + _perc_cost_avoidance;
            var multiplier = Math.pow(10, 1 || 0);

            curperc = Math.round( curperc * multiplier ) / multiplier;

            _currency = _currency + ' (' + curperc + '%)';
            $('#total_hours_saved_2025_energy').html( _currency );


            // _currency = new Intl.NumberFormat('en-GB', { style: 'currency', currency: calc_currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(savings * input_2);

            // $('#total_hours_saved_2025_energy_all').html(_currency);

            if (scrollDown) {
              jQuery('html, body').animate({
                scrollTop: jQuery('#calculator_results_title_2025').offset().top - 100
              }, 500);
            }
          }
        },
        lease_pricing_calculator: function() {
          // Flex module - an editor can place more than one per page, so each
          // instance gets its own scope rather than sharing module-level state.
          jQuery('.lease-pricing-calculator').each(function() {
            var $section = jQuery( this );
            var tiers    = [];

            try {
              tiers = JSON.parse( $section.attr('data-tiers') ) || [];
            } catch ( err ) {
              console.warn( 'Lease pricing: could not parse tiers', err );
              return;
            }

            if ( ! tiers.length ) {
              return;
            }

            var currency  = $section.attr('data-currency') || 'GBP';
            var maxLeases = parseInt( $section.attr('data-max'), 10 ) || 0;
            var $input    = $section.find('.lpc-input');
            var $enquiry  = $section.find('.lpc-enquiry');

            function lpc_format_price( amount ) {
              return new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol',
                // minimumFractionDigits defaults to 2 for currency styles; older
                // engines throw a RangeError when it exceeds the maximum.
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format( amount );
            }

            // First tier whose upper bound covers the entered number wins.
            function lpc_match_tier( leases ) {
              for ( var i = 0; i < tiers.length; i++ ) {
                if ( leases <= tiers[i].max ) {
                  return tiers[i];
                }
              }

              return false;
            }

            function lpc_show_state( state ) {
              $section.find('.lpc-result').each(function() {
                var $result = jQuery( this );
                $result.prop( 'hidden', $result.attr('data-lpc-state') !== state );
              });
            }

            // NitroPack defers iframes onto nitro-lazy-src, so both need updating.
            function lpc_pass_to_pardot( leases ) {
              var pname = $input.attr('data-pname');

              if ( ! pname || ! $enquiry.length ) {
                return;
              }

              $enquiry.find('.pardotform').each(function() {
                var $iframe = jQuery( this );
                var src     = $iframe.attr('nitro-lazy-src') || $iframe.attr('src');

                if ( ! src ) {
                  return;
                }

                // Drop any value we appended on a previous keystroke before re-adding.
                src = src.replace( new RegExp( '([?&])' + pname + '=[^&]*&?', 'g' ), '$1' )
                         .replace( /[?&]$/, '' );

                src += ( src.split('?')[1] ? '&' : '?' ) + pname + '=' + encodeURIComponent( leases );

                if ( $iframe.attr('nitro-lazy-src') ) {
                  $iframe.attr( 'nitro-lazy-src', src );
                }

                $iframe.attr( 'src', src );
              });
            }

            $input.on( 'keyup change', function( event ) {
              // When the arrow keys are pressed, abort.
              if ( event.keyCode && jQuery.inArray( event.keyCode, [38,40,37,39] ) !== -1 ) {
                return;
              }

              var $this  = jQuery( this );
              var raw    = $this.val().replace(/[\D\s\._\-]+/g, "");
              var leases = raw ? parseInt( raw, 10 ) : 0;

              $this.val( ( leases === 0 ) ? "" : leases.toLocaleString("en-US") );

              if ( leases === 0 ) {
                lpc_show_state('empty');
                $enquiry.prop( 'hidden', true );
                return;
              }

              if ( leases > maxLeases ) {
                lpc_show_state('enquire');
                $enquiry.prop( 'hidden', false );
                lpc_pass_to_pardot( leases );
                return;
              }

              var tier = lpc_match_tier( leases );

              if ( ! tier ) {
                lpc_show_state('empty');
                $enquiry.prop( 'hidden', true );
                return;
              }

              $section.find('.lpc-price-value').text( lpc_format_price( tier.price ) );
              lpc_show_state('price');
              $enquiry.prop( 'hidden', true );
            });

            // Nothing to submit - the result updates as the visitor types.
            $section.find('.lpc-form').on( 'submit', function( e ) {
              e.preventDefault();
            });
          });
        },
        rollover_section: function() {

          function isScrolledIntoView($elem) {
            var returnvalue = false;
            if ( $elem.length > 0 ) {
              var docViewTop = $(window).scrollTop();
              var docViewBottom = docViewTop + mriViewportHeight();
              var elemTop = $elem.offset().top;
              returnvalue = ((elemTop <= docViewBottom - 20) && (elemTop >= docViewTop + 20));
            }
            return returnvalue;
          }

          $('.mri-rollover .rl-panel').matchHeight( {byRow: false } );

          $(document).on('click', '.mri-rollover.click ul.rl-tabs li', function(e) {
            e.preventDefault();
            var tab_id = $(this).attr('data-tab');

            $(this).closest('.rl-tabs').find('li').removeClass('current');
            $(this).closest('.mri-rollover').find('.rl-panel').removeClass('current');

            $(this).addClass('current');
            $("#" + tab_id).addClass('current');
          });

          $(document).on('mouseover', '.mri-rollover.mouseover ul.rl-tabs li', function(e) {
            e.preventDefault();
            if( ! $('body').hasClass('touch-device') ) {
              var tab_id = $(this).attr('data-tab');

              $(this).closest('.rl-tabs').find('li').removeClass('current');
              $(this).closest('.mri-rollover').find('.rl-panel').removeClass('current');

              $(this).addClass('current');
              $("#" + tab_id).addClass('current');
            }
          });

          $(document).on('click', '.mri-rollover .rl-panel-title', function(e) {
            e.preventDefault();
            if( window.innerWidth < 768 ) {
              var tab_id = $(this).attr('data-tab');
              $(this).closest('.mri-rollover').find('.rl-tabs').find('li').removeClass('current');
              $(this).closest('.mri-rollover').find('.rl-panel').removeClass('current');
              $(this).closest('.mri-rollover').find('.rl-tabs').find('li[data-tab="'+tab_id+'"]').addClass('current');
              $("#" + tab_id).addClass('current');
              $('body,html').animate({
                scrollTop: $(this).offset().top - 70
              }, 300);
            }
          });

        },
        faq_accordion: function() {
          $(document).on('click','.mri-accordion-content .accordion-header', function(e){
            e.preventDefault();
            $(this).closest('.mri-accordion-box').toggleClass('accordion-open');
            $(this).closest('.mri-accordion-box').find('.accordion-content').slideToggle(200);
            // Headers rendered as buttons (the event agenda) announce their state.
            if ( this.hasAttribute('aria-expanded') ) {
              $(this).attr('aria-expanded', $(this).closest('.mri-accordion-box').hasClass('accordion-open') ? 'true' : 'false');
            }
          });

        },
        epc_generator_form: function() {
          if ( $('.mri-epc-filters').length > 0 ) {
            $('.mri-epc-filters .select').each(function(){
              var select_item = $(this);
              select_item.select2({minimumResultsForSearch: Infinity});
              for( var i = 0; i<=100; i++ ) {
                select_item.append( $('<option>', { value: i, text: i } ) );
              }
              select_item.val( select_item.attr('data-selected') );
            });

            var form = $('.mri-epc-filters').find('form');

            function mri_epc_change_graph() {
              var url = form.attr('action'),
                  epc_eec = form.find('.select[name=mri_epc_ee_current]').val(),
                  epc_eep = form.find('.select[name=mri_epc_ee_potential]').val(),
                  epc_eic = form.find('.select[name=mri_epc_ei_current]').val(),
                  epc_eip = form.find('.select[name=mri_epc_ei_potential]').val();
              url = url + '?mri_epc_ee_current=' + epc_eec + '&mri_epc_ee_potential=' + epc_eep + '&mri_epc_ei_current=' + epc_eic + '&mri_epc_ei_potential=' + epc_eip;

              $('.mri-epc-generator').find('.epc-blank-screen').hide();
              $('.mri-epc-generator').find('.epc-loader').show();

              $('.form-actions-row > .has-error').empty();

              form.closest('section').find('.graph-message-box').empty();
              $('section.mri-epc-generator .mri-epc-filters').addClass('disabled');
              $('section.mri-epc-generator .mri-epc-graph').load(url + ' section.mri-epc-generator .mri-epc-graph > span', function(){
                // console.warn('select-change');
                $('section.mri-epc-generator .mri-epc-filters').removeClass('disabled');
              });
            }

            $(document).on('change', '.mri-epc-filters .select', function() {
              if ( ! $(this).closest('.mri-epc-filters').hasClass('disabled') ) {
                mri_epc_change_graph();
              }
            });

            function isValidEmailAddress(emailAddress) {
              var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
              return pattern.test(emailAddress);
            }
            $.validator.addMethod("supervalidemail", function(value, element) {
            // allow any non-whitespace characters as the host part
                return isValidEmailAddress( value );
            }, 'Please enter a valid email address.');

            $.validator.addMethod("validateSelect", function(value, element) {
            // allow any non-whitespace characters as the host part
                return $('.epc-blank-screen').length > 0 ? false : true;
            }, 'Please change the values to generate a new EPC graph');

            $.validator.addMethod("noSpace", function(value, element) {
              return value === '' || value.trim().length !== 0;
            }, "No space please and don't leave it empty");

            $(document).on('submit','.mri-epc-filters form', function(e){
              e.preventDefault();
            });

            var EPCFormValidation = function() {
              var instance = this;
              instance.settings = {
                // onkeyup: true,
                errorClass : 'has-error', 
                errorPlacement: function(error, element) {
                  error.appendTo(element.closest('.form-actions-row').find('.error-wrap'));
                },
                highlight: function(element, errorClass, validClass) {
                  $(element).closest('.form-actions-row').find('.error-wrap').addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function(element, errorClass, validClass) {
                  $(element).closest('.form-actions-row').find('.error-wrap').removeClass(errorClass).addClass(validClass);
                  $(element).closest('section').find('.graph-message-box').empty();
                },
                focusInvalid: false,
                invalidHandler: function(form, validator) {
                  if (!validator.numberOfInvalids()) {
                    return;
                  }
                  $(validator.errorList[0].element).focus();
                },
                submitHandler: function( form ) {
                  var $theform = $(form);
                  $theform.find('button[type="submit"]').button('loading');

                  var url = $theform.attr('action'),
                    epc_eec = $theform.find('.select[name=mri_epc_ee_current]').val(),
                    epc_eep = $theform.find('.select[name=mri_epc_ee_potential]').val(),
                    epc_eic = $theform.find('.select[name=mri_epc_ei_current]').val(),
                    epc_eip = $theform.find('.select[name=mri_epc_ei_potential]').val(),
                    email   = $theform.find('input[name=mri_epc_email_to]').val();
                  url = url + '?mri_epc_ee_current=' + epc_eec + '&mri_epc_ee_potential=' + epc_eep + '&mri_epc_ei_current=' + epc_eic + '&mri_epc_ei_potential=' + epc_eip + '&mri_epc_email_to=' + email;

                  $('.mri-epc-generator').find('.epc-blank-screen').hide();
                  $('.mri-epc-generator').find('.epc-loader').show();

                  $('.form-actions-row > .has-error').remove();
                  $theform.find('.graph-message-box').empty();

                  $('section.mri-epc-generator .epc-loader-section').load(url + ' section.mri-epc-generator .mri-epc-graph > span, section.mri-epc-generator .graph-message-box', function(){
                    var loader_section = $('section.mri-epc-generator .epc-loader-section');
                    $('section.mri-epc-generator').find('.mri-epc-graph').empty();
                    loader_section.find('> span').appendTo('section.mri-epc-generator .mri-epc-graph');
                    $('section.mri-epc-generator').find('.mri-epc-filters .graph-message-box').empty();
                    loader_section.find('.graph-message-box > div').appendTo('section.mri-epc-generator .graph-message-box');
                    $theform.find('button[type="submit"]').button('reset');

                    if ( $(document).find('section.mri-epc-generator .alert-success').length > 0 ) {
                      $theform.find('input[name=mri_epc_email_to]').val('');
                    }
                  });                

                  return false;
                },
                rules: {
                  'mri_epc_ee_current'    : {
                    validateSelect: true
                  },
                  'mri_epc_ee_potential'  : {
                    validateSelect: true
                  },
                  'mri_epc_ei_current'    : {
                    validateSelect: true
                  },
                  'mri_epc_ei_potential'  : {
                    validateSelect: true
                  },
                  'mri_epc_email_to'      : {
                    required: true,
                    email: true,
                    noSpace: true,
                    supervalidemail: true
                  },
                },
                messages: {
                  'mri_epc_ee_current'    : {
                    validateSelect: 'Please change the values to generate a new EPC graph'
                  },
                  'mri_epc_ee_potential'  : {
                    validateSelect: 'Please change the values to generate a new EPC graph'
                  },
                  'mri_epc_ei_current'    : {
                    validateSelect: 'Please change the values to generate a new EPC graph'
                  },
                  'mri_epc_ei_potential'  : {
                    validateSelect: 'Please change the values to generate a new EPC graph'
                  },
                  'mri_epc_email_to'      : {
                    required: "This field is required.",
                    email: "Invalid e-mail address.",
                    supervalidemail: "Invalid e-mail address.",
                    noSpace: "This field is required."
                  },   
                }
              };
              instance.init = function() {
                var epc_form = $(".mri-epc-filters form");
                if (epc_form.length === 1) {
                  epc_form.find('button[type="submit"]').button('reset');
                  epc_form.validate(instance.settings);
                }
              };
              instance.init();
            }
            var epc_form_validation = new EPCFormValidation;
          }
          

        },
        lets_connect_form: function() {
          // Any overlap with the viewport counts, unlike the other gates in this
          // file which require the element's top to land inside a narrow band.
          // This one drives a one-shot init, so scrolling quickly past the form
          // must still trigger it rather than skip over the band entirely.
          function isScrolledIntoView($elem) {
            if ( ! $elem || $elem.length === 0 ) {
              return false;
            }
            var rect = $elem[0].getBoundingClientRect();
            return ( rect.top <= mriViewportHeight() - 20 ) && ( rect.bottom >= 20 );
          }

          var country_select_init = false;

          if ( $('.lets-connect-form').length > 0 ) {
            $(document).find('#lcf_telephone').on('keyup',function(){
              var input = $(this);
              var val = input.val();
              input.val( val.replace(/[^\d.+-]/g, '') );
            });

            var utm_query_string = window.location.search;
            if ( utm_query_string ) {
              try {
                var utm_url_params  = new URLSearchParams(utm_query_string);
                var utm_source      = utm_url_params.get('utm_source');
                utm_source = utm_source ? utm_source : utm_url_params.get('lcf_utm_source');

                var utm_medium      = utm_url_params.get('utm_medium');
                utm_medium = utm_medium ? utm_medium : utm_url_params.get('lcf_utm_medium');

                var utm_campaign    = utm_url_params.get('utm_campaign');
                utm_campaign = utm_campaign ? utm_campaign : utm_url_params.get('lcf_utm_campaign');

                var utm_term        = utm_url_params.get('utm_term');
                utm_term  = utm_term ? utm_term : utm_url_params.get('lcf_utm_term');

                var utm_content     = utm_url_params.get('utm_content');
                utm_content  = utm_content ? utm_content : utm_url_params.get('lcf_utm_content');

                if ( utm_source ) {
                  $('input[name=lcf_utm_source]').val(utm_source);
                }

                if ( utm_medium ) {
                  $('input[name=lcf_utm_medium]').val(utm_medium);
                }

                if ( utm_term ) {
                  $('input[name=lcf_utm_term]').val(utm_term);
                }

                if ( utm_content ) {
                  $('input[name=lcf_utm_content]').val(utm_content);
                }

                if ( utm_campaign ) {
                  $('input[name=lcf_utm_campaign]').val(utm_campaign);
                  $('input[name=lcf_utm_campign]').val(utm_campaign);
                }
              } catch(err) {
                console.warn(err);
              }
            }

            function init_countries() {
              $(".lets-connect-form select option:empty").remove();

              $('.lcf_select2').select2({minimumResultsForSearch: -1});

              var countries = $.fn.countrySelect.getCountryData();

              var county_select = $('.lcf_country').select2({minimumResultsForSearch: -1});

              var blog_id = $('#lcf_country').attr('data-bid');

              var current_country = 'us';
              switch( blog_id ) {
                case '1':
                  current_country = 'us';
                  break;
                case '2':
                  current_country = 'gb';
                  break;
                case '3':
                  current_country = 'ca';
                  break;
                case '4':
                  current_country = 'au';
                  break;
                case '5':
                  current_country = 'nz';
                  break;
                case '6':
                  current_country = 'sg';
                  break;
                case '7':
                  current_country = 'hk';
                  break;
                case '8':
                  current_country = 'ae';
                  break;
                case '9':
                  current_country = 'za';
                  break;
                case '10':
                  current_country = 'ie';
                  break;
                default:
                  current_country = 'us';
              }

              $(countries).each(function(i,v){
                var c_name = v.name; 
                c_name = c_name.replace(/\(.*\)/g,'').trim();
                
                county_select.append( $('<option>', {value: c_name, text: c_name} ) );
                if ( v.iso2 === current_country ) {
                  var __name = v.name;
                  if ( current_country === 'ae' ) {
                    __name = 'United Arab Emirates';
                  }
                  county_select.val( __name );
                }
              });

              country_select_init = true;
            }

            if ( isScrolledIntoView( $("#lcf_country") ) && ! country_select_init ) {
              init_countries();
            }

            $(window).scroll(function() {
              if ( isScrolledIntoView( $("#lcf_country") ) && ! country_select_init ) {
                init_countries();
              }
            });

            var lcf_first_name_em = ! $('body').is('.wp-child-theme-mri-moove-arabic.mri-fe-arabic-theme') ? 'Please enter your first name' : 'الرجاء إدخال الاسم الأول';

            var lcf_last_name_em = ! $('body').is('.wp-child-theme-mri-moove-arabic.mri-fe-arabic-theme') ? 'Please enter your last name' : 'الرجاء إدخال اسم العائلة';

            var lcf_lcf_company_em = ! $('body').is('.wp-child-theme-mri-moove-arabic.mri-fe-arabic-theme') ? 'Please enter your company' : 'الرجاء إدخال اسم الشركة';

            var lcf_lcf_email_em = ! $('body').is('.wp-child-theme-mri-moove-arabic.mri-fe-arabic-theme') ? 'Please enter your email' : 'الرجاء إدخال البريد الإلكتروني';

            var lcf_lcf_email_em2 = ! $('body').is('.wp-child-theme-mri-moove-arabic.mri-fe-arabic-theme') ? 'Please enter valid email address' : 'الرجاء إدخال البريد الإلكتروني';

            var lcf_postcode_em = ! $('body').is('.wp-child-theme-mri-moove-arabic.mri-fe-arabic-theme') ? 'Please enter your postcode' : 'الرجاء إدخال الرمز البريدي';

            var lcf_required_em = ! $('body').is('.wp-child-theme-mri-moove-arabic.mri-fe-arabic-theme') ? 'This field is required' : 'هذا الحقل مطلوب';
            var lcf_select_em = ! $('body').is('.wp-child-theme-mri-moove-arabic.mri-fe-arabic-theme') ? 'Please select' : 'هذا الحقل مطلوب';

            var form_validator = $('#lets-connect .mri-pardot-form').validate({
              onkeyup: false,
              errorClass : 'has-error', 
              rules: {
                'lcf_first_name' : 'required',
                'lcf_last_name'  : 'required',
                'lcf_company'  : 'required',
                'lcf_email'      : {
                    required: true,
                    email: true
                },
                'lcf_postcode'   : 'required',
                'lcf_properies_managed'    : 'required',
                'lcf_buildings_amount'    : 'required',
                'lcf_team_members'    : 'required',
                'lcf_metro_interested_in'    : 'required',
                'lcf_job_category'    : 'required',
                'lcf_apartment_data_role' : 'required',
                'lcf_requirements'    : 'required',
                'mic_verify': 'required',
              },
              messages: {
                'lcf_first_name'  : lcf_first_name_em,
                'lcf_last_name'   : lcf_last_name_em,
                'lcf_company'     : lcf_lcf_company_em,
                'lcf_email'       : {
                    required  : lcf_lcf_email_em,
                    email     : lcf_lcf_email_em2
                },
                'lcf_postcode'    : lcf_postcode_em,
                'lcf_properies_managed'    : lcf_required_em,
                'lcf_buildings_amount'    : lcf_required_em,
                'lcf_team_members'    : lcf_required_em,
                'lcf_metro_interested_in'    : lcf_select_em,
                'lcf_job_category'    : lcf_select_em,
                'lcf_apartment_data_role'    : lcf_select_em,
                'lcf_requirements'    : lcf_required_em,
                'mic_verify'    : lcf_required_em,
              },
              errorPlacement: function(error, element) {
                error.appendTo(element.closest('.form-group'));
                $('#mic-verify').slideDown(300);
              },
              highlight: function(element, errorClass, validClass) {
                $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
                $('#mic-verify').slideDown(300);
              },
              unhighlight: function(element, errorClass, validClass) {
                $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
              },
              submitHandler: function(e) {
                var formdata  = $('#lets-connect .mri-pardot-form').serialize();
                var button = $('#lets-connect button[type="submit"]');              
                button.button('loading');
                $.post(
                  mri_moove_scripts.ajaxurl,
                  {
                      action: "send_pardot_connect_form",
                      formdata: formdata,
                  },
                  function(data) {
                    data = JSON.parse( data );
                    
                    if( data.success === true ) {
                      console.log('Request sent to pardot!');
                      if ( typeof data.redirect !== undefined && data.redirect ) {
                        window.location.href = data.redirect;
                      }
                    } else {
                      console.log('Failed to send Pardot data. Err:'+ data.response);
                      button.button('reset');

                      if ( data.response === 'Check the captcha field' ) {
                        // The captcha only slides in once the email is typed, so a form
                        // completed by autofill can reach here with it still hidden.
                        $('#mic-verify').slideDown(300);
                        $('#mic_verify').val('');
                        if ( $('#mic_verify-error').length > 0 ) {
                          $('#mic_verify-error').text('Captcha verification failed, try again!').show();
                        } else {
                          $('#mic-verify').closest('.form-group').find('#mic_verify-error').remove();
                          $('#mic-verify').closest('.form-group').append('<label id="mic_verify-error" class="has-error" for="mic_verify">Captcha verification failed, try again!</label>')
                        }
                        
                      }
                    }

                  }
                );

                return false;

              }
            });
          }

          $(document).on('click','a[href*="#request_demo"]',function(e){
            if ( $('#lets-connect').length > 0 ) {
              e.preventDefault();
              $('#lcf_request_type_info').prop('checked',false);
              $('#lcf_request_type_demo').prop('checked',true);

              $('body,html').animate({
                scrollTop: $('#lcf_contact_form_wrap').offset().top - 100
              }, 300);
            }
          });

          $(document).on('click','a[href*="#request_info"], a[href*="#request_information"]',function(e){
            if ( $('#lets-connect').length > 0 ) {
              e.preventDefault();
              $('#lcf_request_type_info').prop('checked',true);
              $('#lcf_request_type_demo').prop('checked',false);

              $('body,html').animate({
                scrollTop: $('#lcf_contact_form_wrap').offset().top - 100
              }, 300);
            }
          });

          if ( $('.lets-connect-form-ms').length > 0 ) {
            var $msForms = $('.lets-connect-form-ms .mri-pardot-form');
            $msForms.each(function() {
              var $form = $(this);
              $form.find('.ms-prev-step').on('click', function() {
                $form.find('.ms-step-2').hide();
                $form.find('.ms-step-1').show();
                $form.closest('.ms-form-wrap').find('.ms-progress-segment').eq(1).removeClass('ms-active');
              });

              $form.find('.ms-next-step').on('click', function() {
                var $step1 = $form.find('.ms-step-1');
                var valid = true;
                $step1.find('input[required], textarea[required], select[required]').each(function() {
                  var $field = $(this).closest('.form-field');
                  var val = $(this).val();
                  if (!val || !String(val).trim()) {
                    if ($field.length) { $field.addClass('has-error'); }
                    valid = false;
                  } else {
                    if ($field.length) { $field.removeClass('has-error'); }
                  }
                });
                if (!valid) { return; }
                $step1.hide();
                var $step2 = $form.find('.ms-step-2');
                $step2.show();
                $form.closest('.ms-form-wrap').find('.ms-progress-segment').addClass('ms-active');
                $step2.find('select').each(function() {
                  if (!$(this).hasClass('select2-hidden-accessible')) {
                    $(this).select2({
                      minimumResultsForSearch: -1,
                      placeholder: '',
                      allowClear: false,
                    });
                  }
                });
              });
            });
          }
        },
        story_progress_bar: function() {
          if ( $('body').hasClass('page-template-template-story') ) {
            jQuery.extend(jQuery.easing, {
              easeInOutCubic: function (x, t, b, c, d) {
                if ((t/=d/2) < 1) {
                  return c/2*t*t*t + b;
                }
                return c/2*((t-=2)*t*t + 2) + b;
              }
            });

            var container = $('.progressbar');
            var shim = $('.progressbar .shim');
            var holder = $('.progressbar .holder');
            var bar = $('.progressbar .bar');
            var indicator = $('.progressbar .indicator');
            var labels = $('.progressbar .labels');
            $(document).find('.section-reading-title').each(function(){
              var code = '<i data-label="'+$(this).text()+'">'+$(this).html()+'</i>';
              labels.append(code);
            });

            var points = labels.find('i');

            points.css('width', 100/$('.section-reading-title').length+'%');

            if ( points.length > 0 ) {

              // match height of shim
              // stop layout jumping when progress bar fixes to / unfixes
              // from top of viewport
              function setShimHeight(){
                shim.css('height', container.height()+'px');
              }
              setShimHeight();
              $(window).resize(function(){ setShimHeight(); });

              // position indicator bar so it starts at first dot
              function setIndicatorX(){
                var point = points.eq(0);
                var xpos = point.offset().left + (point.width() / 2);
                indicator.css('left', xpos+'px');
              }
              setIndicatorX();

              // set trigger point
              // i.e. how far down viewport is the "eye line"
              var triggerPoint = 0;
              function setTriggerPoint(){
                triggerPoint = mriViewportHeight() * 0.28;
              }
              setTriggerPoint();
              $(window).resize(function(){ setTriggerPoint(); });

              // update progress bar
              function setPosition(){
                if ( $('#main-header').hasClass('header-affix') ) {
                  $('.mri-sticky-reading-bar').show();
                } else {
                  $('.mri-sticky-reading-bar').hide();
                }
                if(container.is(':visible')) {
                  setIndicatorX();
                  var section = false;
                  var sectionIndex = 0;
                  var currentPosition = $(window).scrollTop() + triggerPoint;

                  // dots
                  // if before first section
                  if(currentPosition < $('span.section-reading-title').eq(0).offset().top) {
                    points.removeClass('reading read');
                    section = -1;
                  }
                  // if after first section
                  else {
                    $('span.section-reading-title').each(function(){
                      var sectionTop = $(this).offset().top;
                      if(currentPosition >= sectionTop) {
                        points.removeClass('reading');
                        points.eq(sectionIndex).addClass('reading');
                        points.eq(sectionIndex).addClass('read');
                        section = sectionIndex;
                      }
                      else {
                        points.eq(sectionIndex).removeClass('read');
                      }
                      sectionIndex++;
                    });
                  }
                  // bar
                  var barWidth = 0;
                  // if before start
                  if(section == -1) {
                    var point = points.eq(0);
                    barWidth = point.offset().left + (point.width() / 2);
                  }
                  // if after end
                  else if(section >= (points.length - 1)) {
                    var point = points.eq((points.length - 1));
                    barWidth = point.offset().left + (point.width() / 2);
                  }
                  // if within document
                  else {
                    currentPosition = currentPosition;
                    var startPoint = points.eq(section);
                    var startPointX = startPoint.offset().left;
                    var startPointWidth = startPoint.width();
                    var startSection = $('span.section-reading-title').eq(section);
                    var endSection = $('span.section-reading-title').eq(section+1);
                    var startSectionY = startSection.offset().top;
                    var endSectionY = endSection.offset().top;
                    var sectionLength = endSectionY - startSectionY;
                    var scrollY = currentPosition - startSectionY;
                    var sectionProgress = scrollY / sectionLength;
                    barWidth = startPointX + (startPointWidth / 2) + (startPointWidth * sectionProgress);
                  }
                  barWidth -= indicator.offset().left;
                  indicator.css('width', barWidth+'px');
                }
              }
              setPosition();
              $(window).scroll(function(){ setPosition(); });
              $(window).resize(function(){ setPosition(); });

              // on click, scroll to target section
              points.click(function(){
                var sectionIndex = points.index($(this));
                var targetY = $('span.section-reading-title').eq(sectionIndex).offset().top - (triggerPoint * 0.92);
                $('html, body').animate({scrollTop:targetY}, 600, 'easeInOutCubic');
              });
            }
          }
        },
        journey_steps: function() {
          var $section = $('.section.journey_steps');
          if (!$section.length) return;

          var $steps = $section.find('.journey-step-step');
          if (!$steps.length) return;

          function update() {
            var viewportCenter = $(window).scrollTop() + mriViewportHeight() / 2;
            var closest = null;
            var minDist = Infinity;

            $steps.each(function() {
              var $step = $(this);
              var stepCenter = $step.offset().top + $step.outerHeight() / 2;
              var dist = Math.abs(stepCenter - viewportCenter);
              if (dist < minDist) {
                minDist = dist;
                closest = $step;
              }
            });

            if (closest) {
              $steps.removeClass('is-active');
              $(closest).addClass('is-active');
            }
          }

          $(window).on('scroll.journey_steps', update);
          update();
        },
        shs_ajax_module: function() {
          function shs_search_for_duplicates() {
            var shs_duplicates = {};
            $(document).find('.shs-item').each(function(){
              var contents = {};
              
              var title = $(this).find('.article-title').text();
              if (contents[title]) {
                shs_duplicates[title] = title;
              }
              contents[title] = true;
            });
            // console.warn(shs_duplicates);
          }
          $(document).find('section.social-housing-slider').each(function(){
            var section = $(this);
            var args = $.trim( section.find('.shs-args').text() );
            if ( args ) {
              $.post(
                mri_moove_scripts.ajaxurl,
                {
                  action: "mri_shs_get_content",
                  args: args
                },
                function( msg ) {
                  var obj = JSON.parse(msg);
                  if ( obj.success && obj.data ) {
                    section.find('.shs-slider-wrap').empty().html(obj.data);
                    section.find('.shs-slider-wrap');

                    section.find('.owl-carousel').owlCarousel({
                      center: false,
                      items: 4,
                      stagePadding: 0,
                      loop: false,
                      nav: true,
                      navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
                      dots: false,
                      margin: 0,
                      drag: true,
                      autoHeight: false,
                      onInitialized: function(){
                        section.find('.shs-item').matchHeight();
                        $('.mri-article-card').matchHeight();
                      },
                      responsive : {
                        0 : {
                          items: 1,
                          stagePadding: 40,
                          nav: false,
                        },
                        768 : {
                          items: 3,
                          stagePadding: 0,
                          nav: true,
                        },
                        1200 : {
                          items: 4,
                          stagePadding: 0,
                          nav: true,
                        }
                      },
                      startPosition: 0
                    });


                  } else {
                    section.slideUp(200);
                  }
                  shs_search_for_duplicates();
                }
              );
            } else {
              section.slideUp(200);
              shs_search_for_duplicates();
            }
          });
        },
        insta_slider: function(){
          $('.mri-instagram-grid').each(function() {
            var slider = $(this).find('.insta-slider-wrap');
            slider.owlCarousel({
              center: false,
              items: 4,
              loop: true,
              nav: false,
              navText: ['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>'],
              navContainer: '.mri-instagram-grid .owl-nav-container',
              dots: false,
              margin: 0,
              responsive : {
                0 : {
                  items: 2,
                  stagePadding: 40,
                  nav: false,
                },
                768 : {
                  items: 3,
                  stagePadding: 60,
                  nav: true,
                },
                1200 : {
                  items: 4,
                  stagePadding: 0,
                  nav: true,
                }
              }
            });
          });
        },
        contact_support_filter:function() {
          if ( $('.contact-support-filters').length > 0 ) {
            // filter items on button click

            $(document).on( 'change', '.contact-support-filters .select--filter', function(e) {
              e.preventDefault();
              var filter_wrap = $(this).closest('.contact-support-filters');
              var permalink   = $(this).closest('.contact-support-filters').attr('data-permalink');
              $('.contact-section-card-wrap').show();
              if ( permalink ) {
                var location_f = filter_wrap.find('.select--filter-location').val();
                var product_f = filter_wrap.find('.select--filter-product').val();
                if ( location_f !== 'all' ) {
                  permalink = permalink + 'region/' + location_f + '/';
                  $('.location-table-row').each(function(){
                    if ( ! $(this).hasClass(location_f) ) {
                      $(this).hide();
                    } else {
                      $(this).show();
                    }
                  });                
                } else {
                  $('.location-table-row').show();
                }

                if ( product_f !== 'all' ) {
                  permalink = permalink + 'product/' + product_f + '/';

                  $('.contact-section-card-wrap').each(function(){
                    if ( ! $(this).hasClass(product_f) ) {
                      $(this).hide();
                    } else {
                      $(this).show();
                    }
                  });
                } else {
                  $('.contact-section-card-wrap').show();
                }

                $('.contact-section-card-wrap').each(function() {
                  var section = $(this);
                  // console.warn(section.find('.location-table-row:visible'));
                  if ( section.find('.location-table-row:visible').length > 0 ) {
                    section.show();
                  } else {
                    section.hide();
                  }
                });

                if ( $('.contact-section-card-wrap:visible').length < 1 ) {
                  $('.contact-section-card-wrap.not-found').show();
                } else {
                  $('.contact-section-card-wrap.not-found').hide();
                }

                window.history.pushState( false, false, permalink );
              }
            });

            var has_filters = false;
            $(document).find('.contact-support-filters .select--filter').each(function(){
              if ( $(this).val() !== 'all' ) {
                has_filters = true;
              }
            });


            if ( has_filters ) {
              var filter_wrap = $(document).find('.contact-support-filters');
              var permalink   = $(document).find('.contact-support-filters').attr('data-permalink');
              $('.contact-section-card-wrap').show();
              if ( permalink ) {
                var location_f = filter_wrap.find('.select--filter-location').val();
                var product_f = filter_wrap.find('.select--filter-product').val();
                if ( location_f !== 'all' ) {
                  permalink = permalink + 'region/' + location_f + '/';
                  $('.location-table-row').each(function(){
                    if ( ! $(this).hasClass(location_f) ) {
                      $(this).hide();
                    } else {
                      $(this).show();
                    }
                  });                
                } else {
                  $('.location-table-row').show();
                }

                if ( product_f !== 'all' ) {
                  permalink = permalink + 'product/' + product_f + '/';

                  $('.contact-section-card-wrap').each(function(){
                    if ( ! $(this).hasClass(product_f) ) {
                      $(this).hide();
                    } else {
                      $(this).show();
                    }
                  });
                } else {
                  $('.contact-section-card-wrap').show();
                }

                $('.contact-section-card-wrap').each(function() {
                  var section = $(this);
                  // console.warn(section.find('.location-table-row:visible'));
                  if ( section.find('.location-table-row:visible').length > 0 ) {
                    section.show();
                  } else {
                    section.hide();
                  }
                });

                if ( $('.contact-section-card-wrap:visible').length < 1 ) {
                  $('.contact-section-card-wrap.not-found').show();
                } else {
                  $('.contact-section-card-wrap.not-found').hide();
                }
              }
            }

            $('.contact-section-cards-block').addClass('loaded');
          }
        },
        finalize: function() {
          // JavaScript to be fired on all pages, after page specific JS is fired
        }
      },
      // Home page
      'home': {
        init: function() {
          // JavaScript to be fired on the home page
        },
        finalize: function() {
          // JavaScript to be fired on the home page, after the init JS
        }
      },
      // About us page, note the change from about-us to about_us.
      'about_us': {
        init: function() {
          // JavaScript to be fired on the about us page
        }
      }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
      fire: function(func, funcname, args) {
        var fire;
        var namespace = Sage;
        funcname = (funcname === undefined) ? 'init' : funcname;
        fire = func !== '';
        fire = fire && namespace[func];
        fire = fire && typeof namespace[func][funcname] === 'function';

        if (fire) {
          namespace[func][funcname](args);
        }
      },
      loadEvents: function() {
        // Fire common init JS
        UTIL.fire('common');

        // Fire page-specific init JS, and then finalize JS
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, 'finalize');
        });

        // Fire common finalize JS
        UTIL.fire('common', 'finalize');
      }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js